(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./context"));
	else if(typeof define === 'function' && define.amd)
		define(["./context"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./context")) : factory(root["./context"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 57);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon-toolkit");

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(17);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 17 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PanelMessage; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PanelMessage_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22);
/* harmony import */ var _PanelMessage_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PanelMessage_scss__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2016, 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




class PanelMessage extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  render() {
    const {
      children,
      topOffset,
      contentGutter
    } = this.props;
    const style = topOffset ? {
      top: `${topOffset}px`,
      overflow: 'auto'
    } : {};
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__["Container"], {
      className: "bi-common-panelMessage",
      style: style
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__["Container"], {
      className: "bi-common-panelMessage__inner"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_2__["Container"], {
      className: "bi-common-panelMessage__contents",
      gutter: contentGutter
    }, children)));
  }

}

_defineProperty(PanelMessage, "propTypes", {
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  topOffset: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  contentGutter: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.array])
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(23);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-panelMessage{position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden;pointer-events:none;white-space:normal}.bi-common-panelMessage__inner{position:absolute;top:50%;left:0;width:100%;transform:translateY(-50%);text-align:center}[dir=\"rtl\"] .bi-common-panelMessage__inner{left:auto;right:0}.bi-common-panelMessage__contents{pointer-events:all;display:inline-block}\n", ""]);

// exports


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var node_polyglot__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25);
/* harmony import */ var node_polyglot__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(node_polyglot__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26);
/* harmony import */ var amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1__);
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-common
* (C) Copyright IBM Corp. 2019, 2020
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

 // eslint-disable-line

const StringResource = function (resources) {
  const allResources = Object.assign({}, amdi18n_loader_DefaultResources__WEBPACK_IMPORTED_MODULE_1___default.a, resources);
  this._polyglot = new node_polyglot__WEBPACK_IMPORTED_MODULE_0___default.a({
    phrases: allResources
  });
};
/**
 * Get the string resource for the given key and interpolation options
 *
 * @param key The  key of the string to return
 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
 * @returns The string to display
 */


StringResource.prototype.get = function (key, interpolationOptions) {
  let translated = this._polyglot.t(key, interpolationOptions);

  if (this._polyglot.phrases[key] === undefined) {
    translated = `__NOT_TRANSLATED__(${key})`;
  }

  return translated;
};

/* harmony default export */ __webpack_exports__["default"] = (StringResource);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = require("node-polyglot");

/***/ }),
/* 26 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"from":"From","greaterThan":"Greater than","lessThan":"Less than","ok":"OK","reactError":"This view cannot be rendered now. Please try again later.","reactErrorHeader":"Failed to render UI","reactErrorTrace":"Stack trace","reactErrorDetails":"View details","to":"To","tryAgain":"Try again"},"__cs":{"from":"Od","greaterThan":"Větší než","lessThan":"Menší než","ok":"OK","reactError":"Toto zobrazení nyní nelze vykreslit. Opakujte operaci později.","reactErrorHeader":"Vykreslení uživatelského rozhraní se nezdařilo","reactErrorTrace":"Trasování zásobníku","reactErrorDetails":"Zobrazit podrobnosti","to":"Do","tryAgain":"Zkusit znovu"},"__da":{"from":"Fra","greaterThan":"Større end","lessThan":"Mindre end","ok":"OK","reactError":"Denne oversigt kan ikke gengives nu. Prøv igen senere.","reactErrorHeader":"UI kunne ikke gengives","reactErrorTrace":"Staksporing","reactErrorDetails":"Vis detaljer","to":"Til","tryAgain":"Forsøg igen"},"__de":{"from":"Von","greaterThan":"Größer als","lessThan":"Kleiner als","ok":"OK","reactError":"Diese Ansicht kann momentan nicht dargestellt werden. Wiederholen Sie die Aktion zu einem späteren Zeitpunkt.","reactErrorHeader":"Die Darstellung der Benutzerschnittstelle ist fehlgeschlagen","reactErrorTrace":"Stack-Trace","reactErrorDetails":"Details anzeigen","to":"Bis","tryAgain":"Wiederholen"},"__es":{"from":"Desde","greaterThan":"Mayor que","lessThan":"Menor que","ok":"Aceptar","reactError":"Esta vista no se puede mostrar en este momento. Vuelva a intentarlo más tarde.","reactErrorHeader":"No se ha podido representar la IU","reactErrorTrace":"Seguimiento de pila","reactErrorDetails":"Ver detalles","to":"Para","tryAgain":"Vuelva a intentarlo"},"__fi":{"from":"Alkaa","greaterThan":"Suurempi kuin","lessThan":"Pienempi kuin","ok":"OK","reactError":"Tämän näkymän hahmonnus ei onnistu nyt. Yritä myöhemmin uudelleen.","reactErrorHeader":"Käyttöliittymän hahmonnus epäonnistui","reactErrorTrace":"Pinojäljitys","reactErrorDetails":"Näytä tiedot","to":"Päättyy","tryAgain":"Yritä uudelleen"},"__fr":{"from":"De","greaterThan":"Supérieur à","lessThan":"Inférieur à","ok":"OK","reactError":"Cette vue ne peut pas être rendue maintenant. Veuillez réessayer ultérieurement.","reactErrorHeader":"Echec du rendu de l'interface utilisateur","reactErrorTrace":"Trace de pile","reactErrorDetails":"Afficher les détails","to":"A","tryAgain":"Réessayer"},"__hr":{"from":"Od","greaterThan":"Veće od","lessThan":"Manje od","ok":"OK","reactError":"Ovaj pogled se sad ne može prikazati. Molim, pokušajte ponovno kasnije.","reactErrorHeader":"Prikaz korisničkog sučelja nije uspio","reactErrorTrace":"Praćenje stoga","reactErrorDetails":"Pregled detalja","to":"Do","tryAgain":"Pokušaj ponovno"},"__hu":{"from":"Kezdet","greaterThan":"nagyobb mint","lessThan":"Kisebb, mint","ok":"OK","reactError":"Ezt a nézetet most nem lehet megjeleníteni. Próbálkozzon ismét később.","reactErrorHeader":"A felhasználói felület előállítása nem sikerült","reactErrorTrace":"Veremnyomkövetés","reactErrorDetails":"Részletek megjelenítése","to":"Eddig","tryAgain":"Ismételt próbálkozás"},"__it":{"from":"Da","greaterThan":"Maggiore di","lessThan":"Minore di","ok":"OK","reactError":"Impossibile eseguire ora il rendering di questa vista. Riprovare più tardi.","reactErrorHeader":"Impossibile eseguire il rendering della IU","reactErrorTrace":"Traccia dello stack","reactErrorDetails":"Visualizza dettagli","to":"A","tryAgain":"Ritenta"},"__ja":{"from":"範囲の始まり","greaterThan":"より大きい","lessThan":"より小さい","ok":"OK","reactError":"このビューは現時点ではレンダリングできません。 後で、再試行してください。","reactErrorHeader":"UI のレンダリングに失敗しました","reactErrorTrace":"スタック・トレース","reactErrorDetails":"詳細の表示","to":"範囲の終わり","tryAgain":"再試行してください"},"__kk":{"from":"Кімнен","greaterThan":"артығырақ","lessThan":"кемірек","ok":"OK","reactError":"Бұл көріністі енді көрсету мүмкін емес. Әрекетті кейінірек қайталаңыз.","reactErrorHeader":"UI көрсету сәтсіз аяқталды","reactErrorTrace":"Стекті трасирлеу","reactErrorDetails":"Мәліметтерді көріңіз","to":"Кімге","tryAgain":"Әрекетті қайталау"},"__ko":{"from":"시작","greaterThan":"보다 큼","lessThan":"보다 작음","ok":"확인","reactError":"이 보기는 지금 렌더링할 수 없습니다. 나중에 다시 시도하십시오.","reactErrorHeader":"UI 렌더링에 실패","reactErrorTrace":"스택 추적","reactErrorDetails":"세부사항 보기","to":"종료","tryAgain":"다시 시도"},"__nb":{"from":"Fra","greaterThan":"Større enn","lessThan":"Mindre enn","ok":"OK","reactError":"Denne visningen kan ikke gjengis nå. Prøv igjen senere.","reactErrorHeader":"Kunne ikke gjengi UI","reactErrorTrace":"Stakksporing","reactErrorDetails":"Vis detaljer","to":"Til","tryAgain":"Prøv igjen"},"__nl":{"from":"Van","greaterThan":"Groter dan","lessThan":"Kleiner dan","ok":"OK","reactError":"Deze view kan nu niet worden weergegeven. Probeer het later opnieuw.","reactErrorHeader":"Weergeven van gebruikersinterface is mislukt","reactErrorTrace":"Stacktracering","reactErrorDetails":"Details bekijken","to":"Aan","tryAgain":"Opnieuw proberen"},"__no":{"from":"Fra","greaterThan":"Større enn","lessThan":"Mindre enn","ok":"OK","reactError":"Denne visningen kan ikke gjengis nå. Prøv igjen senere.","reactErrorHeader":"Kunne ikke gjengi UI","reactErrorTrace":"Stakksporing","reactErrorDetails":"Vis detaljer","to":"Til","tryAgain":"Prøv igjen"},"__pl":{"from":"Od","greaterThan":"Większe niż","lessThan":"Mniejsze niż","ok":"OK","reactError":"Tego widoku nie można teraz wyświetlać. Spróbuj ponownie później.","reactErrorHeader":"Renderowanie IU nie powiodło się","reactErrorTrace":"Stos wywołań","reactErrorDetails":"Wyświetl szczegóły","to":"Do","tryAgain":"Spróbuj ponownie"},"__pt":{"from":"De","greaterThan":"Maior que","lessThan":"Menor que","ok":"OK","reactError":"Esta visualização não pode ser renderizada agora. Tente novamente mais tarde.","reactErrorHeader":"Falha ao renderizar a UI","reactErrorTrace":"Rastreio de pilha","reactErrorDetails":"View details","to":"Para","tryAgain":"Tentar novamente"},"__pt-br":{"from":"De","greaterThan":"Maior que","lessThan":"Menor que","ok":"OK","reactError":"Esta visualização não pode ser renderizada agora. Tente novamente mais tarde.","reactErrorHeader":"Falha ao renderizar a UI","reactErrorTrace":"Rastreio de pilha","reactErrorDetails":"View details","to":"Para","tryAgain":"Tentar novamente"},"__ro":{"from":"De la","greaterThan":"Mai mare ca","lessThan":"Mai mic ca","ok":"OK","reactError":"Această vizualizare nu poate fi randată acum. Încercaţi din nou mai târziu.","reactErrorHeader":"A eşuat randarea UI","reactErrorTrace":"Urmă stivă","reactErrorDetails":"Vizualizare detalii","to":"Până la","tryAgain":"Încercaţi din nou"},"__ru":{"from":"С","greaterThan":"Больше","lessThan":"Меньше","ok":"ОК","reactError":"Воспроизвести данное представление сейчас невозможно. Повторите попытку позже.","reactErrorHeader":"Не удалось воспроизвести пользовательский интерфейс","reactErrorTrace":"Трассировка стека","reactErrorDetails":"Просмотреть подробности","to":"Кому","tryAgain":"Попробуйте еще раз"},"__sl":{"from":"Od","greaterThan":"Večje od","lessThan":"Manjše od","ok":"V redu","reactError":"Tega pogleda trenutno ni mogoče upodobiti. Poskusite znova pozneje.","reactErrorHeader":"Upodabljanje UI-ja ni uspelo","reactErrorTrace":"Sled sklada","reactErrorDetails":"Ogled podrobnosti","to":"Za","tryAgain":"Poskusite znova"},"__sv":{"from":"Från","greaterThan":"Större än","lessThan":"Mindre än","ok":"OK","reactError":"Det går inte att rendera vyn nu. Försök igen senare.","reactErrorHeader":"Det gick inte att rendera gränssnittet","reactErrorTrace":"Stackspårning","reactErrorDetails":"Visa detaljer","to":"Till","tryAgain":"Försök igen"},"__th":{"from":"จาก","greaterThan":"มากกว่า","lessThan":"น้อยกว่า","ok":"โอเค","reactError":"มุมมองนี้ไม่สามารถสร้างการแสดงผลได้ในตอนนี้ โปรดลองอีกครั้งในภายหลัง","reactErrorHeader":"ล้มเหลวในการสร้างการแสดงผล UI","reactErrorTrace":"การติดตามสแต็ก","reactErrorDetails":"ดูรายละเอียด","to":"ไปยัง","tryAgain":"ลองอีกครั้ง"},"__tr":{"from":"Başlangıç","greaterThan":"Bundan büyük","lessThan":"Küçüktür","ok":"Tamam","reactError":"Bu görünüm şimdi görsel olarak gerçekleştirilemez. Lütfen daha sonra yeniden deneyin.","reactErrorHeader":"Kullanıcı arabirimi görsel olarak gerçekleştirilemedi","reactErrorTrace":"Yığın izlemesi","reactErrorDetails":"Ayrıntıları görüntüle","to":"Hedef","tryAgain":"Yeniden deneyin"},"__zh":{"from":"自","greaterThan":"大于","lessThan":"小于","ok":"确定","reactError":"现在无法呈现此视图。请稍后重试。","reactErrorHeader":"未能呈现 UI","reactErrorTrace":"堆栈跟踪","reactErrorDetails":"查看详细信息","to":"到","tryAgain":"重试"},"__zh-cn":{"from":"自","greaterThan":"大于","lessThan":"小于","ok":"确定","reactError":"现在无法呈现此视图。请稍后重试。","reactErrorHeader":"未能呈现 UI","reactErrorTrace":"堆栈跟踪","reactErrorDetails":"查看详细信息","to":"到","tryAgain":"重试"},"__zh-tw":{"from":"從","greaterThan":"大於","lessThan":"小於","ok":"確定","reactError":"此視圖無法立即呈現。請稍後重試。","reactErrorHeader":"無法呈現使用者介面","reactErrorTrace":"堆疊追蹤","reactErrorDetails":"檢視詳細資料","to":"到","tryAgain":"重試"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EmptyState; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Modeling UI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */



class EmptyState extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  render() {
    const {
      icon,
      iconSize,
      header,
      body,
      button,
      height,
      maxWidth
    } = this.props;
    const headerMarginTop = icon ? 3 : 0;
    const bodyMarginTop = header ? 1 : headerMarginTop;
    const buttonMarginTop = icon || header || body ? 3 : 0;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
      height: height,
      justifyContent: "center"
    }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Icon, {
      icon: icon,
      height: iconSize,
      width: iconSize
    }), header && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Header, {
      maxWidth: maxWidth,
      gutter: [headerMarginTop, 0, 0, 0]
    }, header), body && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Body, {
      maxWidth: maxWidth,
      gutter: [bodyMarginTop, 0, 0, 0]
    }, body), button && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(common_components_TextIcon__WEBPACK_IMPORTED_MODULE_2__["default"].Body, {
      maxWidth: maxWidth,
      gutter: [buttonMarginTop, 0, 0, 0]
    }, button));
  }

}

_defineProperty(EmptyState, "propTypes", {
  icon: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.object,
  iconSize: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number,
  header: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node]),
  body: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node]),
  button: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  height: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number]),
  maxWidth: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number])
});

_defineProperty(EmptyState, "defaultProps", {
  iconSize: 128,
  height: '100%',
  maxWidth: 300
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextIcon; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var _ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TextIcon_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35);
/* harmony import */ var _TextIcon_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_TextIcon_scss__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/no-find-dom-node */

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







const FlexElement = ({
  tid,
  children,
  classNames,
  ...others
}) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["FlexItem"], _extends({
  className: classNames,
  textAlign: "center",
  "data-tid": tid
}, others), children);

FlexElement.propTypes = {
  tid: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  classNames: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  gutter: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.array, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number])
};
class TextIcon extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_container", void 0);

    _defineProperty(this, "_onClick", () => {
      const {
        onClick,
        onSelect
      } = this.props;
      onSelect && onSelect();
      onClick && onClick();
    });

    _defineProperty(this, "_onDoubleClick", () => {
      const {
        onDoubleClick,
        onConfirm
      } = this.props;
      onConfirm && onConfirm();
      onDoubleClick && onDoubleClick();
    });

    _defineProperty(this, "_onKeyDown", e => {
      const {
        onSelect,
        onKeyDown
      } = this.props;

      if (e.keyCode === 32 || e.keyCode === 13) {
        onSelect && onSelect();
      }

      onKeyDown && onKeyDown(e);
    });

    _defineProperty(this, "_isClickable", () => this.props.onSelect || this.props.onClick || this.props.onDoubleClick);
  }

  focus() {
    const containerDomNode = Object(react_dom__WEBPACK_IMPORTED_MODULE_2__["findDOMNode"])(this._container);
    containerDomNode && containerDomNode.focus();
  }

  render() {
    const {
      className = '',
      isSelected,
      children,
      ...other
    } = this.props;
    const passThroughProps = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["omit"])(other, 'onSelect', 'onConfirm');

    const isClickable = this._isClickable();

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["Container"], _extends({
      className: Object(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["classnames"])('text-icon__button', {
        clickable: isClickable,
        selected: isSelected
      }),
      tabIndex: 0,
      role: isClickable ? 'button' : null
    }, passThroughProps, {
      onClick: this._onClick,
      onDoubleClick: this._onDoubleClick,
      onKeyDown: this._onKeyDown,
      ref: node => this._container = node
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["FlexLayout"], {
      justifyContent: "center",
      alignItems: "center",
      direction: "column",
      fullHeight: true,
      className: `text-icon ${className}`
    }, children));
  }

}

_defineProperty(TextIcon, "Header", props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, _extends({
  gutter: [0, 0, 1, 0],
  classNames: "text-icon__header"
}, props)));

_defineProperty(TextIcon, "SubHeader", props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, _extends({
  gutter: [0, 0, 1, 0],
  classNames: "text-icon__sub_header"
}, props)));

_defineProperty(TextIcon, "Body", props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, _extends({
  classNames: "text-icon__body"
}, props)));

_defineProperty(TextIcon, "Icon", ({
  icon,
  gutter = [],
  ...other
}) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(FlexElement, {
  gutter: gutter
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_ba_ba_ui_carbon_toolkit__WEBPACK_IMPORTED_MODULE_4__["SVGIcon"], _extends({
  className: "text-icon__icon",
  iconId: icon && icon.id
}, other))));

_defineProperty(TextIcon, "propTypes", {
  className: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  onSelect: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onConfirm: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  isSelected: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.node,
  onClick: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onDoubleClick: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func,
  onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func
});

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(36);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".text-icon__button{height:100%;border:2px solid transparent;padding-top:24px;padding-bottom:24px}.text-icon__button.is-clickable:hover{cursor:pointer;border:2px solid #2d74da}.text-icon__button.is-selected{border-color:#2d74da}.text-icon__button.is-focus{outline:none}.text-icon__header{font-size:1rem;font-weight:700;line-height:1.25rem;padding-bottom:8px}.text-icon__sub_header{line-height:1.25rem;padding-bottom:8px}.text-icon__body{font-size:.875rem;line-height:1.125rem}.text-icon__icon{fill:#00baa1}\n", ""]);

// exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(95);


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"addCondition":"Add another condition","addFilterCondition":"Add a filter condition","after":"After","allMembers":"All members of the set","and":"And","apply":"Apply","ascending":"Ascending","before":"Before","beginsWith":"Begins with","between":"Between","cancel":"Cancel","clearAll":"Clear all","clearConditions":"Clear conditions","close":"Close","contains":"Contains","containsExcludedIncludedItems":"Contains excluded and included items","dataTruncation":"Not all items are shown.","dateAndTime":"Date and time","dateOnly":"Date only","dateValidation":"Ensure that the \"From\" date and/or time is the same or earlier than the \"To\" date and/or time.","descending":"Descending","doesNotBeginWith":"Does not begin with","doesNotContain":"Does not contain","doesNotEndWith":"Does not end with","doesNotEqual":"Does not equal","done":"Done","editCondition":"Edit condition","endsWith":"Ends with","enterValue":"Enter a value","equals":"Equals","excludeBlankDate":"Exclude blank date","excludeBlankValues":"Exclude blank values","fromDate":"From Date","fromTime":"From Time","filter":"Filter","filterCondition":"Filter condition","filter_noSearchResults":"Your search returned no results","filter_tryDifferentTerm":"Please try a different search term","find":"Find","from":"From","greaterThan":"Greater than","highQuality":"High Quality","includeBlankDate":"Include null values","includeBlankValues":"Include null values","individualValues":"Individual values","individualItems":"Select individual items","invert":"Invert","lessThan":"Less than","loadMore":"Load more ...","lowQuality":"Low Quality","matchingCondition":"Items matching this condition have a similar icon","mediumQuality":"Medium Quality","menu":"Menu","missingValues":"Missing Values","newCondition":"Add condition","next":"Next","noSort":"No sort","notBetween":"Not between","ok":"OK","or":"Or","previous":"Previous","range":"range","reflectsFilterCondition":"Reflects filter condition","returnToTree":"Return to tree","search":"Search","searchAllYourData":"Search all your data","setFilterCondition":"Set filter condition","single":"single","sliderDirections":"Use the slider or enter a range of values","to":"To","uniqueValues":"Unique Values","toDate":"To Date","toTime":"To Time","upperRange":"Define a range","useCheckboxes":"Use the checkboxes below to select which members to display.","useCheckboxToMakeTableSelection":"Use the check boxes in the source tree to make a selection."},"__cs":{"addCondition":"Přidat další podmínku","addFilterCondition":"Přidat podmínku filtru","after":"Za","allMembers":"Všechny členy sady","and":"A","apply":"Použít","ascending":"Vzestupně","before":"Před","beginsWith":"Začíná na","between":"Mezi","cancel":"Storno","clearAll":"Vymazat vše","clearConditions":"Vymazat podmínky","close":"Zavřít","contains":"Obsahuje","containsExcludedIncludedItems":"Obsahuje vyloučené a zahrnuté položky","dataTruncation":"Nejsou zobrazeny všechny položky","dateAndTime":"Datum a čas","dateOnly":"Pouze datum","dateValidation":"Ověřte, že datum a čas \"Od\" jsou stejné nebo dřívější než datum a čas \"Do\".","descending":"Sestupně","doesNotBeginWith":"Nezačíná na","doesNotContain":"Neobsahuje","doesNotEndWith":"Nekončí na","doesNotEqual":"Nerovná se","done":"Hotovo","editCondition":"Upravit podmínku","endsWith":"Končí na","enterValue":"Zadat hodnotu","equals":"Rovná se","excludeBlankDate":"Vyloučit prázdná data","excludeBlankValues":"Vyloučit prázdné hodnoty","fromDate":"Počáteční datum","fromTime":"Počáteční čas","filter":"Filtr","filterCondition":"Podmínka filtru","filter_noSearchResults":"Hledání nevrátilo žádné výsledky.","filter_tryDifferentTerm":"Zkuste jiný hledaný výraz.","find":"Najít","from":"Od","greaterThan":"Větší než","highQuality":"Vysoká kvalita","includeBlankDate":"Zahrnout hodnoty Null","includeBlankValues":"Zahrnout hodnoty Null","individualValues":"Jednotlivé hodnoty","individualItems":"Vybrat jednotlivé položky","invert":"Invertovat","lessThan":"Menší než","loadMore":"Načíst další...","lowQuality":"Nízká kvalita","matchingCondition":"Položky odpovídající této podmínce mají podobnou ikonu","mediumQuality":"Střední kvalita","menu":"Nabídka","missingValues":"Chybějící hodnoty","newCondition":"Přidat podmínku","next":"Další","noSort":"Bez řazení","notBetween":"Ne mezi","ok":"OK","or":"Nebo","previous":"Předchozí","range":"rozsah","reflectsFilterCondition":"Zohledňuje podmínku filtru","returnToTree":"Návrat ke stromu","search":"Hledat","searchAllYourData":"Prohledat všechna data","setFilterCondition":"Nastavit podmínku filtru","single":"jednotlivý","sliderDirections":"Použijte jezdec nebo zadejte rozsah hodnot.","to":"Do","uniqueValues":"Jedinečné hodnoty","toDate":"Koncové datum","toTime":"Koncový čas","upperRange":"Definujte rozsah","useCheckboxes":"Pomocí zaškrtávacích políček uvedených níže vyberte zobrazované členy.","useCheckboxToMakeTableSelection":"Chcete-li provést výběr, použijte zaškrtávací políčka ve zdrojovém stromu."},"__da":{"addCondition":"Tilføj en anden betingelse","addFilterCondition":"Tilføj en filterbetingelse","after":"Efter","allMembers":"Alle medlemmer af sættet","and":"Og","apply":"Anvend","ascending":"Stigende","before":"Før","beginsWith":"Begynder med","between":"Mellem","cancel":"Annullér","clearAll":"Ryd alle","clearConditions":"Ryd betingelser","close":"Luk","contains":"Indeholder","containsExcludedIncludedItems":"Indeholder udeladte og inkluderede elementer","dataTruncation":"Ikke alle elementer er vist.","dateAndTime":"Dato og klokkeslæt","dateOnly":"Kun dato","dateValidation":"Kontrollér, at værdien for dato og/eller klokkeslæt for \"Fra\" er den samme eller tidligere end værdien for dato og/eller klokkeslæt for \"Til\".","descending":"Faldende","doesNotBeginWith":"Begynder ikke med","doesNotContain":"Indeholder ikke","doesNotEndWith":"Slutter ikke med","doesNotEqual":"Er ikke lig med","done":"Udført","editCondition":"Redigér betingelse","endsWith":"Slutter med","enterValue":"Angiv en værdi","equals":"Er lig med","excludeBlankDate":"Udelad tom dato","excludeBlankValues":"Udelad tomme værdier","fromDate":"Fra dato","fromTime":"Fra kl.","filter":"Filtrér","filterCondition":"Filterbetingelse","filter_noSearchResults":"Søgningen gav ingen resultater","filter_tryDifferentTerm":"Prøv et andet søgeudtryk","find":"Søg","from":"Fra","greaterThan":"Større end","highQuality":"Høj kvalitet","includeBlankDate":"Inkludér NULL-værdier","includeBlankValues":"Inkludér NULL-værdier","individualValues":"Individuelle værdier","individualItems":"Vælg individuelle elementer","invert":"Omvendt","lessThan":"Mindre end","loadMore":"Indlæs mere...","lowQuality":"Lav kvalitet","matchingCondition":"Elementer, der matcher denne betingelse, har en lignende ikon","mediumQuality":"Medium kvalitet","menu":"Menu","missingValues":"Manglende værdier","newCondition":"Tilføj betingelse","next":"Næste","noSort":"Ingen sortering","notBetween":"Ikke mellem","ok":"OK","or":"eller","previous":"Forrige","range":"interval","reflectsFilterCondition":"Afspejler filterbetingelse","returnToTree":"Vend tilbage til træstruktur","search":"Søg i","searchAllYourData":"Søg i alle dine data","setFilterCondition":"Angiv filterbetingelse","single":"enkelt","sliderDirections":"Brug skyderen, eller angiv et interval af værdier","to":"Til","uniqueValues":"Entydige værdier","toDate":"Til-dato","toTime":"Til kl.","upperRange":"Definér et interval","useCheckboxes":"Brug nedenstående afkrydsningsfelter til at vælge, hvilke medlemmer der skal vises.","useCheckboxToMakeTableSelection":"Brug afkrydsningsfelterne i kildetræstrukturen til at foretage et valg."},"__de":{"addCondition":"Weitere Bedingung hinzufügen","addFilterCondition":"Filterbedingung hinzufügen","after":"Nach","allMembers":"Alle Mitglieder des Satzes","and":"Und","apply":"Anwenden","ascending":"Aufsteigend","before":"Vor","beginsWith":"Beginnt mit","between":"Zwischen","cancel":"Abbrechen","clearAll":"Inhalt für alle löschen","clearConditions":"Bedingungen löschen","close":"Schließen","contains":"Enthält","containsExcludedIncludedItems":"Enthält ausgeschlossene und einbezogene Elemente","dataTruncation":"Es werden nicht alle Elemente angezeigt.","dateAndTime":"Datum und Uhrzeit","dateOnly":"Nur Datum","dateValidation":"Sicherstellen, dass die Datums- und/oder Zeitangabe für \"Von\" vor der Datums- und/oder Zeitangabe für \"Bis\" liegt oder mit dieser identisch ist.","descending":"Absteigend","doesNotBeginWith":"Beginnt nicht mit","doesNotContain":"Enthält nicht","doesNotEndWith":"Endet nicht mit","doesNotEqual":"Ist nicht gleich","done":"Fertig","editCondition":"Bedingung bearbeiten","endsWith":"Endet mit","enterValue":"Wert eingeben","equals":"Ist gleich","excludeBlankDate":"Leeres Datum ausschließen","excludeBlankValues":"Leere Werte ausschließen","fromDate":"Startdatum","fromTime":"Startzeit","filter":"Filtern","filterCondition":"Filterbedingung","filter_noSearchResults":"Die Suche hat keine Ergebnisse geliefert.","filter_tryDifferentTerm":"Wiederholen Sie die Suche mit einem anderen Suchbegriff.","find":"Suchen","from":"Von","greaterThan":"Größer als","highQuality":"Hohe Qualität","includeBlankDate":"Nullwerte einbeziehen","includeBlankValues":"Nullwerte einbeziehen","individualValues":"Einzelne Werte","individualItems":"Einzelne Elemente auswählen","invert":"Auswahl umkehren","lessThan":"Kleiner als","loadMore":"Weitere laden...","lowQuality":"Niedrige Qualität","matchingCondition":"Elemente, die mit dieser Bedingung übereinstimmen, weisen ein ähnliches Symbol auf","mediumQuality":"Mittlere Qualität","menu":"Menü","missingValues":"Fehlende Werte","newCondition":"Bedingung hinzufügen","next":"Weiter","noSort":"Nicht sortieren","notBetween":"Nicht zwischen","ok":"OK","or":"Oder","previous":"Zurück","range":"Bereich","reflectsFilterCondition":"Spiegelt Filterbedingung wider","returnToTree":"Zurück zur Verzeichnisstruktur","search":"Suchen","searchAllYourData":"Alle Daten durchsuchen","setFilterCondition":"Filterbedingung festlegen","single":"einzeln","sliderDirections":"Schieberegler verwenden oder Wertebereich eingeben","to":"Bis","uniqueValues":"Eindeutige Werte","toDate":"Enddatum","toTime":"Endzeit","upperRange":"Bereich definieren","useCheckboxes":"Verwenden Sie die unten angezeigten Kontrollkästchen, um die anzuzeigenden Mitglieder auszuwählen.","useCheckboxToMakeTableSelection":"Auswahl mithilfe der Kontrollkästchen in der Quellenverzeichnisstruktur vornehmen."},"__es":{"addCondition":"Añadir otra condición","addFilterCondition":"Añadir un filtro de condición","after":"Después","allMembers":"Todos los miembros del conjunto","and":"Y","apply":"Aplicar","ascending":"Ascendente","before":"Antes","beginsWith":"Empieza con","between":"Entre","cancel":"Cancelar","clearAll":"Borrar todo","clearConditions":"Borrar condiciones","close":"Cerrar","contains":"Contiene","containsExcludedIncludedItems":"Contiene elementos incluidos y excluidos","dataTruncation":"No se muestran todos los elementos","dateAndTime":"Fecha y hora","dateOnly":"Solo fecha","dateValidation":"Asegúrese de que la hora y/o la fecha del campo \"Desde\" sea igual o anterior a la hora y/o la fecha de \"Hasta\"","descending":"Descendente","doesNotBeginWith":"No comienza por","doesNotContain":"No contiene","doesNotEndWith":"No acaba por","doesNotEqual":"No es igual a","done":"Listo","editCondition":"Editar condición","endsWith":"Termina con","enterValue":"Especificar un valor","equals":"Igual a","excludeBlankDate":"Excluir fecha en blanco","excludeBlankValues":"Excluir valores en blanco","fromDate":"Desde fecha","fromTime":"Desde hora","filter":"Filtro","filterCondition":"Filtrar condición","filter_noSearchResults":"Su búsqueda no ha devuelto resultados","filter_tryDifferentTerm":"Vuelva a intentarlo con un término de búsqueda distinto","find":"Buscar","from":"Desde","greaterThan":"Mayor que","highQuality":"Alta calidad","includeBlankDate":"Incluir valores nulos","includeBlankValues":"Incluir valores nulos","individualValues":"Valores individuales","individualItems":"Seleccionar elementos individuales","invert":"Invertir","lessThan":"Menor que","loadMore":"Cargar más ...","lowQuality":"Baja calidad","matchingCondition":"Los elementos que coinciden con esta condición tienen un icono similar","mediumQuality":"Calidad media","menu":"Menú","missingValues":"Valores ausentes","newCondition":"Añadir condición","next":"Siguiente","noSort":"Sin orden","notBetween":"No entre","ok":"Aceptar","or":"O","previous":"Anterior","range":"rango","reflectsFilterCondition":"Refleja un filtro de condición","returnToTree":"Devolver al árbol","search":"Buscar","searchAllYourData":"Realizar una búsqueda en todos sus datos","setFilterCondition":"Establecer filtro de condición","single":"individual","sliderDirections":"Utilice la barra deslizante o escriba un rango de valores","to":"Para","uniqueValues":"Valores exclusivos","toDate":"Hasta fecha","toTime":"Hasta hora","upperRange":"Definir un rango","useCheckboxes":"Utilice los cuadros de selección siguientes para seleccionar los miembros que se han de visualizar.","useCheckboxToMakeTableSelection":"Utilice las casillas de verificación del árbol de origen para realizar una selección."},"__fi":{"addCondition":"Lisää toinen ehto","addFilterCondition":"Lisää suodatusehto","after":"Jälkeen","allMembers":"Kaikki joukon jäsenet","and":"Ja","apply":"Käytä","ascending":"Nouseva","before":"Ennen","beginsWith":"Alkaa","between":"Väliltä","cancel":"Peruuta","clearAll":"Tyhjennä kaikki","clearConditions":"Tyhjennä ehdot","close":"Sulje","contains":"Sisältää kohteen","containsExcludedIncludedItems":"Sisältää pois jätettyjä ja sisällytettyjä kohteita","dataTruncation":"Kaikkia kohteita ei näytetä.","dateAndTime":"Päivämäärä ja aika","dateOnly":"Vain päivämäärä","dateValidation":"Varmista, että Alkaa-kentän päivämäärän ja mahdollisen kellonajan arvot ovat samat tai aiemmat kuin Päättyy-kentän vastaavat arvot.","descending":"Laskeva","doesNotBeginWith":"Ei ala parametrilla","doesNotContain":"Ei sisällä","doesNotEndWith":"Ei pääty parametriin","doesNotEqual":"Ei ole yhtä suuri","done":"Valmis","editCondition":"Muokkaa ehtoa","endsWith":"Loppuu","enterValue":"Anna arvo","equals":"On yhtä suuri kuin","excludeBlankDate":"Jätä tyhjä päivämäärä pois","excludeBlankValues":"Jätä tyhjät arvot pois","fromDate":"Aloituspäivä","fromTime":"Aloitusaika","filter":"Suodatin","filterCondition":"Suodatusehto","filter_noSearchResults":"Haku ei palauttanut tuloksia","filter_tryDifferentTerm":"Kokeile toista hakuehtoa","find":"Etsi","from":"Alkaa","greaterThan":"Suurempi kuin","highQuality":"Hyvä laatu","includeBlankDate":"Sisällytä tyhjäarvot","includeBlankValues":"Sisällytä tyhjäarvot","individualValues":"Yksilölliset arvot","individualItems":"Valitse yksittäiset kohteet","invert":"Muuta käänteiseksi","lessThan":"Pienempi kuin","loadMore":"Lataa lisää...","lowQuality":"Heikko laatu","matchingCondition":"Kohteilla, jotka vastaavat tätä ehtoa, on samankaltainen kuvake","mediumQuality":"Keskilaatu","menu":"Menu","missingValues":"Puuttuvat arvot","newCondition":"Lisää ehto","next":"Seuraava","noSort":"Ei lajittelua","notBetween":"Ei välillä","ok":"OK","or":"Tai","previous":"Edellinen","range":"alue","reflectsFilterCondition":"Kuvastaa suodatusehtoa","returnToTree":"Palaa rakenne-esitykseen","search":"Hae","searchAllYourData":"Hae kaikista tiedoista","setFilterCondition":"Määritä suodatusehto","single":"yksittäinen","sliderDirections":"Käytä liukusäädintä tai kirjoita arvoalue","to":"Päättyy","uniqueValues":"Yksittäiset arvot","toDate":"Lopetuspäivä","toTime":"Lopetusaika","upperRange":"Määritä alue","useCheckboxes":"Valitse näytettävät jäsenet seuraavien valintaruutujen avulla.","useCheckboxToMakeTableSelection":"Käytä valintaan lähderakenteen valintaruutuja."},"__fr":{"addCondition":"Ajouter une autre condition","addFilterCondition":"Ajouter une condition de filtre","after":"Après","allMembers":"Tous les membres de l'ensemble","and":"Et","apply":"Appliquer","ascending":"Croissant","before":"Avant","beginsWith":"Commence par","between":"Entre","cancel":"Annuler","clearAll":"Effacer tout","clearConditions":"Désélectionner les conditions","close":"Fermer","contains":"Contient","containsExcludedIncludedItems":"Contient des éléments inclus et exclus","dataTruncation":"Tous les éléments ne sont pas affichés.","dateAndTime":"Date et heure","dateOnly":"Date uniquement","dateValidation":"S'assurer que la date et/ou l'heure \"Du\" est identique ou antérieure à la date et/ou l'heure \"Au\".","descending":"Décroissant","doesNotBeginWith":"Ne commence pas par","doesNotContain":"Ne contient pas","doesNotEndWith":"Ne se termine pas par","doesNotEqual":"N'est pas égal(e) à","done":"Terminé","editCondition":"Editer une condition","endsWith":"Se termine par","enterValue":"Entrer une valeur","equals":"Egal à","excludeBlankDate":"Exclure une date vierge","excludeBlankValues":"Exclure les valeurs vides","fromDate":"Date de début","fromTime":"Heure de début","filter":"Filtre","filterCondition":"Condition de filtre","filter_noSearchResults":"Votre recherche n’a renvoyé aucun résultat.","filter_tryDifferentTerm":"Essayez un autre terme de recherche.","find":"Rechercher","from":"De","greaterThan":"Supérieur à","highQuality":"Haute qualité","includeBlankDate":"Inclure les valeurs NULL","includeBlankValues":"Inclure les valeurs NULL","individualValues":"Valeurs individuelles","individualItems":"Sélectionner des éléments individuels","invert":"Inverser","lessThan":"Inférieur à","loadMore":"Charger davantage ...","lowQuality":"Qualité faible","matchingCondition":"Les éléments qui correspondent à cette condition ont une icône similaire","mediumQuality":"Qualité moyenne","menu":"Menu","missingValues":"Valeurs manquantes","newCondition":"Ajouter une condition","next":"Suivant","noSort":"Aucun tri","notBetween":"Pas compris entre","ok":"OK","or":"Ou","previous":"Précédent","range":"plage","reflectsFilterCondition":"Reflète la condition de filtre","returnToTree":"Retour à l'arborescence","search":"Rechercher","searchAllYourData":"Rechercher dans toutes vos données","setFilterCondition":"Définir une condition de filtre","single":"unique","sliderDirections":"Utiliser le curseur ou entrer une plage de valeurs","to":"A","uniqueValues":"Valeurs uniques","toDate":"Date de fin","toTime":"Heure de fin","upperRange":"Définir une plage","useCheckboxes":"Utiliser les cases ci-dessous pour sélectionner les membres à afficher.","useCheckboxToMakeTableSelection":"Utilisez les cases à cocher dans l'arborescence source pour effectuer une sélection."},"__hr":{"addCondition":"Dodaj drugi uvjet","addFilterCondition":"Dodaj uvjet filtera","after":"Poslije","allMembers":"Svi članovi skupa","and":"I","apply":"Primijeni","ascending":"Uzlazno","before":"Prije","beginsWith":"Počinje s","between":"Između","cancel":"Opoziv","clearAll":"Isprazni sve","clearConditions":"Isprazni uvjete","close":"Zatvori","contains":"Sadrži","containsExcludedIncludedItems":"Sadrži uključene i isključene stavke","dataTruncation":"Nisu prikazani svi podaci.","dateAndTime":"Datum i vrijeme","dateOnly":"Samo datum","dateValidation":"Osigurajte da je datum i/ili vrijeme u \"Od\" jednako ili ranije od datuma i/ili vremena u \"Do\".","descending":"Silazno","doesNotBeginWith":"Ne počinje s","doesNotContain":"Ne sadrži","doesNotEndWith":"Ne završava s","doesNotEqual":"Nije jednako","done":"Gotovo","editCondition":"Uredi uvjet","endsWith":"Završava s","enterValue":"Unesite vrijednost","equals":"Jednako","excludeBlankDate":"Isključi prazan datum","excludeBlankValues":"Isključi prazne vrijednosti","fromDate":"Od datuma","fromTime":"Od vremena","filter":"Filter","filterCondition":"Uvjet filtera","filter_noSearchResults":"Vaše pretraživanje nije vratilo rezultate","filter_tryDifferentTerm":"Molim, pokušajte s različitim pojmom za traženje","find":"Traži","from":"Od","greaterThan":"Veće od","highQuality":"Visoka kvaliteta","includeBlankDate":"Uključi null vrijednosti","includeBlankValues":"Uključi null vrijednosti","individualValues":"Pojedinačne vrijednosti","individualItems":"Izaberite pojedinačne stavke","invert":"Preokreni","lessThan":"Manje od","loadMore":"Učitaj više...","lowQuality":"Niska kvaliteta","matchingCondition":"Stavke koje zadovoljavaju ovaj uvjet imaju sličnu ikonu","mediumQuality":"Srednja kvaliteta","menu":"Izbornik","missingValues":"Vrijednosti koje nedostaju","newCondition":"Dodaj uvjet","next":"Sljedeće","noSort":"Ne sortiraj","notBetween":"Nije između","ok":"OK","or":"Ili","previous":"Prethodno","range":"raspon","reflectsFilterCondition":"Pokazuje stanje filtera","returnToTree":"Povratak na stablo","search":"Traži","searchAllYourData":"Pretraži sve podatke","setFilterCondition":"Postavi uvjet filtera","single":"pojedinačan","sliderDirections":"Koristite klizač ili unesite raspon vrijednosti","to":"Do","uniqueValues":"Jedinstvene vrijednosti","toDate":"Do datuma","toTime":"Do vremena","upperRange":"Definirajte raspon","useCheckboxes":"Koristite donje kontrolne kućice za biranje članova koji se prikazuju.","useCheckboxToMakeTableSelection":"Koristite kontrolne kućice u stablu izvora da napravite izbor."},"__hu":{"addCondition":"Másik feltétel hozzáadása","addFilterCondition":"Szűrőfeltétel hozzáadása","after":"Ez után:","allMembers":"A halmaz összes tagja","and":"És","apply":"Alkalmaz","ascending":"Növekvő","before":"Ez előtt:","beginsWith":"Ezzel kezdődik:","between":"Az alábbiak között:","cancel":"Mégse","clearAll":"Az összes törlése","clearConditions":"Feltételek törlése","close":"Bezárás","contains":"Tartalmazza a következőt:","containsExcludedIncludedItems":"Kizárt és szerepeltetett elemeket tartalmaz","dataTruncation":"Nem jelenik meg az összes elem.","dateAndTime":"Dátum és idő","dateOnly":"Csak dátum","dateValidation":"Gondoskodjék róla, hogy a \"Kezdési\" dátum  és/vagy időpont azonos vagy korábbi legyen, mint a \"Befejezési\" dátum és/vagy időpont.","descending":"Csökkenő","doesNotBeginWith":"Nem a következővel kezdődik:","doesNotContain":"Nem tartalmazza a következőt:","doesNotEndWith":"Nem a következőre végződik:","doesNotEqual":"Nem egyenlő","done":"Kész","editCondition":"Feltétel szerkesztése","endsWith":"Erre végződik:","enterValue":"Érték megadása","equals":"Egyenlő","excludeBlankDate":"Üres dátum kizárása","excludeBlankValues":"Üres értékek kizárása","fromDate":"Kezdő dátum","fromTime":"Kezdő időpont","filter":"Szűrő","filterCondition":"Szűrési feltétel","filter_noSearchResults":"A keresés nem adott vissza találatokat","filter_tryDifferentTerm":"Próbálkozzon egy másik keresési kifejezéssel","find":"Keresés","from":"Kezdet","greaterThan":"nagyobb mint","highQuality":"Magas minőség","includeBlankDate":"Nullértékek szerepeltetése","includeBlankValues":"Nullértékek szerepeltetése","individualValues":"Egyedi értékek","individualItems":"Egyedi elemek kijelölése","invert":"Megfordítás","lessThan":"Kisebb, mint","loadMore":"Továbbiak betöltése ...","lowQuality":"Alacsony minőség","matchingCondition":"A feltételnek megfelelő elemek hasonló ikonnal rendelkeznek","mediumQuality":"Közepes minőség","menu":"Menü","missingValues":"Hiányzó értékek","newCondition":"Feltétel hozzáadása","next":"Tovább","noSort":"Nincs rendezés","notBetween":"Nem közötte","ok":"OK","or":"Vagy","previous":"Előző","range":"tartomány","reflectsFilterCondition":"A szűrési feltételt fejezi ki","returnToTree":"Visszatérés a fához","search":"Keresés","searchAllYourData":"Keresés az összes adat között","setFilterCondition":"Szűrési feltétel beállítása","single":"egyedülálló","sliderDirections":"Használja a csúszkát, vagy adjon meg értéktartományt","to":"Eddig","uniqueValues":"Egyedi értékek","toDate":"Záró dátum","toTime":"Záró időpont","upperRange":"Tartomány meghatározása","useCheckboxes":"A lenti jelölőnégyzetek segítségével válassza ki a megjelenítendő tagokat.","useCheckboxToMakeTableSelection":"A kijelöléshez használja a forrás fában található jelölőnégyzeteket."},"__it":{"addCondition":"Aggiungi un'altra condizione","addFilterCondition":"Aggiungi una condizione di filtro","after":"Dopo","allMembers":"Tutti i membri della serie","and":"E","apply":"Applica","ascending":"Crescente","before":"Prima","beginsWith":"Inizia con","between":"Tra","cancel":"Annulla","clearAll":"Cancella tutto","clearConditions":"Cancella condizioni","close":"Chiudi","contains":"Contiene","containsExcludedIncludedItems":"Contiene voci incluse ed escluse","dataTruncation":"Non tutti gli elementi vengono visualizzati","dateAndTime":"Data e ora","dateOnly":"Solo data","dateValidation":"Accertarsi che la data \"Da\" e/o l'orario siano uguali alla data e/o orario \"A\".","descending":"Discendente","doesNotBeginWith":"Non inizia con","doesNotContain":"Non contiene","doesNotEndWith":"Non finisce con","doesNotEqual":"Non uguale","done":"Fine","editCondition":"Modifica condizione","endsWith":"Finisce con","enterValue":"Immettere un valore","equals":"Uguale a","excludeBlankDate":"Escludi data vuota","excludeBlankValues":"Escludi valori vuoti","fromDate":"Da data","fromTime":"Da ora","filter":"Filtro","filterCondition":"Condizione filtro","filter_noSearchResults":"La ricerca non ha prodotto risultati","filter_tryDifferentTerm":"Si prega di provare un termine di ricerca diverso","find":"Trova","from":"Da","greaterThan":"Maggiore di","highQuality":"Alta qualità","includeBlankDate":"Includi valori null","includeBlankValues":"Includi valori null","individualValues":"Singoli valori","individualItems":"Selezionare singoli elementi","invert":"Inverti","lessThan":"Minore di","loadMore":"Carica altro ...","lowQuality":"Qualità bassa","matchingCondition":"Le voci che corrispondono a questa condizione hanno un'icona simile","mediumQuality":"Qualità media","menu":"Menu","missingValues":"Valori mancanti","newCondition":"Aggiungi condizione","next":"Avanti","noSort":"Nessun ordinamento","notBetween":"Non compreso tra","ok":"OK","or":"O","previous":"Indietro","range":"intervallo","reflectsFilterCondition":"Rifletti condizione di filtro","returnToTree":"Ritorna alla struttura ad albero","search":"Ricerca","searchAllYourData":"Ricerca tutti i dati personali","setFilterCondition":"Imposta condizione di filtro","single":"singolo","sliderDirections":"Utilizza dispositivo di scorrimento o immetti intervallo di valori","to":"A","uniqueValues":"Valori univoci","toDate":"Alla data","toTime":"All'ora","upperRange":"Definire un intervallo","useCheckboxes":"Utilizzare le caselle di spunta seguenti per selezionare i membri da visualizzare.","useCheckboxToMakeTableSelection":"Utilizzare le caselle di controllo nell'albero dei sorgenti per effettuare una selezione."},"__ja":{"addCondition":"他の条件の追加","addFilterCondition":"フィルター条件の追加","after":"次の日付より後","allMembers":"セット内のすべてのメンバー","and":"かつ","apply":"適用","ascending":"昇順","before":"次の日付より前","beginsWith":"次の値から始まる","between":"指定の値の間","cancel":"キャンセル","clearAll":"すべてクリア","clearConditions":"条件のクリア","close":"閉じる","contains":"次を含む","containsExcludedIncludedItems":"対象外および対象アイテムを含む","dataTruncation":"すべての項目が表示されるわけではありません。","dateAndTime":"日時","dateOnly":"日付のみ","dateValidation":"「開始」日付および/または時刻は「終了」日付および/または時刻と同じかそれ以前にしてください。","descending":"降順","doesNotBeginWith":"次の値で始まらない","doesNotContain":"次の値を含まない","doesNotEndWith":"次の値で終わらない","doesNotEqual":"次の値に等しくない","done":"完了","editCondition":"条件を編集","endsWith":"後方一致","enterValue":"値の入力","equals":"等しい","excludeBlankDate":"空の日付を除外する","excludeBlankValues":"空の値を除外する","fromDate":"開始日付","fromTime":"開始時刻","filter":"フィルター","filterCondition":"フィルター条件","filter_noSearchResults":"検索で結果が返されませんでした。","filter_tryDifferentTerm":"他の検索語句を試してください","find":"検索","from":"範囲の始まり","greaterThan":"より大きい","highQuality":"高品質","includeBlankDate":"Null 値を含める","includeBlankValues":"Null 値を含める","individualValues":"個別の値","individualItems":"個々のアイテムの選択","invert":"反転","lessThan":"より小さい","loadMore":"さらにロード ...","lowQuality":"低品質","matchingCondition":"この条件に一致するアイテムは類似のアイコンを持ちます","mediumQuality":"中品質","menu":"Menu","missingValues":"欠落値","newCondition":"条件の追加","next":"次へ","noSort":"ソートなし","notBetween":"次の間以外","ok":"OK","or":"または","previous":"戻る","range":"範囲","reflectsFilterCondition":"フィルター条件の反映","returnToTree":"ツリーに戻る","search":"検索","searchAllYourData":"すべてのデータを検索","setFilterCondition":"フィルター条件の設定","single":"単一","sliderDirections":"スライダーを使用するか、値の範囲を入力してください","to":"範囲の終わり","uniqueValues":"固有値","toDate":"終了日付","toTime":"終了時刻","upperRange":"範囲の定義","useCheckboxes":"以下のチェック・ボックスを使用して、表示するメンバーを選択してください。","useCheckboxToMakeTableSelection":"ソース・ツリー内のチェック・ボックスを使用して選択してください。"},"__kk":{"addCondition":"Басқа бір шарт қосу","addFilterCondition":"Сүзгі шартын қосу","after":"Кейін","allMembers":"Жиындың барлық мүшелері","and":"Және","apply":"Қолдану","ascending":"Артуы бойынша","before":"Дейін","beginsWith":"келесімен басталады","between":"Арасында","cancel":"Болдырмау","clearAll":"Барлығын жою","clearConditions":"Шарттарды тазалау","close":"Жабу","contains":"Құрамында бар","containsExcludedIncludedItems":"Шығарылған және қосылған элементтерді қамтиды","dataTruncation":"Барлық элементтер көрсетілмейді.","dateAndTime":"Күні және уақыты","dateOnly":"Күні ғана","dateValidation":"\"Кімнен\" күн мен/немесе уақыт \"Кімге\" және/немесе уақытқа қарағанда бірдей немесе ертерек екенін тексеріңіз.","descending":"Кемуі бойынша","doesNotBeginWith":"Келесімен басталмайды","doesNotContain":"Құрамында жоқ","doesNotEndWith":"Келесімен аяқталмайды","doesNotEqual":"Тең емес","done":"Аяқталды","editCondition":"Шартты өңдеу","endsWith":"келесімен аяқталады","enterValue":"Мәнді енгізу","equals":"Теңдік белгісі","excludeBlankDate":"Бос күнді алып тастау","excludeBlankValues":"Бос мәндерді алып тастау","fromDate":"Күннен","fromTime":"Уақыттан","filter":"Сүзгі","filterCondition":"Сүзгілеу шарты","filter_noSearchResults":"Іздеуіңіз еш нәтижесіз","filter_tryDifferentTerm":"Басқа іздеу терминін қарап көріңіз","find":"Табу","from":"Кімнен","greaterThan":"артығырақ","highQuality":"Жоғары сапа","includeBlankDate":"Бос мәндер қосу","includeBlankValues":"Бос мәндер қосу","individualValues":"Жеке мәндер","individualItems":"Жеке элементтерді таңдаңыз","invert":"Оралту","lessThan":"кемірек","loadMore":"Толығырақ жүктеу ...","lowQuality":"Төменгі сапа","matchingCondition":"Осы шартқа сәйкес келетін элементтерде ұқсас белгі бар","mediumQuality":"Ортаңғы сапа","menu":"Мәзір","missingValues":"Жоқ мәндер","newCondition":"Шартты қосу","next":"Келесі","noSort":"Сұрыптамау","notBetween":"Арасында емес","ok":"OK","or":"Немесе","previous":"Алдыңғы","range":"ауқым","reflectsFilterCondition":"Сүзгі шартын көрсетеді","returnToTree":"Тармаққа қаутару","search":"Іздеу","searchAllYourData":"Барлық деректерді іздеу","setFilterCondition":"Сүзгіш шартын орнату","single":"жалғыз","sliderDirections":"Жүгірткіні пайдалану немесе мәндер ауқымын енгізу","to":"Кімге","uniqueValues":"Бірегей мәндер","toDate":"Күнге","toTime":"Уақытқа","upperRange":"Ауқымды анықтау","useCheckboxes":"Қандай мүшелерді көрсетуді таңдау үшін төмендегі құсбелгілерді пайдаланыңыз.","useCheckboxToMakeTableSelection":"Таңдау жасау үшін бастапқы ағаштан құсбелгіні пайдаланыңыз."},"__ko":{"addCondition":"다른 조건 추가","addFilterCondition":"필터 조건 추가","after":"이후","allMembers":"세트의 모든 멤버","and":"및","apply":"적용","ascending":"오름차순","before":"이전","beginsWith":"시작 문자","between":"범위","cancel":"취소","clearAll":"모두 지우기","clearConditions":"조건 지우기","close":"닫기","contains":"포함","containsExcludedIncludedItems":"제외 및 포함된 항목 포함","dataTruncation":"일부 항목은 표시되지 않습니다.","dateAndTime":"날짜 및 시간","dateOnly":"날짜만","dateValidation":"\"시작\" 날짜 및/또는 시간은 \"종료\" 날짜 및/또는 시간과 같거나 그 이전이어야 합니다.","descending":"내림차순","doesNotBeginWith":"제외할 시작 문자","doesNotContain":"포함하지 않음","doesNotEndWith":"제외할 끝 문자","doesNotEqual":"같지 않음","done":"완료","editCondition":"조건 편집","endsWith":"끝 문자","enterValue":"값 입력","equals":"같음","excludeBlankDate":"비어 있는 날짜 제외","excludeBlankValues":"비어 있는 값 제외","fromDate":"시작 날짜","fromTime":"시작 시간","filter":"필터","filterCondition":"필터 조건","filter_noSearchResults":"검색 결과가 리턴되지 않음","filter_tryDifferentTerm":"다른 검색어를 시도하십시오.","find":"찾기","from":"시작","greaterThan":"보다 큼","highQuality":"높은 품질","includeBlankDate":"널값 포함","includeBlankValues":"널값 포함","individualValues":"개별 값","individualItems":"개별 항목 선택","invert":"반전","lessThan":"보다 작음","loadMore":"계속 로드...","lowQuality":"낮은 품질","matchingCondition":"이 조건과 일치하는 항목은 아이콘이 유사함","mediumQuality":"중간 품질","menu":"메뉴","missingValues":"누락된 값","newCondition":"조건 추가","next":"다음","noSort":"정렬 안 함","notBetween":"사이에 없음","ok":"확인","or":"또는","previous":"이전","range":"범위","reflectsFilterCondition":"필터 조건 반영","returnToTree":"트리로 돌아가기","search":"검색","searchAllYourData":"모든 데이터 검색","setFilterCondition":"필터 조건 설정","single":"단일","sliderDirections":"슬라이더 사용 또는 값 범위 입력","to":"종료","uniqueValues":"고유 값","toDate":"종료 날짜","toTime":"종료 시간","upperRange":"범위 정의","useCheckboxes":"아래 선택란을 사용하여 표시할 멤버를 선택하십시오.","useCheckboxToMakeTableSelection":"소스 트리의 선택란을 사용하여 선택하십시오."},"__nb":{"addCondition":"Legg til en betingelse til","addFilterCondition":"Legg til en filterbetingelse","after":"Etter","allMembers":"Alle medlemmer i settet","and":"Og","apply":"Bruk","ascending":"Stigende","before":"Før","beginsWith":"Begynner med","between":"Mellom","cancel":"Avbryt","clearAll":"Fjern alle","clearConditions":"Fjern betingelser","close":"Lukk","contains":"Inneholder","containsExcludedIncludedItems":"Inneholder ekskluderte og inkluderte elementer","dataTruncation":"Ikke alle elementer blir vist.","dateAndTime":"Dato og klokkeslett","dateOnly":"Bare dato","dateValidation":"Sørg for at datoen og/eller klokkeslettet for \"Fra\" er likt eller tidligere enn datoen og/eller klokkeslettet for \"Til\".","descending":"Synkende","doesNotBeginWith":"Begynner ikke med","doesNotContain":"Inneholder ikke","doesNotEndWith":"Slutter ikke med","doesNotEqual":"Er ikke lik","done":"Ferdig","editCondition":"Rediger betingelse","endsWith":"Slutter med","enterValue":"Oppgi en verdi","equals":"Er lik","excludeBlankDate":"Ekskluder tom dato","excludeBlankValues":"Ekskluder tomme verdier","fromDate":"Fra dato","fromTime":"Fra klokkeslett","filter":"Filter","filterCondition":"Filterbetingelse","filter_noSearchResults":"Søket ditt gav ingen resultater","filter_tryDifferentTerm":"Prøv et annet søkeord","find":"Søk","from":"Fra","greaterThan":"Større enn","highQuality":"Høy kvalitet","includeBlankDate":"Inkluder nullverdier","includeBlankValues":"Inkluder nullverdier","individualValues":"Individuelle verdier","individualItems":"Velg individuelle elementer","invert":"Inverter","lessThan":"Mindre enn","loadMore":"Last inn mer ...","lowQuality":"Lav kvalitet","matchingCondition":"Elementer som samsvarer med denne betingelsen, har et liknende ikon","mediumQuality":"Middels kvalitet","menu":"Meny","missingValues":"Manglende verdier","newCondition":"Legg til betingelse","next":"Neste","noSort":"Ingen sortering","notBetween":"Ikke mellom","ok":"OK","or":"Eller","previous":"Forrige","range":"område","reflectsFilterCondition":"Gjenspeiler filterbetingelse","returnToTree":"Returner til tre","search":"Søk","searchAllYourData":"Søk i alle dataene dine","setFilterCondition":"Definer filterbetingelse","single":"enkel","sliderDirections":"Bruk glidebryter eller oppgi et verdiområde","to":"Til","uniqueValues":"Unike verdier","toDate":"Til dato","toTime":"Til klokkeslett","upperRange":"Definer et område","useCheckboxes":"Bruk avmerkingsboksene nedenfor for å velge hvilke medlemmer som skal vises.","useCheckboxToMakeTableSelection":"Bruk avmerkingsboksen i kildetreet for å velge."},"__nl":{"addCondition":"Een andere voorwaarde toevoegen","addFilterCondition":"Filtervoorwaarde toevoegen","after":"Na","allMembers":"Alle leden van de set","and":"En","apply":"Toepassen","ascending":"Oplopend","before":"Vóór","beginsWith":"Begint met","between":"Tussen","cancel":"Annuleren","clearAll":"Alles wissen","clearConditions":"Voorwaarden wissen","close":"Sluiting","contains":"Bevat","containsExcludedIncludedItems":"Bevat uitgesloten en opgenomen items","dataTruncation":"Niet alle items worden afgebeeld","dateAndTime":"Datum en tijd","dateOnly":"Alleen datum","dateValidation":"Zorg ervoor dat de datum en/of tijd bij \"Vanaf\" vroeger valt of gelijk is aan de datum en/of tijd bij \"Tot\".","descending":"Aflopend","doesNotBeginWith":"Begint niet met","doesNotContain":"Bevat niet","doesNotEndWith":"Eindigt niet op","doesNotEqual":"Is niet gelijk aan","done":"Gereed","editCondition":"Voorwaarde bewerken","endsWith":"Eindigt op","enterValue":"Voer een waarde in","equals":"Gelijk aan","excludeBlankDate":"Lege datum niet gebruiken","excludeBlankValues":"Lege waarden niet gebruiken","fromDate":"Datum vanaf","fromTime":"Tijd vanaf","filter":"Filteren","filterCondition":"Filtervoorwaarde","filter_noSearchResults":"De zoekactie heeft geen resultaat opgeleverd","filter_tryDifferentTerm":"Probeer een andere zoekterm","find":"Zoeken","from":"Van","greaterThan":"Groter dan","highQuality":"Hoge kwaliteit","includeBlankDate":"Nullwaarden gebruiken","includeBlankValues":"Nullwaarden gebruiken","individualValues":"Afzonderlijke waarden","individualItems":"Afzonderlijke items selecteren","invert":"Inverteren","lessThan":"Kleiner dan","loadMore":"Meer laden ...","lowQuality":"Lage kwaliteit","matchingCondition":"Items die aan deze voorwaarde voldoen, hebben een gelijksoortig pictogram","mediumQuality":"Gemiddelde kwaliteit","menu":"Menu","missingValues":"Ontbrekende waarden","newCondition":"Voorwaarde toevoegen","next":"Volgende","noSort":"Niet sorteren","notBetween":"Niet tussen","ok":"OK","or":"Of","previous":"Vorige","range":"bereik","reflectsFilterCondition":"Weerspiegelt een filtervoorwaarde","returnToTree":"Terug naar boomstructuur","search":"Zoeken","searchAllYourData":"Al uw gegevens doorzoeken","setFilterCondition":"Filtervoorwaarde instellen","single":"enkel","sliderDirections":"Gebruik de schuifregelaar om een reeks van waarden in te stellen","to":"Aan","uniqueValues":"Unieke waarden","toDate":"Tot aan datum","toTime":"Tot aan tijd","upperRange":"Een bereik definiëren","useCheckboxes":"Gebruik de onderstaande selectievakjes voor het selecteren van de leden die moeten worden afgebeeld.","useCheckboxToMakeTableSelection":"Gebruik de selectievakjes in de bronstructuur om een keuze te maken."},"__no":{"addCondition":"Legg til en betingelse til","addFilterCondition":"Legg til en filterbetingelse","after":"Etter","allMembers":"Alle medlemmer i settet","and":"Og","apply":"Bruk","ascending":"Stigende","before":"Før","beginsWith":"Begynner med","between":"Mellom","cancel":"Avbryt","clearAll":"Fjern alle","clearConditions":"Fjern betingelser","close":"Lukk","contains":"Inneholder","containsExcludedIncludedItems":"Inneholder ekskluderte og inkluderte elementer","dataTruncation":"Ikke alle elementer blir vist.","dateAndTime":"Dato og klokkeslett","dateOnly":"Bare dato","dateValidation":"Sørg for at datoen og/eller klokkeslettet for \"Fra\" er likt eller tidligere enn datoen og/eller klokkeslettet for \"Til\".","descending":"Synkende","doesNotBeginWith":"Begynner ikke med","doesNotContain":"Inneholder ikke","doesNotEndWith":"Slutter ikke med","doesNotEqual":"Er ikke lik","done":"Ferdig","editCondition":"Rediger betingelse","endsWith":"Slutter med","enterValue":"Oppgi en verdi","equals":"Er lik","excludeBlankDate":"Ekskluder tom dato","excludeBlankValues":"Ekskluder tomme verdier","fromDate":"Fra dato","fromTime":"Fra klokkeslett","filter":"Filter","filterCondition":"Filterbetingelse","filter_noSearchResults":"Søket ditt gav ingen resultater","filter_tryDifferentTerm":"Prøv et annet søkeord","find":"Søk","from":"Fra","greaterThan":"Større enn","highQuality":"Høy kvalitet","includeBlankDate":"Inkluder nullverdier","includeBlankValues":"Inkluder nullverdier","individualValues":"Individuelle verdier","individualItems":"Velg individuelle elementer","invert":"Inverter","lessThan":"Mindre enn","loadMore":"Last inn mer ...","lowQuality":"Lav kvalitet","matchingCondition":"Elementer som samsvarer med denne betingelsen, har et liknende ikon","mediumQuality":"Middels kvalitet","menu":"Meny","missingValues":"Manglende verdier","newCondition":"Legg til betingelse","next":"Neste","noSort":"Ingen sortering","notBetween":"Ikke mellom","ok":"OK","or":"Eller","previous":"Forrige","range":"område","reflectsFilterCondition":"Gjenspeiler filterbetingelse","returnToTree":"Returner til tre","search":"Søk","searchAllYourData":"Søk i alle dataene dine","setFilterCondition":"Definer filterbetingelse","single":"enkel","sliderDirections":"Bruk glidebryter eller oppgi et verdiområde","to":"Til","uniqueValues":"Unike verdier","toDate":"Til dato","toTime":"Til klokkeslett","upperRange":"Definer et område","useCheckboxes":"Bruk avmerkingsboksene nedenfor for å velge hvilke medlemmer som skal vises.","useCheckboxToMakeTableSelection":"Bruk avmerkingsboksen i kildetreet for å velge."},"__pl":{"addCondition":"Dodaj następny warunek","addFilterCondition":"Dodaj warunek filtrowania","after":"Po","allMembers":"Wszystkie elementy zestawu","and":"I","apply":"Zastosuj","ascending":"Rosnąco","before":"Przed","beginsWith":"Zaczyna się od","between":"Między","cancel":"Anuluj","clearAll":"Wyczyść wszystko","clearConditions":"Wyczyść warunki","close":"Zamknij","contains":"Zawiera","containsExcludedIncludedItems":"Zawiera elementy wykluczone i uwzględnione","dataTruncation":"Nie wszystkie elementy zostały wyświetlone.","dateAndTime":"Data i godzina","dateOnly":"Tylko data","dateValidation":"Upewnij się, że data i/lub godzina \"Od\" nie jest późniejsza niż data i/lub godzina \"Do\".","descending":"Malejąco","doesNotBeginWith":"Nie zaczyna się od","doesNotContain":"Nie zawiera","doesNotEndWith":"Nie kończy się na","doesNotEqual":"Nie równa się","done":"Gotowe","editCondition":"Edytuj warunek","endsWith":"Kończy się na","enterValue":"Wprowadź wartość","equals":"Równa się","excludeBlankDate":"Wyklucz pustą datę","excludeBlankValues":"Wyklucz puste wartości","fromDate":"Od daty","fromTime":"Od godziny","filter":"Filtruj","filterCondition":"Warunek filtrowania","filter_noSearchResults":"Wyszukiwanie nie zwróciło wyników","filter_tryDifferentTerm":"Spróbuj wyszukać inny termin","find":"Znajdź","from":"Od","greaterThan":"Większe niż","highQuality":"Wysoka jakość","includeBlankDate":"Uwzględnij wartości null","includeBlankValues":"Uwzględnij wartości null","individualValues":"Wartości pojedyncze","individualItems":"Wybierz poszczególne elementy","invert":"Odwróć","lessThan":"Mniejsze niż","loadMore":"Załaduj więcej...","lowQuality":"Niska jakość","matchingCondition":"Elementy spełniające ten warunek mają podobne ikony","mediumQuality":"Średnia jakość","menu":"Menu","missingValues":"Brakujące wartości","newCondition":"Dodaj warunek","next":"Dalej","noSort":"Bez sortowania","notBetween":"Nie pomiędzy","ok":"OK","or":"Lub","previous":"Poprzedni","range":"zakres","reflectsFilterCondition":"Odzwierciedla warunek filtrowania","returnToTree":"Wróć do drzewa","search":"Szukaj","searchAllYourData":"Szukaj we wszystkich swoich danych","setFilterCondition":"Ustaw warunek filtrowania","single":"pojedynczo","sliderDirections":"Użyj suwaka lub wprowadzić zakres wartości","to":"Do","uniqueValues":"Unikalne wartości","toDate":"Do daty","toTime":"Do godziny","upperRange":"Zdefiniuj zakres","useCheckboxes":"Użyj poniższych pól wyboru, aby wybrać elementy do wyświetlenia.","useCheckboxToMakeTableSelection":"Użyj pól wyboru w drzewie źródła, aby dokonać wyboru."},"__pt":{"addCondition":"Incluir outra condição","addFilterCondition":"Incluir uma condição de filtro","after":"Depois","allMembers":"Todos os membros do conjunto","and":"E","apply":"Aplicar","ascending":"Ordem crescente","before":"Antes","beginsWith":"Inicia com","between":"Entre","cancel":"Cancelar","clearAll":"Limpar tudo","clearConditions":"Limpar condições","close":"Fechar","contains":"Contém","containsExcludedIncludedItems":"Contém itens excluídos e incluídos","dataTruncation":"Nem todos os itens são mostrados.","dateAndTime":"data e hora","dateOnly":"Apenas data","dateValidation":"Certifique-se de que a data e/ou hora \"De\" seja igual ou anterior à data e/ou hora \"Para\".","descending":"Ordem decrescente","doesNotBeginWith":"Não começa com","doesNotContain":"Não contém","doesNotEndWith":"Não termina com","doesNotEqual":"Não é igual a","done":"Pronto","editCondition":"Editar condição","endsWith":"Termina com","enterValue":"Digite um valor","equals":"Igual a","excludeBlankDate":"Excluir data em branco","excludeBlankValues":"Excluir valores em branco","fromDate":"Data\nInicial","fromTime":"Horário Inicial","filter":"Filtrar","filterCondition":"Condição do Filtro","filter_noSearchResults":"Sua pesquisa não teve nenhum resultado","filter_tryDifferentTerm":"Tente um termo de procura diferente","find":"Localizar","from":"De","greaterThan":"Maior que","highQuality":"Qualidade alta","includeBlankDate":"Incluir valores nulos","includeBlankValues":"Incluir valores nulos","individualValues":"Valores individuais","individualItems":"Selecione itens individuais","invert":"Inverter","lessThan":"Menor que","loadMore":"Carregar mais...","lowQuality":"Qualidade baixa","matchingCondition":"Itens que correspondem a esta condição possuem um ícone similar","mediumQuality":"Qualidade média","menu":"Menu","missingValues":"Valores que faltam","newCondition":"Incluir condição","next":"Avançar","noSort":"Sem ordenação","notBetween":"Não entre","ok":"OK","or":"Ou","previous":"Anterior","range":"intervalo","reflectsFilterCondition":"Reflete a condição do filtro","returnToTree":"Retornar para a árvore","search":"Procurar","searchAllYourData":"Procurar todos os seus dados","setFilterCondition":"Configurar condição do filtro","single":"único","sliderDirections":"Use a régua de controle ou insira um intervalo de valores","to":"Para","uniqueValues":"Valores Exclusivos","toDate":"Até a Data","toTime":"Hora de Conclusão","upperRange":"Defina um intervalo","useCheckboxes":"Use as caixas abaixo para selecionar quais membros exibir.","useCheckboxToMakeTableSelection":"Use as caixas de seleção na árvore de origem para fazer uma\nseleção."},"__pt-br":{"addCondition":"Incluir outra condição","addFilterCondition":"Incluir uma condição de filtro","after":"Depois","allMembers":"Todos os membros do conjunto","and":"E","apply":"Aplicar","ascending":"Ordem crescente","before":"Antes","beginsWith":"Inicia com","between":"Entre","cancel":"Cancelar","clearAll":"Limpar tudo","clearConditions":"Limpar condições","close":"Fechar","contains":"Contém","containsExcludedIncludedItems":"Contém itens excluídos e incluídos","dataTruncation":"Nem todos os itens são mostrados.","dateAndTime":"data e hora","dateOnly":"Apenas data","dateValidation":"Certifique-se de que a data e/ou hora \"De\" seja igual ou anterior à data e/ou hora \"Para\".","descending":"Ordem decrescente","doesNotBeginWith":"Não começa com","doesNotContain":"Não contém","doesNotEndWith":"Não termina com","doesNotEqual":"Não é igual a","done":"Pronto","editCondition":"Editar condição","endsWith":"Termina com","enterValue":"Digite um valor","equals":"Igual a","excludeBlankDate":"Excluir data em branco","excludeBlankValues":"Excluir valores em branco","fromDate":"Data\nInicial","fromTime":"Horário Inicial","filter":"Filtrar","filterCondition":"Condição do Filtro","filter_noSearchResults":"Sua pesquisa não teve nenhum resultado","filter_tryDifferentTerm":"Tente um termo de procura diferente","find":"Localizar","from":"De","greaterThan":"Maior que","highQuality":"Qualidade alta","includeBlankDate":"Incluir valores nulos","includeBlankValues":"Incluir valores nulos","individualValues":"Valores individuais","individualItems":"Selecione itens individuais","invert":"Inverter","lessThan":"Menor que","loadMore":"Carregar mais...","lowQuality":"Qualidade baixa","matchingCondition":"Itens que correspondem a esta condição possuem um ícone similar","mediumQuality":"Qualidade média","menu":"Menu","missingValues":"Valores que faltam","newCondition":"Incluir condição","next":"Avançar","noSort":"Sem ordenação","notBetween":"Não entre","ok":"OK","or":"Ou","previous":"Anterior","range":"intervalo","reflectsFilterCondition":"Reflete a condição do filtro","returnToTree":"Retornar para a árvore","search":"Procurar","searchAllYourData":"Procurar todos os seus dados","setFilterCondition":"Configurar condição do filtro","single":"único","sliderDirections":"Use a régua de controle ou insira um intervalo de valores","to":"Para","uniqueValues":"Valores Exclusivos","toDate":"Até a Data","toTime":"Hora de Conclusão","upperRange":"Defina um intervalo","useCheckboxes":"Use as caixas abaixo para selecionar quais membros exibir.","useCheckboxToMakeTableSelection":"Use as caixas de seleção na árvore de origem para fazer uma\nseleção."},"__ro":{"addCondition":"Adăugare altă condiţie...","addFilterCondition":"Adăugare condiţie de filtrare","after":"După","allMembers":"Toţi membrii din set","and":"And","apply":"Aplicare","ascending":"Crescător","before":"Înainte","beginsWith":"Începe cu","between":"Între","cancel":"Anulare","clearAll":"Curăţare toate","clearConditions":"Curăţare condiţii","close":"Închidere","contains":"Conţine","containsExcludedIncludedItems":"Conţine articole excluse şi incluse","dataTruncation":"Nu sunt afişate toate articolele.","dateAndTime":"Dată şi timp","dateOnly":"Numai date","dateValidation":"Verificaţi că data şi/sau ora \"De la\" este aceeaşi sau anterioară datei şi/sau orei \"Până la\".","descending":"Descrescător","doesNotBeginWith":"Nu începe cu","doesNotContain":"Nu conţine","doesNotEndWith":"Nu se termină cu","doesNotEqual":"Nu este egal cu","done":"Gata","editCondition":"Editare condiţie","endsWith":"Se termină cu","enterValue":"Introduceţi o valoare","equals":"Este egal cu","excludeBlankDate":"Excludere dată necompletată","excludeBlankValues":"Excludere valori necompletate","fromDate":"De la  data","fromTime":"De la ora","filter":"Filtru","filterCondition":"Condiţie de filtrare","filter_noSearchResults":"Căutarea dumneavoastră nu a returnat niciun rezultat","filter_tryDifferentTerm":"Încercaţi alt termen de căutare","find":"Găsire","from":"De la","greaterThan":"Mai mare ca","highQuality":"Calitate înaltă","includeBlankDate":"Includere valori nule","includeBlankValues":"Includere valori nule","individualValues":"Valori individuale","individualItems":"Selectare articole individuale","invert":"Inversare","lessThan":"Mai mic ca","loadMore":"Încărcare mai multe...","lowQuality":"Calitate joasă","matchingCondition":"Articolele care corespund acestei condiţii au o pictogramă similară","mediumQuality":"Calitate medie","menu":"Meniu","missingValues":"Valori lipsă","newCondition":"Adăugare condiţie","next":"Următor","noSort":"Fără sortare","notBetween":"Nu între","ok":"OK","or":"Or","previous":"Anterior","range":"interval","reflectsFilterCondition":"Reflectă condiţia de filtrare","returnToTree":"Întoarcere la arbore","search":"Căutare","searchAllYourData":"Căutaţi toate datele dumneavoastră","setFilterCondition":"Setare condiţie de filtrare","single":"singular","sliderDirections":"Utilizaţi glisorul sau introduceţi un interval de valori","to":"Până la","uniqueValues":"Valori unice","toDate":"Până la data","toTime":"Până la ora","upperRange":"Definiţi un interval","useCheckboxes":"Utilizaţi casetele de bifare de mai jos pentru a selecta ce membri să fie afişaţi.","useCheckboxToMakeTableSelection":"Pentru a face o selecţie, utilizaţi casetele de bifare din arborele sursă."},"__ru":{"addCondition":"Добавить другое условие","addFilterCondition":"Добавить условие фильтра","after":"После","allMembers":"Все члены набора","and":"И","apply":"Применить","ascending":"В восходящем порядке","before":"Перед","beginsWith":"Начинается с","between":"Между","cancel":"Отмена","clearAll":"Очистить все","clearConditions":"Очистить условия","close":"Закрыть","contains":"Содержит","containsExcludedIncludedItems":"Содержит включенные и исключенные элементы","dataTruncation":"Показаны не все элементы.","dateAndTime":"Дата и время","dateOnly":"Только дата","dateValidation":"Проверьте, что дата и/или время \"С\" совпадает или более ранняя, чем дата и/или время \"До\".","descending":"В нисходящем порядке","doesNotBeginWith":"Не начинается с","doesNotContain":"Не содержит","doesNotEndWith":"Не заканчивается на","doesNotEqual":"Не равно","done":"Готово","editCondition":"Изменить условие","endsWith":"Заканчивается на","enterValue":"Ввести значение","equals":"Равно","excludeBlankDate":"Исключить пустую дату","excludeBlankValues":"Исключить пустые значения","fromDate":"Дата начала","fromTime":"С момента","filter":"Фильтр","filterCondition":"Условие фильтра","filter_noSearchResults":"Ваш поиск не возвратил никаких результатов","filter_tryDifferentTerm":"Попробуйте использовать при поиске другой термин","find":"Найти","from":"С","greaterThan":"Больше","highQuality":"Высокое качество","includeBlankDate":"Включить нулевые (null) значения","includeBlankValues":"Включить нулевые (null) значения","individualValues":"Отдельные значения","individualItems":"Выбрать отдельные элементы","invert":"Инверсия","lessThan":"Меньше","loadMore":"Загрузить еще ...","lowQuality":"Низкое качество","matchingCondition":"У элементов, соответствующих этому условию, одинаковые значки","mediumQuality":"Среднее качество","menu":"Меню","missingValues":"Пропущенные значения","newCondition":"Добавить условие","next":"Следующая","noSort":"Без сортировки","notBetween":"Не между","ok":"ОК","or":"Или","previous":"Предыдущее","range":"диапазон","reflectsFilterCondition":"Отражает условие фильтра","returnToTree":"Вернуться в дерево","search":"Поиск","searchAllYourData":"Поиск во всех ваших данных","setFilterCondition":"Задать условие фильтра","single":"один","sliderDirections":"Использовать ползунок или ввести диапазон значений","to":"Кому","uniqueValues":"Уникальные значения","toDate":"Дата завершения","toTime":"До момента","upperRange":"Задать диапазон","useCheckboxes":"Используйте расположенные ниже переключатели, чтобы выбрать членов, которых нужно показать.","useCheckboxToMakeTableSelection":"Используйте переключатели в исходном дереве, чтобы сделать выбор."},"__sl":{"addCondition":"Dodaj še en pogoj","addFilterCondition":"Dodaj pogoj filtra","after":"Po","allMembers":"Vsi člani nabora","and":"In","apply":"Uveljavi","ascending":"Naraščajoče","before":"Pred","beginsWith":"Začne se z","between":"Med","cancel":"Prekliči","clearAll":"Počisti vse","clearConditions":"Počisti pogoje","close":"Zapri","contains":"Vsebuje","containsExcludedIncludedItems":"Vsebuje izključene in vključene postavke","dataTruncation":"Vse postavke niso prikazane.","dateAndTime":"Datum in čas","dateOnly":"Samo datum","dateValidation":"Zagotovite, da je datum in/ali čas v polju \"Od\" enak datumu in/ali času v polju \"Za\" ali pred njim.","descending":"Padajoče","doesNotBeginWith":"Se ne začne z","doesNotContain":"Ne vsebuje","doesNotEndWith":"Se ne konča z","doesNotEqual":"Ni enako","done":"Opravljeno","editCondition":"Urejanje pogoja","endsWith":"Konča se z","enterValue":"Vnesi vrednost","equals":"Je enako","excludeBlankDate":"Izvzemi prazen datum","excludeBlankValues":"Izvzemi prazne vrednosti","fromDate":"Od datuma","fromTime":"Od časa","filter":"Filter","filterCondition":"Pogoj filtra","filter_noSearchResults":"Iskanje ni vrnilo rezultatov","filter_tryDifferentTerm":"Poskusite uporabiti drug iskalni izraz","find":"Najdi","from":"Od","greaterThan":"Večje od","highQuality":"Visoka kakovost","includeBlankDate":"Vključi ničelne vrednosti","includeBlankValues":"Vključi ničelne vrednosti","individualValues":"Posamezne vrednosti","individualItems":"Izberite posamezne postavke","invert":"Obrni","lessThan":"Manjše od","loadMore":"Naloži več ...","lowQuality":"Nizka kakovost","matchingCondition":"Postavke, ki se ujemajo s tem pogojem, imajo podobno ikono","mediumQuality":"Srednja kakovost","menu":"Meni","missingValues":"Manjkajoče vrednosti","newCondition":"Dodaj pogoj","next":"Naprej","noSort":"Brez razvrščanja","notBetween":"Ni med","ok":"V redu","or":"Ali","previous":"Nazaj","range":"obseg","reflectsFilterCondition":"Odraža pogoj filtra","returnToTree":"Nazaj na drevo","search":"Iskanje","searchAllYourData":"Preiščite vse svoje podatke","setFilterCondition":"Pogoj filtra nabora","single":"en sam","sliderDirections":"Uporabite drsnik ali vnesite obseg vrednosti","to":"Za","uniqueValues":"Unikatne vrednosti","toDate":"Do datuma","toTime":"Do časa","upperRange":"Definiraj obseg","useCheckboxes":"S spodnjimi potrditvenimi polji izberite, kateri člani naj bodo prikazani.","useCheckboxToMakeTableSelection":"Za izbor uporabite potrditvena polja v izvornem drevesu."},"__sv":{"addCondition":"Lägg till villkor","addFilterCondition":"Lägg till filtervillkor","after":"Efter","allMembers":"Alla medlemmar i mängden","and":"Och","apply":"Tillämpa","ascending":"Stigande","before":"Före","beginsWith":"Börjar med","between":"Mellan","cancel":"Avbryt","clearAll":"Rensa alla","clearConditions":"Rensa villkor","close":"Stäng","contains":"Innehåller","containsExcludedIncludedItems":"Innehåller exkluderade och inkluderade objekt","dataTruncation":"Alla objekt visas inte.","dateAndTime":"Datum och klockslag","dateOnly":"Endast datum","dateValidation":"Se till att datum och/eller tid för Från är samma som eller infaller tidigare än datum och/eller tid för Till.","descending":"Fallande","doesNotBeginWith":"Börjar inte med","doesNotContain":"Innehåller inte","doesNotEndWith":"Slutar inte med","doesNotEqual":"Är inte lika med","done":"Klart","editCondition":"Ändra villkor","endsWith":"Slutar med","enterValue":"Skriv ett värde","equals":"Lika med","excludeBlankDate":"Exkludera tomt datum","excludeBlankValues":"Exkludera tomma värden","fromDate":"Från datum","fromTime":"Från klockslag","filter":"Filter","filterCondition":"Filtervillkor","filter_noSearchResults":"Sökningen gav inte något resultat.","filter_tryDifferentTerm":"Försök med en annan sökterm","find":"Sök","from":"Från","greaterThan":"Större än","highQuality":"Hög kvalitet","includeBlankDate":"Inkludera nullvärden","includeBlankValues":"Inkludera nullvärden","individualValues":"Individuella värden","individualItems":"Välj enskilda objekt","invert":"Invertera","lessThan":"Mindre än","loadMore":"Läs in mer...","lowQuality":"Låg kvalitet","matchingCondition":"Objekt som matchar villkoret har en liknande ikon","mediumQuality":"Medelbra kvalitet","menu":"Meny","missingValues":"Saknade värden","newCondition":"Lägg till villkor","next":"Nästa","noSort":"Ingen sortering","notBetween":"Inte mellan","ok":"OK","or":"Eller","previous":"Föregående","range":"intervall","reflectsFilterCondition":"Avspeglar filtervillkor","returnToTree":"Återgå till träd","search":"Sök","searchAllYourData":"Sök i alla data","setFilterCondition":"Ange filtervillkor","single":"enskild","sliderDirections":"Använd skjutreglaget eller ange ett värdeintervall","to":"Till","uniqueValues":"Unika värden","toDate":"Till datum","toTime":"Till klockslag","upperRange":"Definiera ett intervall","useCheckboxes":"Använd kryssrutorna för att välja vilka medlemmar som ska visas.","useCheckboxToMakeTableSelection":"Använd kryssrutorna i källträdet för att välja."},"__th":{"addCondition":"เพิ่มเงื่อนไขอื่น","addFilterCondition":"เพิ่มเงื่อนไขการกรอง","after":"หลังจาก","allMembers":"สมาชิกทั้งหมดของชุด","and":"And","apply":"ใช้","ascending":"น้อยไปหามาก","before":"ก่อน","beginsWith":"เริ่มต้นด้วย","between":"ระหว่าง","cancel":"ยกเลิก","clearAll":"เคลียร์ทั้งหมด","clearConditions":"เคลียร์เงื่อนไข","close":"ปิด","contains":"มี","containsExcludedIncludedItems":"มีไอเท็มที่รวมและไม่รวม","dataTruncation":"ไม่ใช่ไอเท็มทั้งหมดที่สามารถแสดงได้","dateAndTime":"วันที่และเวลา","dateOnly":"วันที่เท่านั้น","dateValidation":"ให้แน่ใจว่าวันที่ และ/หรือ เวลาของ \"จาก\" เหมือนกันหรือก่อนหน้าวันที่ และ/หรือ เวลาของ \"ถึง\"","descending":"จากมากไปหาน้อย","doesNotBeginWith":"ไม่เริ่มต้นด้วย","doesNotContain":"ไม่มี","doesNotEndWith":"ไม่ลงท้ายด้วย","doesNotEqual":"ไม่เท่ากับ","done":"เสร็จสิ้น","editCondition":"แก้ไขเงื่อนไข","endsWith":"ลงท้ายด้วย","enterValue":"ป้อนค่า","equals":"เท่ากับ","excludeBlankDate":"แยกวันที่ว่าง","excludeBlankValues":"แยกค่าที่ว่าง","fromDate":"จากวันที่","fromTime":"จากเวลา","filter":"ตัวกรอง","filterCondition":"เงื่อนไขตัวกรอง","filter_noSearchResults":"การค้นหาของคุณไม่ส่งคืนผลลัพธ์","filter_tryDifferentTerm":"โปรดลองเงื่อนไขการค้นหาอื่นอีกครั้ง","find":"ค้นหา","from":"จาก","greaterThan":"มากกว่า","highQuality":"คุณภาพสูง","includeBlankDate":"รวมค่า null","includeBlankValues":"รวมค่า null","individualValues":"แต่ละค่า","individualItems":"เลือกแต่ละไอเท็ม","invert":"กลับ","lessThan":"น้อยกว่า","loadMore":"โหลดเพิ่มเติม ...","lowQuality":"คุณภาพต่ำ","matchingCondition":"ไอเท็มที่ตรงกับเงื่อนไขนี้มีไอคอนเหมือนกัน","mediumQuality":"คุณภาพปานกลาง","menu":"Menu","missingValues":"ค่าที่หายไป","newCondition":"เพิ่มเงื่อนไข","next":"ถัดไป","noSort":"ไม่เรียงลำดับ","notBetween":"ไม่ได้อยู่ระหว่าง","ok":"ตกลง","or":"Or","previous":"ก่อนหน้า","range":"ช่วง","reflectsFilterCondition":"สะท้อนสภาพตัวกรอง","returnToTree":"กลับสู่แผนผัง","search":"ค้นหา","searchAllYourData":"ค้นหาข้อมูลของคุณทั้งหมด","setFilterCondition":"ตั้งค่าเงื่อนไขตัวกรอง","single":"เดี่ยว","sliderDirections":"ใช้ตัวเลื่อนหรือป้อนช่วงของค่า","to":"ถึง","uniqueValues":"ค่าเฉพาะ","toDate":"ถึงวันที่","toTime":"ถึงเวลา","upperRange":"กำหนดช่วง","useCheckboxes":"ใช้เช็กบ็อกซ์ด้านล่างเพื่อเลือกสมาชิกที่ต้องการแสดง","useCheckboxToMakeTableSelection":"ใช้เช็กบ็อกซ์ในแผนผังต้นทางในการเลือก"},"__tr":{"addCondition":"Başka bir koşul ekle","addFilterCondition":"Süzgeç koşulu ekle","after":"Sonra","allMembers":"Kümenin tüm üyeleri","and":"Ve","apply":"Uygula","ascending":"Artan","before":"Önce","beginsWith":"Şununla başlar","between":"Arasında","cancel":"İptal","clearAll":"Tümünü temizle","clearConditions":"Koşulları temizle","close":"Kapat","contains":"İçerir","containsExcludedIncludedItems":"Hariç tutulan ve dahil edilen öğeler içerir","dataTruncation":"Tüm öğeler gösterilemez.","dateAndTime":"Tarih ve saat","dateOnly":"Yalnızca tarih","dateValidation":"\"İlk\" tarihin ve/veya saatin, \"Son\" tarih ve/veya saatle aynı ya da bunlardan önce olduğundan emin olun.","descending":"Azalan","doesNotBeginWith":"Şununla başlamaz","doesNotContain":"İçermez","doesNotEndWith":"Şununla bitmez","doesNotEqual":"Eşit değildir","done":"Bitti","editCondition":"Koşulu düzenle","endsWith":"Şununla biter","enterValue":"Bir değer girin","equals":"Eşittir","excludeBlankDate":"Boş tarihi hariç tut","excludeBlankValues":"Boş değerleri hariç tut","fromDate":"Başlangıç Tarihi","fromTime":"Başlangıç Saati","filter":"Süzgeç","filterCondition":"Süzgeç koşulu","filter_noSearchResults":"Aramanız bir sonuç döndürmedi","filter_tryDifferentTerm":"Lütfen farklı bir arama terimi deneyin","find":"Bul","from":"Başlangıç","greaterThan":"Büyüktür","highQuality":"Yüksek Kalite","includeBlankDate":"Boş değerleri dahil et","includeBlankValues":"Boş değerleri dahil et","individualValues":"Tekli değerler","individualItems":"Tek tek öğeleri seçin","invert":"Ters Çevir","lessThan":"Küçüktür","loadMore":"Daha fazlasını yükle...","lowQuality":"Düşük Kalite","matchingCondition":"Bu koşulla eşleşen öğeler benzer bir simgeye sahiptir","mediumQuality":"Orta Kalite","menu":"Menü","missingValues":"Değerler Eksik","newCondition":"Koşul ekle","next":"İleri","noSort":"Sıralama yok","notBetween":"Arasında değil","ok":"Tamam","or":"Veya","previous":"Önceki","range":"aralık","reflectsFilterCondition":"Süzgeç koşulunu belirtir","returnToTree":"Ağaca geri dön","search":"Ara","searchAllYourData":"Tüm verilerinizde arayın","setFilterCondition":"Süzgeç koşulunu ayarla","single":"tek","sliderDirections":"Kaydırıcıyı kullanın veya bir değer aralığı girin","to":"Bitiş","uniqueValues":"Benzersiz Değerler","toDate":"Bitiş Tarihi","toTime":"Bitiş Saati","upperRange":"Aralık tanımlayın","useCheckboxes":"Görüntülenecek üyeleri seçmek için aşağıdaki onay kutularını kullanın.","useCheckboxToMakeTableSelection":"Seçim yapmak için kaynak ağacındaki onay kutularını kullanın."},"__zh":{"addCondition":"添加其他条件","addFilterCondition":"添加过滤条件","after":"之后","allMembers":"集的所有成员","and":"和","apply":"应用","ascending":"升序","before":"之前","beginsWith":"开头为","between":"两者之间","cancel":"取消","clearAll":"全部清除","clearConditions":"清除条件","close":"关闭","contains":"包含","containsExcludedIncludedItems":"包含排除的项和包含的项","dataTruncation":"未显示所有项。","dateAndTime":"日期和时间","dateOnly":"仅日期","dateValidation":"确保“开始”日期和/或时间与“结束”日期和/或时间相同，或早于“结束”日期和/或时间。","descending":"降序","doesNotBeginWith":"开头不是","doesNotContain":"不包含","doesNotEndWith":"结尾不是","doesNotEqual":"不等于","done":"完成","editCondition":"编辑条件","endsWith":"结尾为","enterValue":"输入值","equals":"等于","excludeBlankDate":"排除空白日期","excludeBlankValues":"排除空白值","fromDate":"开始日期","fromTime":"开始时间","filter":"过滤器","filterCondition":"过滤条件","filter_noSearchResults":"您的搜索未返回任何结果","filter_tryDifferentTerm":"请尝试其他搜索项","find":"查找","from":"自","greaterThan":"大于","highQuality":"高质量","includeBlankDate":"包含空值","includeBlankValues":"包含空值","individualValues":"单个值","individualItems":"选择单个项","invert":"反转","lessThan":"小于","loadMore":"装入更多...","lowQuality":"低质量","matchingCondition":"匹配此条件的项具有相似的图标","mediumQuality":"中等质量","menu":"菜单","missingValues":"缺失值","newCondition":"添加条件","next":"下一步","noSort":"不排序","notBetween":"不在两者之间","ok":"确定","or":"或","previous":"上一页","range":"范围","reflectsFilterCondition":"反应过滤条件","returnToTree":"返回至树","search":"搜索","searchAllYourData":"搜索所有数据","setFilterCondition":"设置过滤条件","single":"单个","sliderDirections":"使用滑块或输入值的范围","to":"到","uniqueValues":"唯一值","toDate":"结束日期","toTime":"结束时间","upperRange":"定义范围","useCheckboxes":"使用以下复选框来选择要显示的成员。","useCheckboxToMakeTableSelection":"使用源树中的复选框进行选择。"},"__zh-cn":{"addCondition":"添加其他条件","addFilterCondition":"添加过滤条件","after":"之后","allMembers":"集的所有成员","and":"和","apply":"应用","ascending":"升序","before":"之前","beginsWith":"开头为","between":"两者之间","cancel":"取消","clearAll":"全部清除","clearConditions":"清除条件","close":"关闭","contains":"包含","containsExcludedIncludedItems":"包含排除的项和包含的项","dataTruncation":"未显示所有项。","dateAndTime":"日期和时间","dateOnly":"仅日期","dateValidation":"确保“开始”日期和/或时间与“结束”日期和/或时间相同，或早于“结束”日期和/或时间。","descending":"降序","doesNotBeginWith":"开头不是","doesNotContain":"不包含","doesNotEndWith":"结尾不是","doesNotEqual":"不等于","done":"完成","editCondition":"编辑条件","endsWith":"结尾为","enterValue":"输入值","equals":"等于","excludeBlankDate":"排除空白日期","excludeBlankValues":"排除空白值","fromDate":"开始日期","fromTime":"开始时间","filter":"过滤器","filterCondition":"过滤条件","filter_noSearchResults":"您的搜索未返回任何结果","filter_tryDifferentTerm":"请尝试其他搜索项","find":"查找","from":"自","greaterThan":"大于","highQuality":"高质量","includeBlankDate":"包含空值","includeBlankValues":"包含空值","individualValues":"单个值","individualItems":"选择单个项","invert":"反转","lessThan":"小于","loadMore":"装入更多...","lowQuality":"低质量","matchingCondition":"匹配此条件的项具有相似的图标","mediumQuality":"中等质量","menu":"菜单","missingValues":"缺失值","newCondition":"添加条件","next":"下一步","noSort":"不排序","notBetween":"不在两者之间","ok":"确定","or":"或","previous":"上一页","range":"范围","reflectsFilterCondition":"反应过滤条件","returnToTree":"返回至树","search":"搜索","searchAllYourData":"搜索所有数据","setFilterCondition":"设置过滤条件","single":"单个","sliderDirections":"使用滑块或输入值的范围","to":"到","uniqueValues":"唯一值","toDate":"结束日期","toTime":"结束时间","upperRange":"定义范围","useCheckboxes":"使用以下复选框来选择要显示的成员。","useCheckboxToMakeTableSelection":"使用源树中的复选框进行选择。"},"__zh-tw":{"addCondition":"新增另一個條件","addFilterCondition":"新增過濾器條件","after":"之後","allMembers":"集內的全部成員","and":"和","apply":"套用","ascending":"遞增","before":"之前","beginsWith":"開始於","between":"介於","cancel":"取消","clearAll":"全部清除","clearConditions":"清除條件","close":"關閉","contains":"包含","containsExcludedIncludedItems":"包含已排除及包括的項目","dataTruncation":"並非所有的項目都會顯示。","dateAndTime":"日期和時間","dateOnly":"僅日期","dateValidation":"請確定「開始」日期及（或）時間相同於或早於「結束」日期及（或）時間。","descending":"遞減","doesNotBeginWith":"不是開始於","doesNotContain":"不包含","doesNotEndWith":"不是結束於","doesNotEqual":"不等於","done":"完成","editCondition":"編輯條件","endsWith":"結束於","enterValue":"輸入值","equals":"等於","excludeBlankDate":"排除空白日期","excludeBlankValues":"排除空白值","fromDate":"起始日期","fromTime":"起始時間","filter":"過濾","filterCondition":"過濾條件","filter_noSearchResults":"您的搜尋未傳回任何結果","filter_tryDifferentTerm":"請嘗試不同的搜尋詞彙","find":"尋找","from":"從","greaterThan":"大於","highQuality":"高品質","includeBlankDate":"包括空值","includeBlankValues":"包括空值","individualValues":"個別值","individualItems":"選取個別項目","invert":"反轉","lessThan":"小於","loadMore":"載入其他項目 ...","lowQuality":"低品質","matchingCondition":"符合此條件的項目具有相同的圖示","mediumQuality":"中等品質","menu":"功能表","missingValues":"遺漏值","newCondition":"新增條件","next":"下一步","noSort":"不排序","notBetween":"不介於","ok":"確定","or":"或","previous":"前一個","range":"範圍","reflectsFilterCondition":"反映過濾器條件","returnToTree":"返回至樹狀結構","search":"搜尋","searchAllYourData":"搜尋所有資料","setFilterCondition":"設定過濾器條件","single":"單一","sliderDirections":"使用滑塊或是輸入值範圍","to":"到","uniqueValues":"唯一的值","toDate":"結束日期","toTime":"結束時間","upperRange":"定義範圍","useCheckboxes":"使用下列勾選框來選取要顯示的成員。","useCheckboxToMakeTableSelection":"使用來源樹狀結構中的勾選框以進行選取。"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(60);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-button.is-disabled{border:none}\n", ""]);

// exports


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/coach-mark_16.js");

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/close_16.js");

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32.js");

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/edit_32.js");

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/search_16.js");

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(67);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-filterHeaderTitle .ba-common-dialog__header{padding-left:0px}.bi-filter-compact-filter-title .ba-common-dialog__header{padding-left:0px}.bi-common-filterHeaderTitle .ba-common-dialog__subtitle{padding-left:0px}.bi-filter-compact-filter-title .ba-common-dialog__subtitle{padding-left:0px}\n", ""]);

// exports


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-range-type-drop-down .bi-common-button{color:black !important;border-color:#c0bfc0 !important;background-color:white !important}\n", ""]);

// exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(72);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-mui-dateTimeFilter__box{border-style:solid;border-width:1px;border-color:#eaeaea}.bi-mui-dateTimeFilter__validation{color:#e62325}\n", ""]);

// exports


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/illustrations-js/search-results_128.js");

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(75);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-filter-list-item-path{color:gray}\n", ""]);

// exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(77);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".wft_calendar:before{color:#595859}.timepicker_icon .svgIcon{fill:#595859 !important}\n", ""]);

// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(79);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-filter-numeric-pane__instructions{font-size:12px}.bi-filter-numeric-pane .ba-common-slider__container.is-boundaryLabelled{margin:0px}\n", ""]);

// exports


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/add_32.js");

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(82);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-filter-setFilterCondition .ba-common-dialog__header{padding-left:0px;padding-top:16px}\n", ""]);

// exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(84);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-filter-summary{background-color:#f2f2f2;font-size:smaller}.bi-filter-summary .ba-common-dialog__header{padding-left:0px;font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;color:#161616;color:hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1)}.bi-filter-summary .bi-filter-summary-desc{font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;color:#525252;color:hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n", ""]);

// exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(86);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-filter-condition-builder{cursor:pointer}.bi-filter-condition-builder .bi-filter-condition-builder-container{position:relative}.popover.bi-react-ui-common-popover{max-width:320px}\n", ""]);

// exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(88);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-filter-select-value :hover svg.common-chevron_right{fill:white}\n", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(90);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(16)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".bi-common-NonNumericFilter .ba-common-toggleSwitch.is-right{padding:24px 24px 0 24px}.bi-common-NonNumericFilter .ba-common-toggleSwitch__box{float:right}\n", ""]);

// exports


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var filterProps_namespaceObject = {};
__webpack_require__.r(filterProps_namespaceObject);
__webpack_require__.d(filterProps_namespaceObject, "FILTER_TYPE", function() { return FILTER_TYPE; });
__webpack_require__.d(filterProps_namespaceObject, "FILTER_RANGE_TYPE", function() { return FILTER_RANGE_TYPE; });
__webpack_require__.d(filterProps_namespaceObject, "FILTER_RANGE_SUBTYPE", function() { return FILTER_RANGE_SUBTYPE; });
__webpack_require__.d(filterProps_namespaceObject, "COMMON_FILTER_PROPS", function() { return COMMON_FILTER_PROPS; });

// EXTERNAL MODULE: external "./context"
var external_context_ = __webpack_require__(4);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(8);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "@ba/ba-ui-carbon-toolkit"
var ba_ui_carbon_toolkit_ = __webpack_require__(12);

// EXTERNAL MODULE: ./src/nls/StringResource.js
var StringResource = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/amdi18n-loader!./src/filters/nls/FilterResources.js
var FilterResources = __webpack_require__(58);
var FilterResources_default = /*#__PURE__*/__webpack_require__.n(FilterResources);

// CONCATENATED MODULE: ./src/filters/nls/StringResource.js
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-common
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

 // eslint-disable-line

/* harmony default export */ var nls_StringResource = (new StringResource["default"](FilterResources_default.a));
// CONCATENATED MODULE: ./src/filters/filterProps.ts
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

const FILTER_TYPE = Object.freeze({
  RANGE: 'range',
  SELECT_VALUE: 'selectValue'
});
const FILTER_RANGE_TYPE = Object.freeze({
  AFTER: 'after',
  BEFORE: 'before',
  BETWEEN: 'between',
  NOT_BETWEEN: 'not between'
});
const FILTER_RANGE_SUBTYPE = Object.freeze({
  DATE_AND_TIME: 'date and time',
  DATE_ONLY: 'date only'
});
const COMMON_FILTER_PROPS = Object.freeze({
  // Tree props.
  getValue: external_prop_types_default.a.func.isRequired,
  getNumberOfChildren: external_prop_types_default.a.func.isRequired,
  getLimitChildren: external_prop_types_default.a.func,
  onExpandCollapse: external_prop_types_default.a.func.isRequired,
  onClick: external_prop_types_default.a.func.isRequired,
  onLoadMore: external_prop_types_default.a.func,
  contentRenderer: external_prop_types_default.a.func,
  limitChildren: external_prop_types_default.a.number,
  onInvert: external_prop_types_default.a.func.isRequired,
  selectedValuesCount: external_prop_types_default.a.number,
  // List props.
  listOnClick: external_prop_types_default.a.func,
  listGetValue: external_prop_types_default.a.func,
  listGetNumberOfChildren: external_prop_types_default.a.func,
  listContentRenderer: external_prop_types_default.a.func,
  listOnInvert: external_prop_types_default.a.func,
  showSubcaption: external_prop_types_default.a.bool.isRequired,
  readOnly: external_prop_types_default.a.bool
});
// EXTERNAL MODULE: ./src/filters/ApplyButton.scss
var filters_ApplyButton = __webpack_require__(59);

// CONCATENATED MODULE: ./src/filters/ApplyButton.tsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





/*
Render a full width 'Apply' button which is used by all the compact filters.
*/

class ApplyButton_ApplyButton extends external_react_["Component"] {
  // Define properties and types
  render() {
    const {
      dirty,
      onApply,
      loading,
      readOnly
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      "data-tid": "applyClickable",
      fullWidth: true,
      title: nls_StringResource.get('apply'),
      "aria-label": nls_StringResource.get('apply'),
      intent: dirty ? 'primary' : 'secondary',
      size: "small",
      onClick: onApply,
      disabled: loading || readOnly || !dirty
    }, nls_StringResource.get('apply'));
  }

}

_defineProperty(ApplyButton_ApplyButton, "propTypes", {
  dirty: external_prop_types_default.a.bool.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  loading: external_prop_types_default.a.bool.isRequired,
  readOnly: external_prop_types_default.a.bool.isRequired
});
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(34);
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/coach-mark_16.js"
var coach_mark_16_js_ = __webpack_require__(61);
var coach_mark_16_js_default = /*#__PURE__*/__webpack_require__.n(coach_mark_16_js_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/close_16.js"
var close_16_js_ = __webpack_require__(62);
var close_16_js_default = /*#__PURE__*/__webpack_require__.n(close_16_js_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32.js"
var overflow_menu_horizontal_32_js_ = __webpack_require__(63);
var overflow_menu_horizontal_32_js_default = /*#__PURE__*/__webpack_require__.n(overflow_menu_horizontal_32_js_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/edit_32.js"
var edit_32_js_ = __webpack_require__(64);
var edit_32_js_default = /*#__PURE__*/__webpack_require__.n(edit_32_js_);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/search_16.js"
var search_16_js_ = __webpack_require__(65);
var search_16_js_default = /*#__PURE__*/__webpack_require__.n(search_16_js_);

// CONCATENATED MODULE: ./src/utils/tid.js
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
function getTid(file, suffix, prefix) {
  return `${prefix || 'mui'}-${file}${suffix ? `-${suffix}` : ''}`;
}
// EXTERNAL MODULE: ./src/filters/FilterHeader.scss
var filters_FilterHeader = __webpack_require__(66);

// CONCATENATED MODULE: ./src/filters/FilterHeader.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FilterHeader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-find-dom-node */

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */












class FilterHeader_FilterHeader extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FilterHeader_defineProperty(this, "state", {
      menuOpen: false
    });

    FilterHeader_defineProperty(this, "_menuButton", void 0);

    FilterHeader_defineProperty(this, "_renderMenuItem", (index, props) => /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ListItem"], props, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: this.props.menu[index].label || '',
      "data-tid": `menuItem${index}`
    })));

    FilterHeader_defineProperty(this, "_onSelectionChange", event => {
      // Get the item
      const item = this.props.menu[event.index]; // Focus the '...' button

      this._menuButton.focus(); // Fire the menu action


      item.fn && item.fn();
      this.setState({
        menuOpen: false
      });
    });

    FilterHeader_defineProperty(this, "_renderMenu", () => {
      const {
        menu,
        readOnly
      } = this.props;

      if (this.state.menuOpen && menu && menu.length > 0) {
        return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Flyout"], {
          placement: "bottom",
          onClose: () => this.setState({
            menuOpen: false
          }),
          triggerNode: external_react_dom_default.a.findDOMNode(this._menuButton),
          domNodeToAttachTo: external_react_dom_default.a.findDOMNode(this._menuButton).parentNode
        }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
          "data-tid": getTid('filterHeader', 'menuSection'),
          minWidth: 200
        }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["List"], {
          length: menu.length,
          itemRenderer: this._renderMenuItem,
          selectionMode: "single",
          listType: "uniform",
          onSelectionChange: this._onSelectionChange,
          readOnly: readOnly
        })));
      }

      return null;
    });

    FilterHeader_defineProperty(this, "_onMenu", () => {
      this.setState({
        menuOpen: !this.state.menuOpen
      });
      this.props.onMenu && this.props.onMenu();
    });

    FilterHeader_defineProperty(this, "_renderMenuIcon", props => /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], _extends({
      icon: this.props.isMenuEditButton ? edit_32_js_default.a : overflow_menu_horizontal_32_js_default.a
    }, props)));
  }

  focus() {
    if (this.props.showMenu) {
      this._menuButton.focus();
    }
  }

  render() {
    const {
      title,
      actionTitle,
      showSearch,
      showClose,
      showMenu,
      onClose,
      menuTitle,
      onSearch,
      loading,
      height,
      readOnly,
      showMatchCondition,
      menuButtonPressed,
      menuButtonDescribedby
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      alignItems: "center",
      direction: "row",
      "data-tid": getTid('filterHeader', 'filterHeader'),
      height: height
    }, showMatchCondition && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [0.5, 0.5, 2, 0.5]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Tooltip"], {
      "data-tid": getTid('filterHeader', 'matchingConditionTooltip'),
      title: nls_StringResource.get('matchingCondition'),
      focusable: true
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
      iconId: coach_mark_16_js_default.a.id,
      intent: "positive",
      width: 8,
      height: 8,
      style: {
        'vertical-align': 'baseline'
      }
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true
    }, actionTitle && actionTitle.length && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      alignItems: "flex-start",
      direction: "column",
      "data-tid": getTid('filterHeader', 'filterHeaderTitle'),
      className: "bi-common-filterHeaderTitle",
      height: height * 2
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].SubHeader, {
      "data-tid": getTid('filterHeader', 'title')
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: title
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Header, {
      "data-tid": getTid('filterHeader', 'actionTitle')
    }, actionTitle))), !(actionTitle && actionTitle.length) && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Header, {
      "data-tid": getTid('filterHeader', 'title')
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: title
    })))), showSearch && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: [0, 1, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      "data-tid": getTid('filterHeader', 'searchClickable'),
      onClick: onSearch,
      title: nls_StringResource.get('search'),
      "aria-label": nls_StringResource.get('search'),
      variant: "inline",
      icon: /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
        iconId: search_16_js_default.a.id,
        size: "small"
      }),
      disabled: loading || readOnly
    })), showMenu && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      "data-tid": getTid('filterHeader', 'menuClickable'),
      ref: btn => {
        this._menuButton = btn;
      },
      onClick: this._onMenu,
      iconDescription: menuTitle || nls_StringResource.get('menu'),
      "data-selector": "true",
      kind: "ghost",
      hasIconOnly: true,
      size: "small",
      renderIcon: props => this._renderMenuIcon(props),
      tooltipPosition: "left",
      disabled: loading || readOnly,
      "aria-pressed": menuButtonPressed,
      "aria-describedby": menuButtonDescribedby
    }), this._renderMenu()), showClose && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      "data-tid": getTid('filterHeader', 'closeClickable'),
      onClick: onClose,
      title: nls_StringResource.get('close'),
      "aria-label": nls_StringResource.get('close'),
      variant: "icon",
      icon: /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
        iconId: close_16_js_default.a.id,
        size: "small"
      })
    })));
  }

}

FilterHeader_defineProperty(FilterHeader_FilterHeader, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  actionTitle: external_prop_types_default.a.string,
  onSearch: external_prop_types_default.a.func,
  onClose: external_prop_types_default.a.func,
  onMenu: external_prop_types_default.a.func,
  showSearch: external_prop_types_default.a.bool,
  showClose: external_prop_types_default.a.bool,
  showMenu: external_prop_types_default.a.bool,
  menuTitle: external_prop_types_default.a.string,
  menu: external_prop_types_default.a.array,
  menuButtonPressed: external_prop_types_default.a.bool,
  menuButtonDescribedby: external_prop_types_default.a.string,
  loading: external_prop_types_default.a.bool,
  height: external_prop_types_default.a.number,
  readOnly: external_prop_types_default.a.bool,
  showMatchCondition: external_prop_types_default.a.bool,
  isMenuEditButton: external_prop_types_default.a.bool
});

FilterHeader_defineProperty(FilterHeader_FilterHeader, "defaultProps", {
  showSearch: true,
  isMenuEditButton: false,
  showMenu: true,
  showClose: false,
  menu: [],
  loading: false,
  height: 32,
  readOnly: false,
  showMatchCondition: false
});
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(68);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// CONCATENATED MODULE: ./src/filters/FilterTypeSelector.tsx
function FilterTypeSelector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */






class FilterTypeSelector_FilterTypeSelector extends external_react_["Component"] {
  // Define properties and types
  // Define default property values
  render() {
    const {
      type,
      onChange,
      readOnly
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "row"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [0, 2, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Radio"], {
      name: "filterType",
      direction: "horizontal",
      align: "left",
      label: nls_StringResource.get('upperRange'),
      value: "range",
      checked: type === FILTER_TYPE.RANGE,
      onChange: onChange,
      readOnly: readOnly,
      "data-tid": getTid('filterTypeSelector', 'filterTypeRange')
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true
    }), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Radio"], {
      name: "filterType",
      direction: "horizontal",
      align: "left",
      label: nls_StringResource.get('individualItems'),
      value: "selectValue",
      checked: type === FILTER_TYPE.SELECT_VALUE,
      onChange: onChange,
      readOnly: readOnly,
      "data-tid": getTid('filterTypeSelector', 'filterTypeSelectValue')
    })));
  }

}

FilterTypeSelector_defineProperty(FilterTypeSelector_FilterTypeSelector, "propTypes", {
  onChange: external_prop_types_default.a.func.isRequired,
  type: external_prop_types_default.a.oneOf([FILTER_TYPE.SELECT_VALUE, FILTER_TYPE.RANGE]).isRequired,
  readOnly: external_prop_types_default.a.bool
});

FilterTypeSelector_defineProperty(FilterTypeSelector_FilterTypeSelector, "defaultProps", {
  onChange: null,
  type: FILTER_TYPE.RANGE,
  readOnly: false
});
// CONCATENATED MODULE: ./src/constants/featureFlags.ts
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * A flag should be defined for features that require enablement in production only
 * when complete. Once the feature is complete and ready to be exposed in production
 * the flag should be deleted and the code that uses older logic must be deleted
 */
const FILTERS_FLAG = {
  name: 'filtersFlag',
  enabled: true
};
// CONCATENATED MODULE: ./src/utils/featureFlags.ts
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

let devModeForced = false;
function forceDevMode(value) {
  devModeForced = value;
}
/**
 * Check if a feature is enabled.
 *
 * @param {FeatureFlag} feature - the feature to check;
 *
 * @return true if we're in dev mode and feature is defined or if feature is enabled with glass featureChecker service, false otherwise
 */

function isFeatureEnabled(feature) {
  const isEnabled = !!(feature && external_context_["isFeatureEnabled"](feature.name));
  return !!(devModeForced || external_context_["isDevInstall"]()) || isEnabled;
}
// EXTERNAL MODULE: ./src/filters/DateTimeRangeTypeSelector.scss
var filters_DateTimeRangeTypeSelector = __webpack_require__(69);

// CONCATENATED MODULE: ./src/filters/DateTimeRangeTypeSelector.tsx
function DateTimeRangeTypeSelector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */









class DateTimeRangeTypeSelector_DateTimeRangeTypeSelector extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    DateTimeRangeTypeSelector_defineProperty(this, "_onRangeTypeChanged", e => {
      this.props.onChangeRangeType(e);
    });

    DateTimeRangeTypeSelector_defineProperty(this, "_onRangeSubtypeChanged", e => {
      this.props.onChangeRangeSubtype(e);
    });

    DateTimeRangeTypeSelector_defineProperty(this, "_findLabel", (options, type) => {
      const label = type ? options.find(o => o.value === type).value : options[0].value;
      return label;
    });
  }

  render() {
    const {
      rangeType,
      rangeSubtype,
      readOnly,
      validRangeTypeOptions
    } = this.props;

    const rangeTypeLabel = this._findLabel(DateTimeRangeTypeSelector_DateTimeRangeTypeSelector.rangeTypeOptions, rangeType);

    const rangeSubtypeLabel = this._findLabel(DateTimeRangeTypeSelector_DateTimeRangeTypeSelector.rangeSubtypeOptions, rangeSubtype);

    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "row",
      "data-tid": getTid('dateTimeRangeTypeSelector', 'dateTimeRangeSection')
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: [1, 0, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-range-type-drop-down"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Select"], {
      light: true,
      onChange: this._onRangeTypeChanged,
      size: "small",
      ellipsis: false,
      truncated: false,
      fullWidth: true,
      selected: rangeTypeLabel,
      options: validRangeTypeOptions || DateTimeRangeTypeSelector_DateTimeRangeTypeSelector.rangeTypeOptions,
      readOnly: readOnly,
      "data-tid": getTid('dateTimeRangeTypeSelector', 'rangeTypeDropDown')
    }))), isFeatureEnabled(FILTERS_FLAG) && rangeSubtype && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: [1, 0, 0, 1]
    }, /*#__PURE__*/external_react_default.a.createElement("div", {
      className: "bi-common-range-type-drop-down"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Select"], {
      light: true,
      onChange: this._onRangeSubtypeChanged,
      size: "small",
      ellipsis: false,
      truncated: false,
      fullWidth: true,
      selected: rangeSubtypeLabel,
      options: validRangeTypeOptions || DateTimeRangeTypeSelector_DateTimeRangeTypeSelector.rangeTypeOptions,
      readOnly: readOnly,
      "data-tid": getTid('dateTimeRangeTypeSelector', 'rangeSubtypeDropDown')
    }))));
  }

}

DateTimeRangeTypeSelector_defineProperty(DateTimeRangeTypeSelector_DateTimeRangeTypeSelector, "propTypes", {
  rangeType: external_prop_types_default.a.oneOf([FILTER_RANGE_TYPE.BEFORE, FILTER_RANGE_TYPE.BETWEEN, FILTER_RANGE_TYPE.AFTER, FILTER_RANGE_TYPE.NOT_BETWEEN]),
  onChangeRangeType: external_prop_types_default.a.func.isRequired,
  rangeSubtype: external_prop_types_default.a.oneOf([FILTER_RANGE_SUBTYPE.DATE_AND_TIME, FILTER_RANGE_SUBTYPE.DATE_ONLY]),
  onChangeRangeSubtype: external_prop_types_default.a.func.isRequired,
  readOnly: external_prop_types_default.a.bool,
  validRangeTypeOptions: external_prop_types_default.a.array
});

DateTimeRangeTypeSelector_defineProperty(DateTimeRangeTypeSelector_DateTimeRangeTypeSelector, "rangeTypeOptions", [{
  value: FILTER_RANGE_TYPE.BEFORE,
  label: nls_StringResource.get('before')
}, {
  value: FILTER_RANGE_TYPE.BETWEEN,
  label: nls_StringResource.get('between')
}, {
  value: FILTER_RANGE_TYPE.AFTER,
  label: nls_StringResource.get('after')
}, {
  value: FILTER_RANGE_TYPE.NOT_BETWEEN,
  label: nls_StringResource.get('notBetween')
}]);

DateTimeRangeTypeSelector_defineProperty(DateTimeRangeTypeSelector_DateTimeRangeTypeSelector, "rangeSubtypeOptions", [{
  value: FILTER_RANGE_SUBTYPE.DATE_AND_TIME,
  label: nls_StringResource.get('dateAndTime')
}, {
  value: FILTER_RANGE_SUBTYPE.DATE_ONLY,
  label: nls_StringResource.get('dateOnly')
}]);
// CONCATENATED MODULE: ./src/filters/DateTimePane.tsx
function DateTimePane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */






class DateTimePane_DateTimePane extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    DateTimePane_defineProperty(this, "state", {
      time: external_moment_default()(this.props.inputTime, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT),
      date: external_moment_default()(this.props.inputDate, DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT)
    });

    DateTimePane_defineProperty(this, "getDate", () => {
      const {
        date
      } = this.state;

      if (date && date.isValid()) {
        date.format(DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT);
      }

      return null;
    });

    DateTimePane_defineProperty(this, "getTime", () => {
      const {
        time
      } = this.state;

      if (time && time.isValid()) {
        time.format(DateTimeFilter_DateTimeFilter.ISO_TIME_FORMAT);
      }

      return null;
    });

    DateTimePane_defineProperty(this, "_onDateChange", date => {
      this.setState({
        date
      });

      if (date && date.isValid()) {
        this.props.onDateChange(date.format(DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT));
      }
    });

    DateTimePane_defineProperty(this, "_onTimeChange", time => {
      this.setState({
        time
      });

      if (time && time.isValid()) {
        this.props.onTimeChange(time.format(DateTimeFilter_DateTimeFilter.ISO_TIME_FORMAT));
      }
    });

    DateTimePane_defineProperty(this, "_renderDate", () => {
      const {
        locale,
        readOnly
      } = this.props;
      const {
        date
      } = this.state;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        "data-tid": getTid('dateTimePane', 'datePickerSection')
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SingleDatepicker"], {
        light: true,
        locale: locale,
        date: date,
        onChange: this._onDateChange,
        disabled: readOnly,
        numberOfMonths: 1
      }));
    });

    DateTimePane_defineProperty(this, "_renderTime", () => {
      const {
        locale,
        readOnly
      } = this.props;
      const {
        time
      } = this.state;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        "data-tid": getTid('dateTimePane', 'timePickerSection')
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TimePicker"], {
        locale: locale,
        time: time,
        onChange: this._onTimeChange,
        disabled: readOnly,
        showSec: true,
        light: true
      }));
    });

    DateTimePane_defineProperty(this, "_renderDateTime", () => {
      const {
        locale,
        ariaLabelDate,
        ariaLabelTime,
        dateOnly,
        readOnly
      } = this.props;
      const {
        date,
        time
      } = this.state;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        wrap: "wrap",
        direction: "row",
        "data-tid": getTid('dateTimePane', 'dateTimePickerSection')
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        "data-tid": getTid('dateTimePane', 'datePickerSection'),
        gutter: [0, 1, 1, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SingleDatepicker"], {
        light: true,
        locale: locale,
        date: date,
        onChange: this._onDateChange,
        ariaLabel: ariaLabelDate,
        disabled: readOnly,
        numberOfMonths: 1
      })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        "data-tid": getTid('dateTimePane', 'timePickerSection')
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TimePicker"], {
        locale: locale,
        time: time,
        onChange: this._onTimeChange,
        ariaLabel: ariaLabelTime,
        disabled: readOnly || dateOnly,
        showSec: true,
        light: true
      })));
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.inputTime !== nextProps.inputTime) {
      this.setState({
        time: external_moment_default()(nextProps.inputTime, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT)
      });
    }

    if (this.props.inputDate !== nextProps.inputDate) {
      this.setState({
        date: external_moment_default()(nextProps.inputDate, DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT)
      });
    }
  }

  _revertDate(date) {
    this.setState({
      date: external_moment_default()(date, DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT)
    });
  }

  _revertTime(time) {
    this.setState({
      time: external_moment_default()(time, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT)
    });
  }

  render() {
    switch (this.props.dataType) {
      case 'datetime':
        return this._renderDateTime();

      case 'date':
        return this._renderDate();

      case 'time':
        return this._renderTime();

      default:
        return this._renderDateTime();
    }
  }

}

DateTimePane_defineProperty(DateTimePane_DateTimePane, "propTypes", {
  inputDate: external_prop_types_default.a.string,
  inputTime: external_prop_types_default.a.string,
  dataType: external_prop_types_default.a.string,
  onDateChange: external_prop_types_default.a.func,
  onTimeChange: external_prop_types_default.a.func,
  locale: external_prop_types_default.a.string.isRequired,
  ariaLabelDate: external_prop_types_default.a.string,
  ariaLabelTime: external_prop_types_default.a.string,
  dateOnly: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool
});

DateTimePane_defineProperty(DateTimePane_DateTimePane, "defaultProps", {
  inputDate: '',
  inputTime: '',
  dataType: 'datetime',
  dateOnly: false,
  readOnly: false
});
// EXTERNAL MODULE: ./src/filters/DateTimeFilter.scss
var filters_DateTimeFilter = __webpack_require__(71);

// CONCATENATED MODULE: ./src/filters/DateTimeFilter.tsx
function DateTimeFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */










/*
 * Input dates are assumed to be in UTC. The timezone property is propagated to
 * the pickers, but is expected to be in UTC (as full timezone support is not
 * currently required).
 */

class DateTimeFilter_DateTimeFilter extends external_react_["Component"] {
  constructor(props) {
    super(props);

    DateTimeFilter_defineProperty(this, "_fromDateTimePaneNode", void 0);

    DateTimeFilter_defineProperty(this, "_toDateTimePaneNode", void 0);

    DateTimeFilter_defineProperty(this, "_hasTimeChanged", (inputTime, changedTime) => {
      if (inputTime && changedTime) {
        return inputTime !== changedTime;
      } else if (inputTime || changedTime) {
        return true;
      }

      return false;
    });

    DateTimeFilter_defineProperty(this, "_hasDateChanged", (inputDate, changedDate) => {
      if (inputDate && changedDate) {
        return inputDate !== changedDate;
      } else if (inputDate || changedDate) {
        return true;
      }

      return false;
    });

    DateTimeFilter_defineProperty(this, "_onRangeTypeChange", changed => {
      const result = {
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        rangeType: changed,
        rangeSubtype: this.props.rangeSubtype,
        includeNulls: this.props.includeNulls,
        inverted: changed === FILTER_RANGE_TYPE.NOT_BETWEEN
      };
      this.props.onChange(result);
    });

    DateTimeFilter_defineProperty(this, "_onRangeSubtypeChange", changed => {
      const result = {
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        rangeType: this.props.rangeType,
        rangeSubtype: changed,
        includeNulls: this.props.includeNulls,
        inverted: changed === FILTER_RANGE_TYPE.NOT_BETWEEN
      };
      this.props.onChange(result);
    });

    DateTimeFilter_defineProperty(this, "_onFromValueDateChange", fromDate => {
      if (!fromDate || this.props.readOnly) {
        this._revertFromDate();

        return;
      }

      const {
        toValue,
        rangeType,
        rangeSubtype,
        includeNulls,
        inverted,
        dataType
      } = this.props;
      const {
        fromTime
      } = this.state;

      switch (dataType) {
        case 'datetime':
          if (fromTime) {
            const datetime = external_moment_default.a.utc(`${fromDate} ${fromTime}`);
            const validFromValue = datetime.format(DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT);
            this.props.onChange({
              fromValue: validFromValue,
              toValue,
              rangeType,
              rangeSubtype,
              includeNulls,
              inverted,
              format: DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT
            });
          } else if (this._isValidFromDate(external_moment_default.a.utc(fromDate, DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT))) {
            const state = this._getStateFromProps(this.props);

            state.fromDate = fromDate;
            this.setState(state);
          } else {
            this._revertFromDate();
          }

          break;

        case 'date':
          {
            this.props.onChange({
              fromValue: fromDate,
              toValue,
              rangeType,
              rangeSubtype,
              includeNulls,
              inverted,
              format: DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT
            });
            break;
          }

        default:
      }
    });

    DateTimeFilter_defineProperty(this, "_onFromValueTimeChange", fromTime => {
      if (!fromTime || this.props.readOnly) {
        this._revertFromTime();

        return;
      }

      const {
        toValue,
        rangeType,
        rangeSubtype,
        includeNulls,
        inverted,
        dataType
      } = this.props;
      const {
        fromDate
      } = this.state;

      switch (dataType) {
        case 'datetime':
          if (fromDate) {
            if (this._hasTimeChanged(this.state.fromTime, fromTime)) {
              const datetime = external_moment_default.a.utc(`${fromDate} ${fromTime}`);
              const validFromValue = datetime.format(DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT);
              this.props.onChange({
                fromValue: validFromValue,
                toValue,
                rangeType,
                rangeSubtype,
                includeNulls,
                inverted,
                format: DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT
              });
            }
          } else {
            const state = this._getStateFromProps(this.props);

            state.fromTime = fromTime;
            this.setState(state);
          }

          break;

        case 'time':
          {
            if (this._hasTimeChanged(this.props.fromValue, fromTime)) {
              this.props.onChange({
                fromValue: fromTime,
                toValue,
                rangeType,
                rangeSubtype,
                includeNulls,
                inverted,
                format: DateTimeFilter_DateTimeFilter.ISO_TIME_FORMAT
              });
            }

            break;
          }

        default:
      }
    });

    DateTimeFilter_defineProperty(this, "_onToValueDateChange", toDate => {
      if (!toDate || this.props.readOnly) {
        this._revertToDate();

        return;
      }

      const {
        fromValue,
        rangeType,
        rangeSubtype,
        includeNulls,
        inverted,
        dataType
      } = this.props;
      const {
        toTime
      } = this.state;

      switch (dataType) {
        case 'datetime':
          if (toTime) {
            const datetime = external_moment_default.a.utc(`${toDate} ${toTime}`);
            const validToValue = datetime.format(DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT);
            this.props.onChange({
              fromValue,
              toValue: validToValue,
              rangeType,
              rangeSubtype,
              includeNulls,
              inverted,
              format: DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT
            });
          } else if (this._isValidToDate(external_moment_default.a.utc(toDate, DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT))) {
            const state = this._getStateFromProps(this.props);

            state.toDate = toDate;
            this.setState(state);
          } else {
            this._revertToDate();
          }

          break;

        case 'date':
          {
            this.props.onChange({
              fromValue,
              toValue: toDate,
              rangeType,
              rangeSubtype,
              includeNulls,
              inverted,
              format: DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT
            });
            break;
          }

        default:
      }
    });

    DateTimeFilter_defineProperty(this, "_onToValueTimeChange", toTime => {
      if (!toTime || this.props.readOnly) {
        this._revertToTime();

        return;
      }

      const {
        fromValue,
        rangeType,
        rangeSubtype,
        includeNulls,
        inverted,
        dataType
      } = this.props;
      const {
        toDate
      } = this.state;

      switch (dataType) {
        case 'datetime':
          if (toDate) {
            if (this._hasTimeChanged(this.state.toTime, toTime)) {
              const datetime = external_moment_default.a.utc(`${toDate} ${toTime}`);
              const validToValue = datetime.format(DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT);
              this.props.onChange({
                fromValue,
                toValue: validToValue,
                rangeType,
                rangeSubtype,
                includeNulls,
                inverted,
                format: DateTimeFilter_DateTimeFilter.ISO_DATETIME_FORMAT
              });
            }
          } else {
            const state = this._getStateFromProps(this.props);

            state.toTime = toTime;
            this.setState(state);
          }

          break;

        case 'time':
          {
            if (this._hasTimeChanged(this.props.toValue, toTime)) {
              this.props.onChange({
                fromValue,
                toValue: toTime,
                rangeType,
                rangeSubtype,
                includeNulls,
                inverted,
                format: DateTimeFilter_DateTimeFilter.ISO_TIME_FORMAT
              });
            }

            break;
          }

        default:
      }
    });

    DateTimeFilter_defineProperty(this, "_isValidFromDate", fromDate => {
      const {
        toDate
      } = this.state;

      if (toDate && fromDate.isAfter(external_moment_default.a.utc(toDate))) {
        return false;
      }

      return true;
    });

    DateTimeFilter_defineProperty(this, "_isValidToDate", toDate => {
      const {
        fromDate
      } = this.state;

      if (fromDate && toDate.isBefore(external_moment_default.a.utc(fromDate))) {
        return false;
      }

      return true;
    });

    DateTimeFilter_defineProperty(this, "_getUTCDatePart", (utcDateTimeString, format) => {
      const {
        dataType
      } = this.props;
      const dateFormat = format || DateTimeFilter_DateTimeFilter.ISO_DATE_FORMAT;

      switch (dataType) {
        case 'date':
          return external_moment_default.a.utc(utcDateTimeString, dateFormat).format(dateFormat);

        case 'datetime':
          return external_moment_default.a.utc(utcDateTimeString).format(dateFormat);

        default:
          return null;
      }
    });

    DateTimeFilter_defineProperty(this, "_getUTCTimePart", (utcDateTimeString, format) => {
      const {
        dataType
      } = this.props;
      const timeFormat = format || DateTimeFilter_DateTimeFilter.ISO_TIME_FORMAT;

      switch (dataType) {
        case 'time':
          return external_moment_default.a.utc(utcDateTimeString, timeFormat).format(timeFormat);

        case 'datetime':
          return external_moment_default.a.utc(utcDateTimeString).format(timeFormat);

        default:
          return null;
      }
    });

    DateTimeFilter_defineProperty(this, "_refFromDateTimePane", node => {
      this._fromDateTimePaneNode = node;
    });

    DateTimeFilter_defineProperty(this, "_refToDateTimePane", node => {
      this._toDateTimePaneNode = node;
    });

    DateTimeFilter_defineProperty(this, "_revertFromDate", () => {
      const {
        fromDate
      } = this.state;
      /* eslint-disable no-underscore-dangle */

      this._fromDateTimePaneNode._revertDate(fromDate);
      /* eslint-enable no-underscore-dangle */

    });

    DateTimeFilter_defineProperty(this, "_revertFromTime", () => {
      const {
        fromTime,
        toTime,
        fromTimeDisplay,
        toTimeDisplay
      } = this.state;
      /* eslint-disable no-underscore-dangle */

      const fromTimePickerValue = this._fromDateTimePaneNode.getTime();

      if (!fromTime && toTime && this._hasTimeChanged(fromTimePickerValue, toTime)) {
        this._fromDateTimePaneNode._revertTime(toTimeDisplay);
      } else if (this._hasTimeChanged(fromTimePickerValue, fromTime)) {
        this._fromDateTimePaneNode._revertTime(fromTimeDisplay);
      }
      /* eslint-enable no-underscore-dangle */

    });

    DateTimeFilter_defineProperty(this, "_revertToDate", () => {
      const {
        toDate
      } = this.state;
      /* eslint-disable no-underscore-dangle */

      this._toDateTimePaneNode._revertDate(toDate);
      /* eslint-enable no-underscore-dangle */

    });

    DateTimeFilter_defineProperty(this, "_revertToTime", () => {
      const {
        fromTime,
        toTime,
        fromTimeDisplay,
        toTimeDisplay
      } = this.state;
      /* eslint-disable no-underscore-dangle */

      const toTimePickerValue = this._toDateTimePaneNode.getTime();

      if (!toTime && fromTime && this._hasTimeChanged(toTimePickerValue, fromTime)) {
        this._toDateTimePaneNode._revertTime(fromTimeDisplay);
      } else if (this._hasTimeChanged(toTimePickerValue, toTime)) {
        this._toDateTimePaneNode._revertTime(toTimeDisplay);
      }
      /* eslint-enable no-underscore-dangle */

    });

    DateTimeFilter_defineProperty(this, "_renderRangeTypeSelector", () => {
      // specify 'subtype' when dealing with 'datetime' only
      const subtype = this.props.dataType === 'datetime' ? this.props.rangeSubtype : undefined;
      return /*#__PURE__*/external_react_default.a.createElement(DateTimeRangeTypeSelector_DateTimeRangeTypeSelector, {
        onChangeRangeType: this._onRangeTypeChange,
        onChangeRangeSubtype: this._onRangeSubtypeChange,
        locale: this.props.locale,
        rangeType: this.props.rangeType,
        rangeSubtype: subtype,
        readOnly: this.props.readOnly,
        validRangeTypeOptions: this.props.validRangeTypeOptions
      });
    });

    DateTimeFilter_defineProperty(this, "_isDateOnly", () => this.props.rangeSubtype === FILTER_RANGE_SUBTYPE.DATE_ONLY);

    DateTimeFilter_defineProperty(this, "_renderAfter", () => {
      const {
        locale,
        timezone,
        dataType,
        readOnly
      } = this.props;
      const {
        fromDate,
        fromTimeDisplay
      } = this.state;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        fullHeight: true,
        direction: "column"
      }, this._renderRangeTypeSelector(), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["VSpacer"], null), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true,
        gutter: [0, 2, 0, 2],
        className: "bi-mui-dateTimeFilter__box"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        gutter: [2, 0, 1, 0]
      }, nls_StringResource.get('after')), /*#__PURE__*/external_react_default.a.createElement(DateTimePane_DateTimePane, {
        inputDate: fromDate,
        inputTime: fromTimeDisplay,
        locale: locale,
        timezone: timezone,
        dataType: dataType,
        onDateChange: this._onFromValueDateChange,
        onTimeChange: this._onFromValueTimeChange,
        ref: this._refFromDateTimePane,
        dateOnly: this._isDateOnly(),
        readOnly: readOnly
      })));
    });

    DateTimeFilter_defineProperty(this, "_renderBefore", () => {
      const {
        locale,
        timezone,
        dataType,
        readOnly
      } = this.props;
      const {
        toDate,
        toTimeDisplay
      } = this.state;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        fullHeight: true,
        direction: "column"
      }, this._renderRangeTypeSelector(), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["VSpacer"], null), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true,
        gutter: [0, 2, 0, 2],
        className: "bi-mui-dateTimeFilter__box"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        gutter: [2, 0, 1, 0]
      }, nls_StringResource.get('before')), /*#__PURE__*/external_react_default.a.createElement(DateTimePane_DateTimePane, {
        inputDate: toDate,
        inputTime: toTimeDisplay,
        locale: locale,
        timezone: timezone,
        dataType: dataType,
        onDateChange: this._onToValueDateChange,
        onTimeChange: this._onToValueTimeChange,
        ref: this._refToDateTimePane,
        dateOnly: this._isDateOnly(),
        readOnly: readOnly
      })));
    });

    DateTimeFilter_defineProperty(this, "_renderBetween", () => {
      const {
        locale,
        timezone,
        dataType,
        fromValue,
        toValue,
        readOnly,
        isDirty,
        isValid
      } = this.props;
      const {
        fromDate,
        fromTimeDisplay,
        toDate,
        toTimeDisplay
      } = this.state;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        fullHeight: true,
        direction: "column",
        "data-tid": getTid('dateTimeFilter')
      }, this._renderRangeTypeSelector(), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["VSpacer"], null), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true,
        gutter: [0, 2, 0, 2],
        className: "bi-mui-dateTimeFilter__box"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        gutter: [2, 0, 1, 0]
      }, nls_StringResource.get('from')), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        "data-tid": getTid('dateTimeFilter', 'pickerSection1')
      }, /*#__PURE__*/external_react_default.a.createElement(DateTimePane_DateTimePane, {
        locale: locale,
        timezone: timezone,
        dataType: dataType,
        inputDate: fromDate,
        inputTime: fromTimeDisplay,
        onDateChange: this._onFromValueDateChange,
        onTimeChange: this._onFromValueTimeChange,
        ref: this._refFromDateTimePane,
        maxDate: toValue,
        ariaLabelDate: nls_StringResource.get('fromDate'),
        ariaLabelTime: nls_StringResource.get('fromTime'),
        dateOnly: this._isDateOnly(),
        readOnly: readOnly
      })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        gutter: [3, 0, 1, 0]
      }, nls_StringResource.get('to')), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        "data-tid": getTid('dateTimeFilter', 'pickerSection2')
      }, /*#__PURE__*/external_react_default.a.createElement(DateTimePane_DateTimePane, {
        locale: locale,
        timezone: timezone,
        dataType: dataType,
        inputDate: toDate,
        inputTime: toTimeDisplay,
        onDateChange: this._onToValueDateChange,
        onTimeChange: this._onToValueTimeChange,
        ref: this._refToDateTimePane,
        minDate: fromValue,
        ariaLabelDate: nls_StringResource.get('toDate'),
        ariaLabelTime: nls_StringResource.get('toTime'),
        dateOnly: this._isDateOnly(),
        readOnly: readOnly
      })), isDirty && !isValid && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
        gutter: [3, 0, 1, 0],
        className: "bi-mui-dateTimeFilter__validation",
        "data-tid": getTid('dateTimeFilter', 'stringDateValidation')
      }, nls_StringResource.get('dateValidation'))));
    });

    this.state = this._getStateFromProps(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getStateFromProps(nextProps));
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.rangeType !== nextProps.rangeType) {
      return true;
    }

    if (this.props.rangeSubtype !== nextProps.rangeSubtype) {
      return true;
    }

    if (this.props.readOnly !== nextProps.readOnly) {
      return true;
    }

    switch (nextProps.dataType) {
      case 'datetime':
        {
          return this._shouldComponentUpdateDateCheck(nextProps, nextState) || this._shouldComponentUpdateTimeCheck(nextProps, nextState);
        }

      case 'date':
        return this._shouldComponentUpdateDateCheck(nextProps, nextState);

      case 'time':
        return this._shouldComponentUpdateTimeCheck(nextProps, nextState);

      default:
    }

    return false;
  }

  _shouldComponentUpdateDateCheck(nextProps, nextState) {
    const fromDatePickerValue = this._fromDateTimePaneNode && this._fromDateTimePaneNode.getDate();

    const toDatePickerValue = this._toDateTimePaneNode && this._toDateTimePaneNode.getDate();

    switch (nextProps.rangeType) {
      case FILTER_RANGE_TYPE.BETWEEN:
      case FILTER_RANGE_TYPE.NOT_BETWEEN:
        if (this._hasDateChanged(fromDatePickerValue, nextState.fromDate) || this._hasDateChanged(toDatePickerValue, nextState.toDate)) {
          return true;
        }

        break;

      case FILTER_RANGE_TYPE.AFTER:
        if (this._hasDateChanged(fromDatePickerValue, nextState.fromDate)) {
          return true;
        }

        break;

      case FILTER_RANGE_TYPE.BEFORE:
        if (this._hasDateChanged(toDatePickerValue, nextState.toDate)) {
          return true;
        }

        break;

      default:
    }

    return false;
  }

  _shouldComponentUpdateTimeCheck(nextProps, nextState) {
    const fromTimePickerValue = this._fromDateTimePaneNode && this._fromDateTimePaneNode.getTime();

    const toTimePickerValue = this._toDateTimePaneNode && this._toDateTimePaneNode.getTime();

    switch (nextProps.rangeType) {
      case FILTER_RANGE_TYPE.BETWEEN:
      case FILTER_RANGE_TYPE.NOT_BETWEEN:
        if (this._hasTimeChanged(fromTimePickerValue, nextState.fromTime) || this._hasTimeChanged(toTimePickerValue, nextState.toTime)) {
          return true;
        }

        break;

      case FILTER_RANGE_TYPE.AFTER:
        if (this._hasTimeChanged(fromTimePickerValue, nextState.fromTime)) {
          return true;
        }

        break;

      case FILTER_RANGE_TYPE.BEFORE:
        if (this._hasTimeChanged(toTimePickerValue, nextState.toTime)) {
          return true;
        }

        break;

      default:
    }

    return false;
  }

  _getStateFromProps(nextProps) {
    const {
      dataType,
      fromValue,
      toValue
    } = nextProps;

    switch (dataType) {
      case 'datetime':
        {
          const fromDate = fromValue ? this._getUTCDatePart(fromValue) : fromValue;
          const fromTime = fromValue ? this._getUTCTimePart(fromValue) : fromValue;
          const fromTimeDisplay = fromValue ? this._getUTCTimePart(fromValue, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT) : fromValue;
          const toDate = toValue ? this._getUTCDatePart(toValue) : toValue;
          const toTime = toValue ? this._getUTCTimePart(toValue) : toValue;
          const toTimeDisplay = toValue ? this._getUTCTimePart(toValue, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT) : toValue;
          return this.transferExistingState({
            fromDate,
            fromTime,
            fromTimeDisplay,
            toDate,
            toTime,
            toTimeDisplay
          });
        }

      case 'date':
        {
          const fromDate = fromValue ? this._getUTCDatePart(fromValue) : fromValue;
          const toDate = toValue ? this._getUTCDatePart(toValue) : toValue;
          return {
            fromDate,
            toDate
          };
        }

      case 'time':
        {
          const fromTime = fromValue ? this._getUTCTimePart(fromValue) : fromValue;
          const fromTimeDisplay = fromValue ? this._getUTCTimePart(fromValue, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT) : fromValue;
          const toTime = toValue ? this._getUTCTimePart(toValue) : toValue;
          const toTimeDisplay = toValue ? this._getUTCTimePart(toValue, DateTimeFilter_DateTimeFilter.DISPLAY_TIME_FORMAT) : toValue;
          return {
            fromTime,
            fromTimeDisplay,
            toTime,
            toTimeDisplay
          };
        }

      default:
        return null;
    }
  }

  transferExistingState(state) {
    if (this.state) {
      if (this.state.fromDate && !state.fromDate) state.fromDate = this.state.fromDate;
      if (this.state.toDate && !state.toDate) state.toDate = this.state.toDate;
      if (this.state.fromTime && !state.fromTime) state.fromTime = this.state.fromTime;
      if (this.state.toTime && !state.toTime) state.toTime = this.state.toTime;

      if (this.state.fromTimeDisplay && !state.fromTimeDisplay) {
        state.fromTimeDisplay = this.state.fromTimeDisplay;
      }

      if (this.state.toTimeDisplay && !state.toTimeDisplay) {
        state.toTimeDisplay = this.state.toTimeDisplay;
      }
    }

    return state;
  }

  render() {
    switch (this.props.rangeType) {
      case FILTER_RANGE_TYPE.BETWEEN:
      case FILTER_RANGE_TYPE.NOT_BETWEEN:
        return this._renderBetween();

      case FILTER_RANGE_TYPE.AFTER:
        return this._renderAfter();

      case FILTER_RANGE_TYPE.BEFORE:
        return this._renderBefore();

      default:
        return null;
    }
  }

}

DateTimeFilter_defineProperty(DateTimeFilter_DateTimeFilter, "propTypes", {
  fromValue: external_prop_types_default.a.string,
  toValue: external_prop_types_default.a.string,
  rangeType: external_prop_types_default.a.string,
  rangeSubtype: external_prop_types_default.a.string,
  dataType: external_prop_types_default.a.string,
  inverted: external_prop_types_default.a.bool,
  includeNulls: external_prop_types_default.a.bool,
  timezone: external_prop_types_default.a.string.isRequired,
  onChange: external_prop_types_default.a.func.isRequired,
  locale: external_prop_types_default.a.string.isRequired,
  readOnly: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  isValid: external_prop_types_default.a.bool,
  validRangeTypeOptions: external_prop_types_default.a.array
});

DateTimeFilter_defineProperty(DateTimeFilter_DateTimeFilter, "defaultProps", {
  fromValue: '',
  toValue: '',
  rangeType: FILTER_RANGE_TYPE.BETWEEN,
  rangeSubtype: FILTER_RANGE_SUBTYPE.DATE_AND_TIME,
  dataType: 'datetime',
  readOnly: false
});

DateTimeFilter_defineProperty(DateTimeFilter_DateTimeFilter, "ISO_DATE_FORMAT", 'YYYY-MM-DD');

DateTimeFilter_defineProperty(DateTimeFilter_DateTimeFilter, "ISO_TIME_FORMAT", 'HH:mm:ss');

DateTimeFilter_defineProperty(DateTimeFilter_DateTimeFilter, "ISO_DATETIME_FORMAT", 'YYYY-MM-DDTHH:mm:ss');

DateTimeFilter_defineProperty(DateTimeFilter_DateTimeFilter, "DISPLAY_TIME_FORMAT", 'hh:mm:ss a');
// EXTERNAL MODULE: ./src/common/components/PanelMessage.tsx
var PanelMessage = __webpack_require__(21);

// EXTERNAL MODULE: ./src/common/components/EmptyState.tsx
var EmptyState = __webpack_require__(32);

// EXTERNAL MODULE: external "@ba/ba-graphics/dist/illustrations-js/search-results_128.js"
var search_results_128_js_ = __webpack_require__(73);
var search_results_128_js_default = /*#__PURE__*/__webpack_require__.n(search_results_128_js_);

// EXTERNAL MODULE: ./src/filters/FilterListItem.scss
var filters_FilterListItem = __webpack_require__(74);

// CONCATENATED MODULE: ./src/filters/FilterListItem.tsx
function FilterListItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





/*
 * FilterList implementation (leverages List.js)
 */

class FilterListItem_FilterListItem extends external_react_["Component"] {
  render() {
    const {
      showPath,
      caption,
      subcaption,
      matchesCondition
    } = this.props;
    const textDir = external_context_["getTextDirPref"]();
    return showPath ? /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [2, 0, 0, 0],
      grow: true
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: caption,
      bolder: matchesCondition,
      textDir: textDir
    }), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
      className: "bi-filter-list-item-path"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: subcaption,
      bolder: matchesCondition,
      textDir: textDir
    }))) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: caption,
      bolder: matchesCondition,
      textDir: textDir
    }));
  }

}

FilterListItem_defineProperty(FilterListItem_FilterListItem, "propTypes", {
  caption: external_prop_types_default.a.string,
  subcaption: external_prop_types_default.a.string,
  showPath: external_prop_types_default.a.bool,
  matchesCondition: external_prop_types_default.a.bool
});

FilterListItem_defineProperty(FilterListItem_FilterListItem, "defaultProps", {
  showPath: false,
  matchesCondition: false
});
// CONCATENATED MODULE: ./src/filters/FilterList.tsx
function FilterList_extends() { FilterList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FilterList_extends.apply(this, arguments); }

function FilterList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







const {
  selectionEventTypes
} = ba_ui_carbon_toolkit_["listEventTypes"];
/*
 * FilterList implementation (leverages List.js)
 */

class FilterList_FilterList extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FilterList_defineProperty(this, "_itemMap", new Map());

    FilterList_defineProperty(this, "_getValue", index => {
      if (this._itemMap.has(index)) {
        return this._itemMap.get(index);
      }

      const item = this.props.getValue(index);

      if (item) {
        this._itemMap.set(index, item);

        return item;
      }

      return {};
    });

    FilterList_defineProperty(this, "_itemRenderer", (index, props) => {
      const {
        selected,
        ...other
      } = props;
      const {
        showPath,
        readOnly
      } = this.props;

      const item = this._getValue(index);

      let {
        caption,
        subcaption,
        selectable
      } = item;
      caption += '';
      subcaption += '';
      const {
        matchesCondition
      } = item;

      if (selectable === undefined) {
        selectable = true;
      }

      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ListItem"], FilterList_extends({
        length: this.props.totalValues,
        index: index,
        selected: !!selected
      }, other, {
        "data-tid": `filterListItem${index}`,
        ariaSelected: !!selected,
        selectable: selectable
      }), selectable && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: [0, 1, 0, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Checkbox"], {
        checked: !!selected,
        visual: true,
        readOnly: readOnly
      }))), /*#__PURE__*/external_react_default.a.createElement(FilterListItem_FilterListItem, {
        showPath: showPath,
        caption: caption,
        subcaption: subcaption,
        matchesCondition: matchesCondition
      }), matchesCondition === true && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: 0.5
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Tooltip"], {
        gutter: 0.5,
        title: nls_StringResource.get('reflectsFilterCondition'),
        "aria-label": nls_StringResource.get('reflectsFilterCondition'),
        orient: "left",
        focusable: true
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], {
        iconId: coach_mark_16_js_default.a.id,
        intent: "positive",
        width: 8,
        height: 8
      }))));
    });

    FilterList_defineProperty(this, "_onSelectionChange", event => {
      if (this.props.readOnly) {
        return;
      }

      const eventType = event.type;

      switch (eventType) {
        case selectionEventTypes.SET:
        case selectionEventTypes.TOGGLE:
          this.props.onClick(this._getValue(event.index));
          break;

        default:
      }
    });

    FilterList_defineProperty(this, "_isSelected", index => !!this._getValue(index).selected);
  }

  componentWillUpdate() {
    // always re-fetch data value from parent control.
    this._itemMap = new Map();
  }

  render() {
    const {
      initialIndex,
      totalValues,
      isSearching
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
      height: "100%"
    }, isSearching ? /*#__PURE__*/external_react_default.a.createElement(PanelMessage["default"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ProgressIndicator"], {
      size: "normal"
    })) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["List"], {
      length: totalValues,
      itemRenderer: this.props.contentRenderer ? this.props.contentRenderer : this._itemRenderer,
      initialIndex: initialIndex,
      onSelectionChange: this._onSelectionChange,
      toggleOnClick: true,
      selectionMode: "single",
      listType: "uniform",
      isSelected: this._isSelected,
      getKey: v => v,
      ariaMultiselectable: true
    }));
  }

}

FilterList_defineProperty(FilterList_FilterList, "propTypes", {
  totalValues: external_prop_types_default.a.number.isRequired,
  onClick: external_prop_types_default.a.func.isRequired,
  getValue: external_prop_types_default.a.func.isRequired,
  contentRenderer: external_prop_types_default.a.func,
  initialIndex: external_prop_types_default.a.number,
  selected: external_prop_types_default.a.bool,
  showPath: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool
});

FilterList_defineProperty(FilterList_FilterList, "defaultProps", {
  showPath: false,
  readOnly: false,
  isSearching: false
});
// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(10);
var external_lodash_default = /*#__PURE__*/__webpack_require__.n(external_lodash_);

// CONCATENATED MODULE: ./src/filters/FilterSearchInput.tsx
function FilterSearchInput_extends() { FilterSearchInput_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FilterSearchInput_extends.apply(this, arguments); }

function FilterSearchInput_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




class FilterSearchInput_FilterSearchInput extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FilterSearchInput_defineProperty(this, "searchInput", Object(external_react_["createRef"])());

    FilterSearchInput_defineProperty(this, "_onSearchTimeout", void 0);

    FilterSearchInput_defineProperty(this, "_onChange", searchString => {
      const {
        delay,
        onChange
      } = this.props;

      if (this._onSearchTimeout) {
        clearTimeout(this._onSearchTimeout);
      }

      this._onSearchTimeout = window.setTimeout(() => {
        onChange && onChange(searchString);
      }, delay);
    });

    FilterSearchInput_defineProperty(this, "_focus", () => {
      this.searchInput.current && this.searchInput.current.focus();
    });
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this._focus();
    }
  }

  render() {
    const passThroughProps = { ...Object(external_lodash_["omit"])(this.props, 'delay', 'onChange', 'autoFocus')
    };
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SearchInput"], FilterSearchInput_extends({}, passThroughProps, {
      ref: this.searchInput,
      onChange: this._onChange,
      light: true
    }));
  }

}

FilterSearchInput_defineProperty(FilterSearchInput_FilterSearchInput, "propTypes", {
  delay: external_prop_types_default.a.number,
  onChange: external_prop_types_default.a.func.isRequired,
  autoFocus: external_prop_types_default.a.bool
});

FilterSearchInput_defineProperty(FilterSearchInput_FilterSearchInput, "defaultProps", {
  delay: 800
});
// CONCATENATED MODULE: ./src/filters/FilterLoadingSpinner.tsx
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


class FilterLoadingSpinner_FilterLoadingSpinner extends external_react_["Component"] {
  render() {
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      alignItems: "center",
      justifyContent: "center",
      direction: "column",
      fullHeight: true
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ProgressIndicator"], {
      size: "large"
    }));
  }

}
// CONCATENATED MODULE: ./src/filters/SelectValueFilterPane.tsx
function SelectValueFilterPane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */










class SelectValueFilterPane_SelectValueFilterPane extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    SelectValueFilterPane_defineProperty(this, "_getValue", index => {
      const {
        getValue,
        hasMoreData,
        totalValues
      } = this.props;

      if (hasMoreData && index >= totalValues) {
        return {
          id: totalValues,
          caption: nls_StringResource.get('dataTruncation'),
          selectable: false
        };
      }

      return getValue(index);
    });

    SelectValueFilterPane_defineProperty(this, "_renderSelectValueFilterPane", () => {
      // TODO add onInvert and onClear
      const {
        loading,
        selectedValuesCount,
        totalValues,
        onSearch,
        onClick,
        contentRenderer,
        readOnly,
        allowSearch,
        hasMoreData,
        isSearching,
        autoFocus
      } = this.props;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        fullHeight: true,
        direction: "column"
      }, allowSearch === true && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: 0
      }, /*#__PURE__*/external_react_default.a.createElement(FilterSearchInput_FilterSearchInput, {
        light: true,
        size: "sm",
        fullWidth: true,
        placeholder: nls_StringResource.get('search'),
        title: nls_StringResource.get('search'),
        value: "",
        onChange: onSearch,
        readOnly: readOnly,
        autoFocus: autoFocus
      })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true,
        "data-tid": "filterListSection"
      }, totalValues > 0 ? /*#__PURE__*/external_react_default.a.createElement(FilterList_FilterList, {
        loading: loading,
        selectedValuesCount: selectedValuesCount,
        totalValues: hasMoreData ? totalValues + 1 : totalValues,
        onClick: onClick,
        getValue: this._getValue,
        contentRenderer: contentRenderer,
        readOnly: readOnly,
        isSearching: isSearching
      }) : /*#__PURE__*/external_react_default.a.createElement(PanelMessage["default"], null, /*#__PURE__*/external_react_default.a.createElement(EmptyState["default"], {
        icon: search_results_128_js_default.a,
        header: nls_StringResource.get('filter_noSearchResults'),
        body: nls_StringResource.get('filter_tryDifferentTerm')
      }))));
    });
  }

  render() {
    const {
      loading
    } = this.props;

    if (loading) {
      return /*#__PURE__*/external_react_default.a.createElement(FilterLoadingSpinner_FilterLoadingSpinner, null);
    }

    return this._renderSelectValueFilterPane();
  }

}

SelectValueFilterPane_defineProperty(SelectValueFilterPane_SelectValueFilterPane, "propTypes", {
  totalValues: external_prop_types_default.a.number.isRequired,
  selectedValuesCount: external_prop_types_default.a.number,
  loading: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool.isRequired,
  onClick: external_prop_types_default.a.func.isRequired,
  // onInvert: PropTypes.func.isRequired,
  // onClear: PropTypes.func.isRequired,
  onSearch: external_prop_types_default.a.func,
  contentRenderer: external_prop_types_default.a.func,
  getValue: external_prop_types_default.a.func.isRequired,
  readOnly: external_prop_types_default.a.bool,
  hasMoreData: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool,
  autoFocus: external_prop_types_default.a.bool
});

SelectValueFilterPane_defineProperty(SelectValueFilterPane_SelectValueFilterPane, "defaultProps", {
  selectedValuesCount: 0,
  loading: false,
  readOnly: false,
  allowSearch: true,
  hasMoreData: false,
  isSearching: false
});
// CONCATENATED MODULE: ./src/filters/FilterPreferences.tsx
function FilterPreferences_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




class FilterPreferences_FilterPreferences extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FilterPreferences_defineProperty(this, "_onIncludeNullsChanged", value => {
      const result = {
        includeNulls: value
      };
      this.props.onChange(result);
    });

    FilterPreferences_defineProperty(this, "_onInvertedChanged", () => {
      const result = {
        inverted: !this.props.inverted
      };
      this.props.onChange(result);
    });

    FilterPreferences_defineProperty(this, "_onClear", () => {
      if (this.props.onClear !== undefined) {
        this.props.onClear();
      }
    });
  }

  render() {
    const {
      includeNulls,
      showIncludeNull,
      showReturnToTree,
      returnToTree,
      showInvertSelected,
      blankValuesLabel,
      readOnly,
      invertDisabled
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      "data-tid": "filterPreferenceSection"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      padding: [0, 0, 2, 0],
      grow: true
    }, showIncludeNull ? /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Checkbox"], {
      label: blankValuesLabel,
      onChange: this._onIncludeNullsChanged,
      checked: includeNulls,
      readOnly: readOnly,
      "data-tid": "includeNullsClickable"
    }) : showReturnToTree && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      "data-tid": "returnToTreeClickable",
      variant: "inline",
      intent: "primary",
      label: nls_StringResource.get('returnToTree'),
      text: nls_StringResource.get('returnToTree'),
      "aria-label": nls_StringResource.get('returnToTree'),
      onClick: returnToTree,
      disabled: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      kind: "ghost",
      size: "small",
      style: {
        paddingLeft: '0px',
        paddingRight: '0px'
      } // until UX carbonizes dialog
      ,
      "data-tid": "clearAllClickable",
      onClick: this._onClear,
      disabled: readOnly
    }, nls_StringResource.get('clearAll'))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, showInvertSelected && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      kind: "ghost",
      size: "small",
      style: {
        paddingLeft: '0px',
        paddingRight: '0px'
      } // until UX carbonizes dialog
      ,
      "data-tid": "invertSelectionClickable",
      onClick: this._onInvertedChanged,
      disabled: readOnly || invertDisabled
    }, nls_StringResource.get('invert')))));
  }

}

FilterPreferences_defineProperty(FilterPreferences_FilterPreferences, "propTypes", {
  showIncludeNull: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool.isRequired,
  includeNulls: external_prop_types_default.a.bool.isRequired,
  onChange: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func,
  showReturnToTree: external_prop_types_default.a.bool,
  returnToTree: external_prop_types_default.a.func.isRequired,
  showInvertSelected: external_prop_types_default.a.bool,
  blankValuesLabel: external_prop_types_default.a.string,
  readOnly: external_prop_types_default.a.bool,
  invertDisabled: external_prop_types_default.a.bool
});

FilterPreferences_defineProperty(FilterPreferences_FilterPreferences, "defaultProps", {
  showIncludeNull: true,
  showReturnToTree: false,
  selectedValuesCount: 0,
  showInvertSelected: true,
  blankValuesLabel: nls_StringResource.get('includeBlankValues'),
  readOnly: false,
  invertDisabled: false
});
// EXTERNAL MODULE: ./src/filters/DateTimeFilterPane.scss
var filters_DateTimeFilterPane = __webpack_require__(76);

// CONCATENATED MODULE: ./src/filters/DateTimeFilterPane.tsx
function DateTimeFilterPane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */













class DateTimeFilterPane_DateTimeFilterPane extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    DateTimeFilterPane_defineProperty(this, "_onChange", result => {
      // Append the filter type to the result
      const res = { ...result,
        includeNulls: this.props.includeNulls,
        filterSelectionType: this.props.filterSelectionType
      };
      this.validate(result);
      this.props.onChange(res);
    });

    DateTimeFilterPane_defineProperty(this, "validate", result => {
      const {
        rangeType,
        toValue,
        fromValue,
        format
      } = result;
      const {
        setValidationStatus
      } = this.props;
      const from = external_moment_default.a.utc(fromValue, format);
      const to = external_moment_default.a.utc(toValue, format);

      if (rangeType === 'between' || rangeType === 'not between') {
        setValidationStatus(!to.isBefore(external_moment_default.a.utc(from)));
      } else {
        setValidationStatus(true);
      }
    });

    DateTimeFilterPane_defineProperty(this, "_onFilterTypeChanged", filterSelectionType => {
      const result = {
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        includeNulls: this.props.includeNulls,
        inverted: this.props.inverted,
        filterSelectionType
      };
      this.props.onChange(result);
    });

    DateTimeFilterPane_defineProperty(this, "_buildResult", () => {
      const result = {
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        includeNulls: this.props.includeNulls,
        inverted: this.props.inverted,
        rangeType: this.props.rangeType,
        rangeSubtype: this.props.rangeSubtype
      };
      return result;
    });

    DateTimeFilterPane_defineProperty(this, "_onPreferencesChanged", preferences => {
      const result = { ...this._buildResult(),
        ...preferences,
        filterSelectionType: this.props.filterSelectionType
      };
      this.props.onChange(result);
    });

    DateTimeFilterPane_defineProperty(this, "_renderDateTimeFilterPane", () => {
      const {
        fromValue,
        toValue,
        rangeType,
        rangeSubtype,
        dataType,
        includeNulls,
        showLabels,
        inverted,
        selectedValuesCount,
        locale,
        timezone,
        totalValues,
        loading,
        onClick,
        onSearch,
        getValue,
        contentRenderer,
        allowSearch,
        filterSelectionType,
        allowSwitch,
        showFilterPreferences,
        filterType,
        readOnly,
        allowIncludeNulls,
        hasMoreData,
        invertDisabled,
        setValidationStatus,
        validRangeTypeOptions
      } = this.props;
      let spacing = 2;

      if (filterType === 'full') {
        spacing = 3;
      }

      const borderStyle = {
        'border-color': '#F2F2F2',
        'border-width': '1px',
        'border-style': 'solid'
      };
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        fullHeight: true,
        direction: "column",
        "data-tid": getTid('dateTimeFilterPane')
      }, allowSwitch && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: [0, 0, spacing, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(FilterTypeSelector_FilterTypeSelector, {
        type: filterSelectionType,
        onChange: this._onFilterTypeChanged,
        readOnly: readOnly
      })), filterSelectionType === FILTER_TYPE.RANGE ? /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true
      }, /*#__PURE__*/external_react_default.a.createElement(DateTimeFilter_DateTimeFilter, {
        fromValue: fromValue,
        toValue: toValue,
        rangeType: rangeType,
        rangeSubtype: rangeSubtype,
        dataType: dataType,
        inverted: inverted,
        locale: locale,
        timezone: timezone,
        onChange: this._onChange,
        showLabels: showLabels,
        setValidationStatus: setValidationStatus,
        readOnly: readOnly,
        isDirty: this.props.isDirty,
        isValid: this.props.isValid,
        validRangeTypeOptions: validRangeTypeOptions
      })) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true,
        margin: [0, 0, 2, 0],
        style: borderStyle
      }, /*#__PURE__*/external_react_default.a.createElement(SelectValueFilterPane_SelectValueFilterPane, {
        totalValues: totalValues,
        selectedValuesCount: selectedValuesCount,
        loading: loading,
        allowSearch: allowSearch,
        onClick: onClick,
        onChange: this._onChange,
        onSearch: onSearch,
        getValue: getValue,
        contentRenderer: contentRenderer,
        readOnly: readOnly,
        hasMoreData: hasMoreData
      })), showFilterPreferences && /*#__PURE__*/external_react_default.a.createElement(FilterPreferences_FilterPreferences, {
        inverted: inverted,
        includeNulls: includeNulls,
        onChange: this._onPreferencesChanged,
        onClear: this.props.onClear,
        showIncludeNull: allowIncludeNulls && filterSelectionType === FILTER_TYPE.RANGE,
        showInvertSelected: filterSelectionType !== FILTER_TYPE.RANGE,
        selectedValuesCount: selectedValuesCount,
        returnToTree: () => {},
        blankValuesLabel: nls_StringResource.get('includeBlankDate'),
        readOnly: readOnly,
        invertDisabled: invertDisabled
      }));
    });
  }

  render() {
    const {
      loading
    } = this.props;

    if (loading) {
      return /*#__PURE__*/external_react_default.a.createElement(FilterLoadingSpinner_FilterLoadingSpinner, null);
    }

    return this._renderDateTimeFilterPane();
  }

}

DateTimeFilterPane_defineProperty(DateTimeFilterPane_DateTimeFilterPane, "propTypes", {
  // props for DateTimeFilter
  filterSelectionType: external_prop_types_default.a.oneOf([FILTER_TYPE.RANGE, FILTER_TYPE.SELECT_VALUE]),
  fromValue: external_prop_types_default.a.string,
  toValue: external_prop_types_default.a.string,
  rangeType: external_prop_types_default.a.string,
  rangeSubtype: external_prop_types_default.a.string,
  dataType: external_prop_types_default.a.string,
  includeNulls: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  onChange: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func,
  locale: external_prop_types_default.a.string.isRequired,
  timezone: external_prop_types_default.a.string,
  // Props for SelectValueFilter
  totalValues: external_prop_types_default.a.number.isRequired,
  selectedValuesCount: external_prop_types_default.a.number,
  loading: external_prop_types_default.a.bool,
  onClick: external_prop_types_default.a.func.isRequired,
  onSearch: external_prop_types_default.a.func,
  allowSearch: external_prop_types_default.a.bool,
  allowIncludeNulls: external_prop_types_default.a.bool,
  contentRenderer: external_prop_types_default.a.func,
  getValue: external_prop_types_default.a.func,
  showLabels: external_prop_types_default.a.bool,
  allowSwitch: external_prop_types_default.a.bool,
  showFilterPreferences: external_prop_types_default.a.bool,
  filterType: external_prop_types_default.a.oneOf(['compact', 'full']),
  readOnly: external_prop_types_default.a.bool,
  hasMoreData: external_prop_types_default.a.bool,
  invertDisabled: external_prop_types_default.a.bool,
  setValidationStatus: external_prop_types_default.a.func,
  isDirty: external_prop_types_default.a.bool,
  isValid: external_prop_types_default.a.bool,
  validRangeTypeOptions: external_prop_types_default.a.array
});

DateTimeFilterPane_defineProperty(DateTimeFilterPane_DateTimeFilterPane, "defaultProps", {
  filterSelectionType: FILTER_TYPE.RANGE,
  fromValue: 0,
  toValue: 0,
  rangeType: FILTER_RANGE_TYPE.BETWEEN,
  rangeSubtype: FILTER_RANGE_SUBTYPE.DATE_AND_TIME,
  dataType: 'datetime',
  includeNulls: false,
  selectedValuesCount: 0,
  loading: false,
  showLabels: true,
  timezone: 'UTC',
  showFilterPreferences: true,
  filterType: 'compact',
  readOnly: false,
  allowSwitch: true,
  allowSearch: true,
  allowIncludeNulls: true,
  hasMoreData: false,
  invertDisabled: false,
  isDirty: false,
  isValid: true
});
// CONCATENATED MODULE: ./src/filters/CompactDateTimeFilter.tsx
function CompactDateTimeFilter_extends() { CompactDateTimeFilter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CompactDateTimeFilter_extends.apply(this, arguments); }

function CompactDateTimeFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








class CompactDateTimeFilter_CompactDateTimeFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    CompactDateTimeFilter_defineProperty(this, "state", {
      showSearchInput: false,
      showSearchButton: false,
      isDirty: false,
      isValid: true,
      // these states are used to determine dirty
      // these values are set in _resetDirty()
      rangeType: undefined,
      rangeSubtype: undefined,
      fromValue: undefined,
      toValue: undefined
    });

    CompactDateTimeFilter_defineProperty(this, "_setValidationStatus", isValid => this.setState({
      isValid
    }));

    CompactDateTimeFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false,
        rangeType: this.props.rangeType,
        rangeSubtype: this.props.rangeSubtype,
        fromValue: this.props.fromValue,
        toValue: this.props.toValue
      });
    });

    CompactDateTimeFilter_defineProperty(this, "_onSearchClick", () => {
      this.setState(prevState => ({
        showSearchInput: !prevState.showSearchInput
      }));
    });

    CompactDateTimeFilter_defineProperty(this, "_onShowMenu", () => {// TODO Add Menu
    });

    CompactDateTimeFilter_defineProperty(this, "_onChangeType", () => {
      const {
        onChange,
        filterSelectionType
      } = this.props;
      const newFilterSelectionType = filterSelectionType === FILTER_TYPE.RANGE ? FILTER_TYPE.SELECT_VALUE : FILTER_TYPE.RANGE;
      onChange && onChange({
        filterSelectionType: newFilterSelectionType
      });
      this.setState({
        showSearchButton: newFilterSelectionType !== FILTER_TYPE.RANGE
      });
    });

    CompactDateTimeFilter_defineProperty(this, "_onToggleIncludeNulls", () => {
      const {
        onChange
      } = this.props;
      onChange && onChange({
        includeNulls: !this.props.includeNulls
      });
    });

    CompactDateTimeFilter_defineProperty(this, "_onInvert", () => {
      const {
        onChange
      } = this.props;
      onChange && onChange({
        inverted: !this.props.inverted
      });
    });

    CompactDateTimeFilter_defineProperty(this, "_onClearAll", () => {
      const {
        onClear
      } = this.props;
      onClear && onClear();
    });

    CompactDateTimeFilter_defineProperty(this, "_onApply", () => {
      const {
        onApply
      } = this.props;
      onApply && onApply();

      this._resetDirty();
    });

    CompactDateTimeFilter_defineProperty(this, "_getContextMenu", () => {
      const menu = [];
      const {
        filterSelectionType,
        includeNulls,
        allowIncludeNulls,
        allowSwitch
      } = this.props;

      if (filterSelectionType === FILTER_TYPE.RANGE) {
        if (allowSwitch) {
          menu.push({
            label: nls_StringResource.get('individualItems'),
            fn: this._onChangeType
          });
        }

        if (allowIncludeNulls) {
          menu.push({
            label: includeNulls ? nls_StringResource.get('excludeBlankDate') : nls_StringResource.get('includeBlankDate'),
            fn: this._onToggleIncludeNulls
          });
        }
      } else {
        if (allowSwitch) {
          menu.push({
            label: nls_StringResource.get('upperRange'),
            fn: this._onChangeType
          });
        }

        menu.push({
          label: nls_StringResource.get('invert'),
          fn: this._onInvert
        });
      }

      menu.push({
        label: nls_StringResource.get('clearAll'),
        fn: this._onClearAll
      });
      return menu;
    });
  }

  componentWillMount() {
    this._resetDirty();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(prevState => ({
      isDirty: prevState.rangeType !== nextProps.rangeType || prevState.rangeSubtype !== nextProps.rangeSubtype || prevState.fromValue && prevState.fromValue !== nextProps.fromValue || prevState.toValue && prevState.toValue !== nextProps.toValue
    }));
  }

  render() {
    const {
      title,
      menuTitle,
      rangeType,
      rangeSubtype,
      dataType,
      fromValue,
      toValue,
      includeNulls,
      locale,
      timezone,
      filterSelectionType,
      onChange,
      loading,
      readOnly,
      allowSwitch,
      allowSearch,
      hasMoreData
    } = this.props;
    const {
      showSearchInput,
      showSearchButton
    } = this.state;

    const menu = this._getContextMenu(); // Define the styles so the when the filter is resized below a certain
    // height the apply button does not overlap with the contents in the
    // filter pane UI


    const containerStyle = {
      overflow: 'hidden'
    };
    const filterPaneStyle = {
      minHeight: '200px'
    };
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column",
      style: containerStyle
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [2, 2, 0, 2],
      className: "bi-filter-compact-filter-title"
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      menuTitle: menuTitle,
      showSearch: allowSearch && showSearchButton && filterSelectionType !== FILTER_TYPE.RANGE,
      allowSwitch: allowSwitch,
      onSearch: this._onSearchClick,
      onShowMenu: this._onShowMenu,
      menu: menu,
      loading: loading,
      height: 40,
      readOnly: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: [0, 2, 0, 2],
      style: filterPaneStyle
    }, /*#__PURE__*/external_react_default.a.createElement(DateTimeFilterPane_DateTimeFilterPane, CompactDateTimeFilter_extends({}, this.props, {
      rangeType: rangeType,
      rangeSubtype: rangeSubtype,
      dataType: dataType,
      fromValue: fromValue,
      toValue: toValue,
      includeNulls: includeNulls,
      locale: locale,
      timezone: timezone,
      allowSearch: allowSearch && showSearchInput,
      filterSelectionType: filterSelectionType,
      onChange: onChange,
      setValidationStatus: this._setValidationStatus,
      allowSwitch: false,
      showFilterPreferences: false,
      loading: loading,
      readOnly: readOnly,
      hasMoreData: hasMoreData,
      isDirty: this.state.isDirty,
      isValid: this.state.isValid
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      textAlign: "center",
      gutter: 0
    }, /*#__PURE__*/external_react_default.a.createElement(ApplyButton_ApplyButton, {
      dirty: (this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty) && this.state.isValid,
      onApply: this._onApply,
      loading: loading,
      readOnly: readOnly
    })));
  }

}

CompactDateTimeFilter_defineProperty(CompactDateTimeFilter_CompactDateTimeFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  menuTitle: external_prop_types_default.a.string,
  rangeType: external_prop_types_default.a.string,
  rangeSubtype: external_prop_types_default.a.string,
  dataType: external_prop_types_default.a.string,
  fromValue: external_prop_types_default.a.string,
  toValue: external_prop_types_default.a.string,
  locale: external_prop_types_default.a.string,
  timezone: external_prop_types_default.a.string,
  includeNulls: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  filterSelectionType: external_prop_types_default.a.oneOf([FILTER_TYPE.RANGE, FILTER_TYPE.SELECT_VALUE]),
  onChange: external_prop_types_default.a.func.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func,
  loading: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  allowSwitch: external_prop_types_default.a.bool,
  allowIncludeNulls: external_prop_types_default.a.bool,
  hasMoreData: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool
});

CompactDateTimeFilter_defineProperty(CompactDateTimeFilter_CompactDateTimeFilter, "defaultProps", {
  filterSelectionType: FILTER_TYPE.RANGE,
  dataType: 'datetime',
  rangeType: FILTER_RANGE_TYPE.BETWEEN,
  rangeSubtype: FILTER_RANGE_SUBTYPE.DATE_AND_TIME,
  fromValue: '',
  toValue: '',
  includeNulls: false,
  selectedValuesCount: 0,
  loading: false,
  showLabels: true,
  timezone: 'UTC',
  readOnly: false,
  allowSearch: true,
  allowSwitch: true,
  allowIncludeNulls: true,
  hasMoreData: false
});
// CONCATENATED MODULE: ./src/filters/FilterFooter.tsx
function FilterFooter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




class FilterFooter_FilterFooter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FilterFooter_defineProperty(this, "_onApply", () => {
      if (this.props.onApply !== undefined) {
        this.props.onApply();
      }
    });

    FilterFooter_defineProperty(this, "_onOk", () => {
      if (this.props.onOk !== undefined) {
        this.props.onOk();
      }
    });

    FilterFooter_defineProperty(this, "_onCancel", () => {
      if (this.props.onCancel !== undefined) {
        this.props.onCancel();
      }
    });

    FilterFooter_defineProperty(this, "_onClear", () => {
      if (this.props.onClear !== undefined) {
        this.props.onClear();
      }
    });

    FilterFooter_defineProperty(this, "_renderApply", () => {
      const {
        loading,
        readOnly,
        dirty
      } = this.props;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Footer, null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Button, {
        primary: true,
        "data-tid": "applyClickable",
        label: nls_StringResource.get('apply'),
        onClick: this._onApply,
        disabled: loading || readOnly || !dirty
      }), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Button, {
        "ata-tid": "clearAllClickable",
        label: nls_StringResource.get('clearAll'),
        onClick: this._onClear,
        disabled: loading || readOnly
      }));
    });

    FilterFooter_defineProperty(this, "_renderOk", () => {
      const {
        loading,
        readOnly,
        dirty,
        showCancel
      } = this.props;
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Footer, null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Button, {
        primary: true,
        "data-tid": "okClickable",
        label: nls_StringResource.get('done'),
        onClick: this._onOk,
        disabled: loading || readOnly || !dirty
      }), showCancel && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Button, {
        "data-tid": "cancelClickable",
        label: nls_StringResource.get('cancel'),
        onClick: this._onCancel,
        disabled: loading || readOnly
      }));
    });
  }

  render() {
    if (this.props.showApply) {
      return this._renderApply();
    }

    return this._renderOk();
  }

}

FilterFooter_defineProperty(FilterFooter_FilterFooter, "propTypes", {
  onClear: external_prop_types_default.a.func,
  onApply: external_prop_types_default.a.func,
  onOk: external_prop_types_default.a.func,
  onCancel: external_prop_types_default.a.func,
  loading: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  showApply: external_prop_types_default.a.bool,
  dirty: external_prop_types_default.a.bool,
  showCancel: external_prop_types_default.a.bool
});

FilterFooter_defineProperty(FilterFooter_FilterFooter, "defaultProps", {
  loading: false,
  readOnly: false,
  showApply: false,
  dirty: false,
  showCancel: true
});
// CONCATENATED MODULE: ./src/filters/FullDateTimeFilter.tsx
function FullDateTimeFilter_extends() { FullDateTimeFilter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FullDateTimeFilter_extends.apply(this, arguments); }

function FullDateTimeFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







class FullDateTimeFilter_FullDateTimeFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FullDateTimeFilter_defineProperty(this, "state", {
      isDirty: false,
      isValid: true,
      // these states are used to determine dirty
      // these values are set in _resetDirty()
      filterSelectionType: undefined,
      inverted: undefined,
      selectedValuesCount: undefined,
      rangeType: undefined,
      rangeSubtype: undefined,
      fromValue: undefined,
      toValue: undefined
    });

    FullDateTimeFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false,
        filterSelectionType: this.props.filterSelectionType,
        inverted: this.props.inverted,
        selectedValuesCount: this.props.selectedValuesCount,
        rangeType: this.props.rangeType,
        rangeSubtype: this.props.rangeSubtype,
        fromValue: this.props.fromValue,
        toValue: this.props.toValue
      });
    });

    FullDateTimeFilter_defineProperty(this, "_setValidationStatus", isValid => this.setState({
      isValid
    }));

    FullDateTimeFilter_defineProperty(this, "_onApply", () => {
      this.props.onApply();

      this._resetDirty();
    });

    FullDateTimeFilter_defineProperty(this, "_onClear", () => {
      this.props.onClear();
    });

    FullDateTimeFilter_defineProperty(this, "_onOk", () => {
      this._onApply();

      this.props.onDone();
    });

    FullDateTimeFilter_defineProperty(this, "_onCancel", () => {
      this.props.onClose();
    });
  }

  componentWillMount() {
    this._resetDirty();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(prevState => ({
      isDirty: prevState.filterSelectionType !== nextProps.filterSelectionType || prevState.inverted !== nextProps.inverted || prevState.filterSelectionType === FILTER_TYPE.RANGE && (prevState.rangeType !== nextProps.rangeType || prevState.rangeSubtype !== nextProps.rangeSubtype || !!prevState.fromValue && prevState.fromValue !== nextProps.fromValue || !!prevState.toValue && prevState.toValue !== nextProps.toValue) || prevState.filterSelectionType === FILTER_TYPE.SELECT_VALUE && prevState.selectedValuesCount !== nextProps.selectedValuesCount
    }));
  }

  render() {
    const {
      title,
      actionTitle,
      rangeType,
      rangeSubtype,
      dataType,
      fromValue,
      toValue,
      includeNulls,
      locale,
      timezone,
      filterSelectionType,
      loading,
      readOnly,
      allowSearch,
      allowIncludeNulls,
      allowSwitch,
      onChange,
      hasMoreData,
      showHeader,
      showCancel
    } = this.props;
    const showClose = true;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column",
      "data-tid": "fullDateTimeFilter"
    }, showHeader && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: 3
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      actionTitle: actionTitle,
      showSearch: false // always false, this controls the icon
      ,
      showMenu: false,
      showClose: showClose,
      onClose: this.props.onClose,
      loading: loading,
      height: 16,
      readOnly: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: [1, 3, 0, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(DateTimeFilterPane_DateTimeFilterPane, FullDateTimeFilter_extends({}, this.props, {
      rangeType: rangeType,
      rangeSubtype: rangeSubtype,
      dataType: dataType,
      fromValue: fromValue,
      toValue: toValue,
      includeNulls: includeNulls,
      locale: locale,
      timezone: timezone,
      allowSearch: allowSearch,
      filterSelectionType: filterSelectionType,
      onChange: onChange,
      setValidationStatus: this._setValidationStatus,
      loading: loading,
      filterType: "full",
      readOnly: readOnly,
      allowSwitch: allowSwitch,
      allowIncludeNulls: allowIncludeNulls,
      hasMoreData: hasMoreData,
      isDirty: this.state.isDirty,
      isValid: this.state.isValid
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      padding: [3, 0, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(FilterFooter_FilterFooter, {
      loading: loading,
      readOnly: readOnly,
      onClear: this._onClear,
      onApply: this._onApply,
      onOk: this._onOk,
      onCancel: this._onCancel,
      showCancel: showCancel,
      dirty: (this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty) && this.state.isValid
    })));
  }

}

FullDateTimeFilter_defineProperty(FullDateTimeFilter_FullDateTimeFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  actionTitle: external_prop_types_default.a.string,
  rangeType: external_prop_types_default.a.string,
  rangeSubtype: external_prop_types_default.a.string,
  dataType: external_prop_types_default.a.string,
  fromValue: external_prop_types_default.a.string,
  toValue: external_prop_types_default.a.string,
  locale: external_prop_types_default.a.string,
  timezone: external_prop_types_default.a.string,
  includeNulls: external_prop_types_default.a.bool,
  filterSelectionType: external_prop_types_default.a.oneOf([FILTER_TYPE.RANGE, FILTER_TYPE.SELECT_VALUE]),
  onChange: external_prop_types_default.a.func.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func.isRequired,
  onClose: external_prop_types_default.a.func.isRequired,
  onDone: external_prop_types_default.a.func.isRequired,
  loading: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  allowSwitch: external_prop_types_default.a.bool,
  allowIncludeNulls: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  selectedValuesCount: external_prop_types_default.a.number,
  hasMoreData: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  showHeader: external_prop_types_default.a.bool,
  showCancel: external_prop_types_default.a.bool
});

FullDateTimeFilter_defineProperty(FullDateTimeFilter_FullDateTimeFilter, "defaultProps", {
  dataType: 'datetime',
  rangeType: FILTER_RANGE_TYPE.BETWEEN,
  rangeSubtype: FILTER_RANGE_SUBTYPE.DATE_AND_TIME,
  fromValue: '',
  toValue: '',
  includeNulls: false,
  selectedValuesCount: 0,
  loading: false,
  showLabels: true,
  timezone: 'UTC',
  readOnly: false,
  allowSearch: true,
  allowSwitch: true,
  allowIncludeNulls: true,
  hasMoreData: false,
  showHeader: true,
  showCancel: true
});
// CONCATENATED MODULE: ./src/filters/NumericRangeFilter.tsx
function NumericRangeFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */



/*
This is a common filter component that allows a filter to be applied to a range
of numbers using a slider control. There are also options to enter filter
values directly using text boxes, invert the current selection and specify whether to include
blank values.
*/

class NumericRangeFilter_NumericRangeFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    NumericRangeFilter_defineProperty(this, "_onSliderValuesChanged", result => {
      const {
        inverted,
        onChange,
        decimalPlaces
      } = this.props;

      if (decimalPlaces > 0) {
        onChange({
          fromValue: parseFloat(result[0]),
          toValue: parseFloat(result[1]),
          inverted
        });
      } else {
        onChange({
          fromValue: parseInt(result[0], 10),
          toValue: parseInt(result[1], 10),
          inverted
        });
      }
    });
  }

  render() {
    const {
      minimumValue,
      maximumValue,
      fromValue,
      toValue,
      inverted,
      readOnly,
      decimalPlaces,
      autoFocus
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
      "data-tid": "rangeSliderSection"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["RangeSlider"], {
      min: minimumValue,
      max: maximumValue,
      values: [fromValue, toValue],
      inverted: inverted,
      onChange: this._onSliderValuesChanged,
      showInputBox: true,
      showBoundaryLabels: true,
      showTooltip: true,
      scale: decimalPlaces,
      disabled: readOnly,
      light: true,
      autoFocus: autoFocus
    }));
  }

}

NumericRangeFilter_defineProperty(NumericRangeFilter_NumericRangeFilter, "propTypes", {
  minimumValue: external_prop_types_default.a.number,
  maximumValue: external_prop_types_default.a.number,
  fromValue: external_prop_types_default.a.number.isRequired,
  toValue: external_prop_types_default.a.number.isRequired,
  inverted: external_prop_types_default.a.bool,
  decimalPlaces: external_prop_types_default.a.number,
  onChange: external_prop_types_default.a.func.isRequired,
  readOnly: external_prop_types_default.a.bool
});

NumericRangeFilter_defineProperty(NumericRangeFilter_NumericRangeFilter, "defaultProps", {
  minimumValue: 0,
  maximumValue: 100,
  inverted: false,
  decimalPlaces: 5,
  readOnly: false
});
// EXTERNAL MODULE: ./src/filters/NumericFilterPane.scss
var filters_NumericFilterPane = __webpack_require__(78);

// CONCATENATED MODULE: ./src/filters/NumericFilterPane.tsx
function NumericFilterPane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */











/*
This is a common filter component that allows a filter to be applied using a
slider control. There are also options to enter to/from filter values directly
via text boxes, invert the current selection and specify whether to include
blank values. The filter type can be to switched to a 'list' filter which allows the user
to select/deselect from a list of values.
*/

class NumericFilterPane_NumericFilterPane extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    NumericFilterPane_defineProperty(this, "_onChange", result => {
      // Append the filter type to the result
      const res = { ...result,
        includeNulls: this.props.includeNulls,
        filterSelectionType: this.props.filterSelectionType
      };
      this.props.onChange(res);
    });

    NumericFilterPane_defineProperty(this, "_onFilterTypeChanged", filterSelectionType => {
      const result = {
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        includeNulls: this.props.includeNulls,
        inverted: this.props.inverted,
        filterSelectionType
      };
      this.props.onChange(result);
    });

    NumericFilterPane_defineProperty(this, "_buildResult", () => {
      const result = {
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        includeNulls: this.props.includeNulls,
        inverted: this.props.inverted
      };
      return result;
    });

    NumericFilterPane_defineProperty(this, "_onPreferencesChanged", preferences => {
      const result = { ...this._buildResult(),
        ...preferences,
        filterSelectionType: this.props.filterSelectionType
      };
      this.props.onChange(result);
    });

    NumericFilterPane_defineProperty(this, "_renderNumericFilterPane", () => {
      const {
        fromValue,
        toValue,
        includeNulls,
        inverted,
        showLabels,
        selectedValuesCount,
        minimumValue,
        maximumValue,
        decimalPlaces,
        locale,
        totalValues,
        onClick,
        onSearch,
        getValue,
        readOnly,
        contentRenderer,
        allowSearch,
        filterSelectionType,
        showSelectionType,
        showFilterPreferences,
        allowIncludeNulls,
        allowSwitch,
        hasMoreData,
        invertDisabled,
        isSearching,
        autoFocus
      } = this.props;
      const borderStyle = {
        'border-color': '#F2F2F2',
        'border-width': '1px',
        'border-style': 'solid'
      }; // Define the styles so the when the filter is resized below a certain
      // height the apply button does not overlap with the contents in the
      // filter pane UI

      const containerStyle = {
        overflow: 'hidden'
      };
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        className: "bi-filter-numeric-pane",
        justifyContent: "space-between",
        fullHeight: true,
        direction: "column",
        "data-tid": "numericFilterPane"
      }, allowSwitch && showSelectionType && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: [1, 0, 2, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(FilterTypeSelector_FilterTypeSelector, {
        type: filterSelectionType,
        onChange: this._onFilterTypeChanged,
        readOnly: readOnly
      })), filterSelectionType === FILTER_TYPE.RANGE && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        className: "bi-filter-numeric-pane__instructions",
        gutter: [1, 0, 2, 0]
      }, /*#__PURE__*/external_react_default.a.createElement("b", null, nls_StringResource.get('sliderDirections'))), filterSelectionType === FILTER_TYPE.RANGE ? /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: 1,
        style: containerStyle
      }, /*#__PURE__*/external_react_default.a.createElement(NumericRangeFilter_NumericRangeFilter, {
        minimumValue: minimumValue,
        maximumValue: maximumValue,
        fromValue: fromValue,
        toValue: toValue,
        inverted: inverted,
        decimalPlaces: decimalPlaces,
        locale: locale,
        onChange: this._onChange,
        showLabels: showLabels,
        readOnly: readOnly,
        autoFocus: autoFocus
      })) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: 1,
        style: borderStyle
      }, /*#__PURE__*/external_react_default.a.createElement(SelectValueFilterPane_SelectValueFilterPane, {
        totalValues: totalValues,
        selectedValuesCount: selectedValuesCount,
        allowSearch: allowSearch,
        onClick: onClick,
        onChange: this._onChange,
        onSearch: onSearch,
        isSearching: isSearching,
        getValue: getValue,
        contentRenderer: contentRenderer,
        readOnly: readOnly,
        hasMoreData: hasMoreData,
        autoFocus: autoFocus
      })), showFilterPreferences && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(FilterPreferences_FilterPreferences, {
        inverted: inverted,
        includeNulls: includeNulls,
        onChange: this._onPreferencesChanged,
        onClear: this.props.onClear,
        showIncludeNull: allowIncludeNulls && filterSelectionType === FILTER_TYPE.RANGE,
        selectedValuesCount: selectedValuesCount,
        returnToTree: () => {},
        readOnly: readOnly,
        invertDisabled: invertDisabled
      })));
    });
  }

  render() {
    const {
      loading
    } = this.props;

    if (loading) {
      return /*#__PURE__*/external_react_default.a.createElement(FilterLoadingSpinner_FilterLoadingSpinner, null);
    }

    return this._renderNumericFilterPane();
  }

}

NumericFilterPane_defineProperty(NumericFilterPane_NumericFilterPane, "propTypes", {
  // Props unique to NumericFilter
  filterSelectionType: external_prop_types_default.a.oneOf([FILTER_TYPE.RANGE, FILTER_TYPE.SELECT_VALUE]),
  // Props for NumericRangeFilter
  minimumValue: external_prop_types_default.a.number,
  maximumValue: external_prop_types_default.a.number,
  fromValue: external_prop_types_default.a.number,
  toValue: external_prop_types_default.a.number,
  includeNulls: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  decimalPlaces: external_prop_types_default.a.number,
  onChange: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func,
  locale: external_prop_types_default.a.string,
  // Props for SelectValueFilter
  totalValues: external_prop_types_default.a.number,
  selectedValuesCount: external_prop_types_default.a.number,
  loading: external_prop_types_default.a.bool,
  onClick: external_prop_types_default.a.func.isRequired,
  onSearch: external_prop_types_default.a.func.isRequired,
  allowSearch: external_prop_types_default.a.bool,
  allowIncludeNulls: external_prop_types_default.a.bool,
  allowSwitch: external_prop_types_default.a.bool,
  contentRenderer: external_prop_types_default.a.func,
  getValue: external_prop_types_default.a.func,
  showLabels: external_prop_types_default.a.bool,
  showSelectionType: external_prop_types_default.a.bool,
  showFilterPreferences: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  hasMoreData: external_prop_types_default.a.bool,
  invertDisabled: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool
});

NumericFilterPane_defineProperty(NumericFilterPane_NumericFilterPane, "defaultProps", {
  filterSelectionType: FILTER_TYPE.RANGE,
  minimumValue: 0,
  maximumValue: 100,
  fromValue: 0,
  toValue: 0,
  includeNulls: false,
  inverted: false,
  invertDisabled: false,
  decimalPlaces: 5,
  selectedValuesCount: 0,
  showLabels: true,
  allowSearch: true,
  allowIncludeNulls: true,
  allowSwitch: true,
  showSelectionType: true,
  showFilterPreferences: true,
  totalValues: 0,
  readOnly: false,
  locale: undefined,
  hasMoreData: false
});
// CONCATENATED MODULE: ./src/filters/CompactNumericFilter.tsx
function CompactNumericFilter_extends() { CompactNumericFilter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CompactNumericFilter_extends.apply(this, arguments); }

function CompactNumericFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








/*
This is a common filter component that allows a filter to be applied using a
slider control. There are also options to enter to/from filter values directly
via text boxes, invert the current selection and specify whether to include
blank values. The filter type can be to switched to a 'list' filter which allows the user
to select/deselect from a list of values.
*/

class CompactNumericFilter_CompactNumericFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    CompactNumericFilter_defineProperty(this, "state", {
      showSearchInput: false,
      showSearchButton: false,
      // default is range, which has no search
      isDirty: false,
      // these states are used to determine dirty
      // these values are set in _resetDirty()
      fromValue: undefined,
      toValue: undefined,
      inverted: undefined
    });

    CompactNumericFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false,
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        inverted: this.props.inverted
      });
    });

    CompactNumericFilter_defineProperty(this, "_onSearchClick", () => {
      this.setState(prevState => ({
        showSearchInput: !prevState.showSearchInput
      }));
    });

    CompactNumericFilter_defineProperty(this, "_onShowMenu", () => {// TODO Add Menu
    });

    CompactNumericFilter_defineProperty(this, "_onChangeType", () => {
      const {
        onChange,
        filterSelectionType,
        allowSearch
      } = this.props;
      const newFilterSelectionType = filterSelectionType === FILTER_TYPE.RANGE ? FILTER_TYPE.SELECT_VALUE : FILTER_TYPE.RANGE;
      onChange && onChange({
        filterSelectionType: newFilterSelectionType
      });

      if (allowSearch) {
        this.setState({
          showSearchButton: newFilterSelectionType !== FILTER_TYPE.RANGE
        });
      }
    });

    CompactNumericFilter_defineProperty(this, "_onToggleIncludeNulls", () => {
      const {
        onChange
      } = this.props;
      onChange && onChange({
        includeNulls: !this.props.includeNulls
      });
    });

    CompactNumericFilter_defineProperty(this, "_onInvert", () => {
      const {
        onChange
      } = this.props;
      onChange && onChange({
        inverted: !this.props.inverted,
        fromValue: this.props.fromValue,
        toValue: this.props.toValue
      });
    });

    CompactNumericFilter_defineProperty(this, "_onClearAll", () => {
      const {
        onClear
      } = this.props;
      onClear && onClear();
    });

    CompactNumericFilter_defineProperty(this, "_onApply", () => {
      const {
        onApply
      } = this.props;
      onApply && onApply();

      this._resetDirty();
    });

    CompactNumericFilter_defineProperty(this, "_getContextMenu", () => {
      const menu = [];
      const {
        filterSelectionType,
        includeNulls,
        allowSwitch,
        allowIncludeNulls
      } = this.props;

      if (allowSwitch && filterSelectionType === FILTER_TYPE.RANGE) {
        menu.push({
          label: nls_StringResource.get('individualItems'),
          fn: this._onChangeType
        });
      } else if (allowSwitch) {
        menu.push({
          label: nls_StringResource.get('upperRange'),
          fn: this._onChangeType
        });
      }

      if (allowIncludeNulls && filterSelectionType === FILTER_TYPE.RANGE) {
        menu.push({
          label: includeNulls ? nls_StringResource.get('excludeBlankValues') : nls_StringResource.get('includeBlankValues'),
          fn: this._onToggleIncludeNulls
        });
      }

      menu.push({
        label: nls_StringResource.get('invert'),
        fn: this._onInvert
      });
      menu.push({
        label: nls_StringResource.get('clearAll'),
        fn: this._onClearAll
      });
      return menu;
    });
  }

  componentWillMount() {
    this._resetDirty();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isDirty: this.state.fromValue !== nextProps.fromValue || this.state.toValue !== nextProps.toValue || this.state.inverted !== nextProps.inverted
    });
  }

  render() {
    const {
      title,
      menuTitle,
      onChange,
      loading,
      readOnly,
      allowSearch,
      locale,
      hasMoreData,
      isSearching
    } = this.props;
    const {
      showSearchInput,
      showSearchButton
    } = this.state;

    const menu = this._getContextMenu();

    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column",
      minHeight: "212px"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [2, 2, 0, 2],
      className: "bi-filter-compact-filter-title"
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      menuTitle: menuTitle,
      showSearch: allowSearch && showSearchButton,
      onSearch: this._onSearchClick,
      onShowMenu: this._onShowMenu,
      menu: menu,
      loading: loading,
      height: 40,
      readOnly: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: [1, 2, 2, 2]
    }, /*#__PURE__*/external_react_default.a.createElement(NumericFilterPane_NumericFilterPane, CompactNumericFilter_extends({}, this.props, {
      allowSearch: allowSearch && showSearchInput,
      onChange: onChange,
      showSelectionType: false,
      showFilterPreferences: false,
      readOnly: readOnly,
      locale: locale,
      isSearching: isSearching,
      hasMoreData: hasMoreData
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      textAlign: "center",
      gutter: 0
    }, /*#__PURE__*/external_react_default.a.createElement(ApplyButton_ApplyButton, {
      dirty: this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty,
      onApply: this._onApply,
      loading: loading,
      readOnly: readOnly
    })));
  }

}

CompactNumericFilter_defineProperty(CompactNumericFilter_CompactNumericFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  menuTitle: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  filterSelectionType: external_prop_types_default.a.oneOf([FILTER_TYPE.RANGE, FILTER_TYPE.SELECT_VALUE]),
  locale: external_prop_types_default.a.string,
  includeNulls: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  onClear: external_prop_types_default.a.func,
  loading: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  allowIncludeNulls: external_prop_types_default.a.bool,
  allowSwitch: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  fromValue: external_prop_types_default.a.number,
  toValue: external_prop_types_default.a.number,
  hasMoreData: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool
});

CompactNumericFilter_defineProperty(CompactNumericFilter_CompactNumericFilter, "defaultProps", {
  filterSelectionType: FILTER_TYPE.RANGE,
  minimumValue: 0,
  maximumValue: 100,
  fromValue: 0,
  toValue: 0,
  includeNulls: false,
  inverted: false,
  decimalPlaces: 5,
  selectedValuesCount: 0,
  loading: false,
  showLabels: true,
  readOnly: false,
  allowIncludeNulls: true,
  allowSwitch: true,
  allowSearch: true,
  locale: undefined,
  hasMoreData: false
});
// CONCATENATED MODULE: ./src/filters/NumericFilter.tsx
function NumericFilter_extends() { NumericFilter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return NumericFilter_extends.apply(this, arguments); }

function NumericFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







/*
This is a common filter component that allows a filter to be applied using a
slider control. There are also options to enter to/from filter values directly
via text boxes, invert the current selection and specify whether to include
blank values. The filter type can be to switched to a 'list' filter which allows the user
to select/deselectSVGIcon from a list of values.
*/

class NumericFilter_NumericFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    NumericFilter_defineProperty(this, "state", {
      isDirty: false,
      // these states are used to determine dirty
      // these values are set in _resetDirty()
      fromValue: undefined,
      toValue: undefined,
      inverted: undefined
    });

    NumericFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false,
        fromValue: this.props.fromValue,
        toValue: this.props.toValue,
        inverted: this.props.inverted
      });
    });

    NumericFilter_defineProperty(this, "_onChange", result => {
      this.props.onChange(result);
    });

    NumericFilter_defineProperty(this, "_onApply", () => {
      this.props.onApply();

      this._resetDirty();
    });

    NumericFilter_defineProperty(this, "_onClear", () => {
      this.props.onClear();
    });

    NumericFilter_defineProperty(this, "_onClose", () => {
      this.props.onClose();
    });

    NumericFilter_defineProperty(this, "_onOk", () => {
      this._onApply();

      this.props.onDone();
    });

    NumericFilter_defineProperty(this, "_onCancel", () => {
      this.props.onClose();
    });
  }

  componentWillMount() {
    this._resetDirty();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isDirty: this.state.fromValue !== nextProps.fromValue || this.state.toValue !== nextProps.toValue || this.state.inverted !== nextProps.inverted
    });
  }

  render() {
    const {
      title,
      actionTitle,
      loading,
      readOnly,
      allowSearch,
      allowIncludeNulls,
      allowSwitch,
      hasMoreData,
      showHeader,
      showCancel
    } = this.props;
    const showClose = true;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column",
      "data-tid": "numericFilter"
    }, showHeader && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [3, 3, 3, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      actionTitle: actionTitle,
      showSearch: false // always false, turns off the icon
      ,
      showMenu: false,
      showClose: showClose,
      onClose: this._onClose,
      height: 16,
      readOnly: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: [1, 3, 2, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(NumericFilterPane_NumericFilterPane, NumericFilter_extends({}, this.props, {
      allowSwitch: allowSwitch,
      onChange: this._onChange,
      allowSearch: allowSearch,
      readOnly: readOnly,
      allowIncludeNulls: allowIncludeNulls,
      hasMoreData: hasMoreData
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(FilterFooter_FilterFooter, {
      loading: loading,
      readOnly: readOnly,
      onClear: this._onClear,
      onApply: this._onApply,
      onOk: this._onOk,
      onCancel: this._onCancel,
      showCancel: showCancel,
      dirty: this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty
    })));
  }

}

NumericFilter_defineProperty(NumericFilter_NumericFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  actionTitle: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  onClose: external_prop_types_default.a.func.isRequired,
  onDone: external_prop_types_default.a.func.isRequired,
  loading: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  allowSwitch: external_prop_types_default.a.bool,
  allowIncludeNulls: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  fromValue: external_prop_types_default.a.number,
  decimalPlaces: external_prop_types_default.a.number,
  toValue: external_prop_types_default.a.number,
  hasMoreData: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  showHeader: external_prop_types_default.a.bool
});

NumericFilter_defineProperty(NumericFilter_NumericFilter, "defaultProps", {
  filterSelectionType: FILTER_TYPE.RANGE,
  minimumValue: 0,
  maximumValue: 100,
  fromValue: 0,
  toValue: 0,
  includeNulls: false,
  inverted: false,
  decimalPlaces: 5,
  selectedValuesCount: 0,
  loading: false,
  showLabels: true,
  readOnly: false,
  allowSearch: true,
  allowSwitch: true,
  allowIncludeNulls: true,
  hasMoreData: false,
  showHeader: true,
  showCancel: true
});
// EXTERNAL MODULE: external "@ba/ba-graphics/dist/icons-js/add_32.js"
var add_32_js_ = __webpack_require__(80);
var add_32_js_default = /*#__PURE__*/__webpack_require__.n(add_32_js_);

// CONCATENATED MODULE: ./src/filters/ConditionTypeOptions.ts
function ConditionTypeOptions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

class ConditionTypeOptions_ConditionTypeOptions {
  constructor() {
    ConditionTypeOptions_defineProperty(this, "_options", void 0);

    this._options = [// NOTE:
    // the value items below are used internally - they should not be changed.
    {
      value: 'equals',
      label: nls_StringResource.get('equals'),
      inverted: nls_StringResource.get('doesNotEqual'),
      invert: false,
      operation: 'equals'
    }, {
      value: 'contains',
      label: nls_StringResource.get('contains'),
      inverted: nls_StringResource.get('doesNotContain'),
      invert: false,
      operation: 'contains'
    }, {
      value: 'startsWith',
      label: nls_StringResource.get('beginsWith'),
      inverted: nls_StringResource.get('doesNotBeginWith'),
      invert: false,
      operation: 'startsWith'
    }, {
      value: 'endsWith',
      label: nls_StringResource.get('endsWith'),
      inverted: nls_StringResource.get('doesNotEndWith'),
      invert: false,
      operation: 'endsWith'
    }, {
      value: 'doesNotEqual',
      label: nls_StringResource.get('doesNotEqual'),
      inverted: nls_StringResource.get('equals'),
      invert: true,
      operation: 'equals'
    }, {
      value: 'doesNotContain',
      label: nls_StringResource.get('doesNotContain'),
      inverted: nls_StringResource.get('contains'),
      invert: true,
      operation: 'contains'
    }, {
      value: 'doesNotBeginWith',
      label: nls_StringResource.get('doesNotBeginWith'),
      inverted: nls_StringResource.get('beginsWith'),
      invert: true,
      operation: 'startsWith'
    }, {
      value: 'doesNotEndWith',
      label: nls_StringResource.get('doesNotEndWith'),
      inverted: nls_StringResource.get('endsWith'),
      invert: true,
      operation: 'endsWith'
    }];
  }

  get list() {
    return this._options;
  }

  get defaultOption() {
    return this._options[1];
  }

  label(predicate) {
    let label = '';

    const option = this._options.find(item => predicate.conditionType === item.value);

    if (option) {
      label = predicate.invert === true ? option.inverted : option.label;
    }

    return label;
  }

}
// CONCATENATED MODULE: ./src/filters/ConditionSelector.tsx
function ConditionSelector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





class ConditionSelector_ConditionSelector extends external_react_["Component"] {
  // Define properties and types
  constructor(props) {
    super(props);

    ConditionSelector_defineProperty(this, "_options", void 0);

    ConditionSelector_defineProperty(this, "_onConditionTypeChanged", e => {
      const option = this._options.list.find(item => item.value === e);

      const result = this._buildPredicate(option.operation, this.props.value, option.invert);

      this.props.onChange(result);
    });

    ConditionSelector_defineProperty(this, "_onConditionValueChanged", e => {
      let option = this._options.list.find(item => item.operation === this.props.type && item.invert === this.props.invert);

      if (!option) {
        option = this._options.defaultOption;
      }

      const result = this._buildPredicate(option.operation, e, option.invert);

      this.props.onChange(result);
    });

    ConditionSelector_defineProperty(this, "_buildPredicate", (type, value, invert) => {
      const {
        defaultOption
      } = this._options;
      const condition = {
        position: this.props.position,
        predicate: {
          conditionType: !type ? defaultOption.value : type,
          value: !value ? '' : value,
          invert: !invert ? defaultOption.invert : invert
        }
      };
      return condition;
    });

    this._options = new ConditionTypeOptions_ConditionTypeOptions();
  }

  render() {
    const {
      value,
      type,
      invert
    } = this.props;
    const options = this._options.list;
    const selectedLabel = !type ? this._options.defaultOption.value : options.find(item => item.operation === type && item.invert === invert).value;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "column",
      "data-tid": this.props['data-tid']
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: [3, 0, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Select"], {
      light: true,
      "data-tid": "conditionDropDown",
      onChange: this._onConditionTypeChanged,
      size: "small",
      truncated: false,
      customWidth: "100%",
      selected: selectedLabel,
      options: options,
      domNodeToAttachTo: false
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: [1, 0, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TextInput"], {
      light: true,
      fullWidth: true,
      placeholder: nls_StringResource.get('enterValue'),
      value: value,
      onChange: this._onConditionValueChanged
    })));
  }

}

ConditionSelector_defineProperty(ConditionSelector_ConditionSelector, "propTypes", {
  position: external_prop_types_default.a.number.isRequired,
  type: external_prop_types_default.a.oneOf(['equals', 'contains', 'startsWith', 'endsWith', 'doesNotEqual', 'doesNotContain', 'doesNotBeginWith', 'doesNotEndWith']),
  invert: external_prop_types_default.a.bool,
  value: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func.isRequired,
  'data-tid': external_prop_types_default.a.string
});
// CONCATENATED MODULE: ./src/filters/OperatorSelector.tsx
function OperatorSelector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-find-dom-node */

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





class OperatorSelector_OperatorSelector extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    OperatorSelector_defineProperty(this, "radioGroup", void 0);
  }

  componentDidMount() {
    const node = Object(external_react_dom_["findDOMNode"])(this.radioGroup);
    node && node.focus();
  }

  render() {
    const {
      onChange,
      operator
    } = this.props;
    const radioOptions = [{
      label: nls_StringResource.get('and'),
      value: 'and'
    }, {
      label: nls_StringResource.get('or'),
      value: 'or'
    }];
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "row"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [0, 3, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["RadioGroup"], {
      ref: radioGroup => {
        this.radioGroup = radioGroup;
      },
      checked: operator,
      name: "operator",
      options: radioOptions,
      selectedId: operator,
      align: "left",
      direction: "horizontal",
      onChange: onChange
    })));
  }

}

OperatorSelector_defineProperty(OperatorSelector_OperatorSelector, "propTypes", {
  operator: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func.isRequired
});

OperatorSelector_defineProperty(OperatorSelector_OperatorSelector, "defaultProps", {
  operator: 'and'
});
// EXTERNAL MODULE: ./src/filters/PredicateSelector.scss
var filters_PredicateSelector = __webpack_require__(81);

// CONCATENATED MODULE: ./src/filters/PredicateSelector.tsx
function PredicateSelector_extends() { PredicateSelector_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return PredicateSelector_extends.apply(this, arguments); }

function PredicateSelector_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */











class PredicateSelector_PredicateSelector extends external_react_["Component"] {
  constructor(...args) {
    var _this$props$condition, _this$props$condition2, _this$props$condition3, _this$props$condition4, _this$props$condition5;

    super(...args);

    PredicateSelector_defineProperty(this, "state", {
      firstPredicate: (_this$props$condition = this.props.condition) == null ? void 0 : (_this$props$condition2 = _this$props$condition.predicates) == null ? void 0 : _this$props$condition2[0],
      secondPredicate: (_this$props$condition3 = this.props.condition) == null ? void 0 : (_this$props$condition4 = _this$props$condition3.predicates) == null ? void 0 : _this$props$condition4[1],
      logicalOperation: (_this$props$condition5 = this.props.condition) == null ? void 0 : _this$props$condition5.logicalOperation,
      disableDoneButton: true
    });

    PredicateSelector_defineProperty(this, "_clearAllButton", void 0);

    PredicateSelector_defineProperty(this, "_setState", condition => {
      if (condition) {
        if (condition.predicates && condition.predicates.length > 1) {
          this.setState({
            firstPredicate: condition.predicates[0],
            secondPredicate: condition.predicates[1],
            logicalOperation: condition.logicalOperation
          }, this._setDisableDoneButton);
        } else if (condition.predicates && condition.predicates.length === 1) {
          this.setState({
            firstPredicate: condition.predicates[0]
          }, this._setDisableDoneButton);
        }
      } else {
        this.setState({
          firstPredicate: undefined,
          secondPredicate: undefined,
          logicalOperation: undefined
        }, this._setDisableDoneButton);
      }
    });

    PredicateSelector_defineProperty(this, "_setDisableDoneButton", () => {
      const {
        firstPredicate,
        secondPredicate
      } = this.state;

      if (firstPredicate && !secondPredicate) {
        this.setState({
          disableDoneButton: false
        });
      } else if (firstPredicate && secondPredicate) {
        if (firstPredicate.value.length === 0 && secondPredicate.value.length !== 0) {
          this.setState({
            disableDoneButton: true
          });
        } else {
          this.setState({
            disableDoneButton: false
          });
        }
      } else {
        this.setState({
          disableDoneButton: false
        });
      }
    });

    PredicateSelector_defineProperty(this, "_onConditionChange", v => {
      if (v.position === 0) {
        this.setState({
          firstPredicate: v.predicate
        }, this._setDisableDoneButton);
      } else {
        this.setState({
          secondPredicate: v.predicate
        }, this._setDisableDoneButton);
      }
    });

    PredicateSelector_defineProperty(this, "_onAddCondition", () => {
      const {
        defaultOption
      } = new ConditionTypeOptions_ConditionTypeOptions();
      this.setState({
        secondPredicate: {
          conditionType: defaultOption.operation,
          value: '',
          invert: defaultOption.invert
        },
        logicalOperation: 'and'
      });
    });

    PredicateSelector_defineProperty(this, "_onOperatorChange", v => {
      this.setState({
        logicalOperation: v,
        disableDoneButton: false
      });
    });

    PredicateSelector_defineProperty(this, "_onClear", () => {
      this._setState(null);
    });

    PredicateSelector_defineProperty(this, "_onDone", () => {
      const {
        onConditionChange
      } = this.props;
      const {
        firstPredicate,
        secondPredicate,
        logicalOperation
      } = this.state;
      let condition = null;

      if (firstPredicate && firstPredicate.value.length > 0) {
        condition = this._getDefaultCondition();
        condition.predicates = [];
        condition.predicates[0] = PredicateSelector_PredicateSelector.getPredicate(firstPredicate);

        if (secondPredicate && secondPredicate.value.length > 0) {
          condition.predicates[1] = PredicateSelector_PredicateSelector.getPredicate(secondPredicate);
          condition.logicalOperation = logicalOperation;
        }
      }

      if (condition || this.props.condition) {
        onConditionChange(condition);
      }
    });

    PredicateSelector_defineProperty(this, "_getDefaultCondition", () => {
      const condition = {
        predicates: [{
          conditionType: 'equals',
          value: '',
          invert: false
        }]
      };
      return condition;
    });
  }

  static getPredicate(predicate) {
    return external_lodash_default.a.pick(predicate, ['conditionType', 'value', 'invert']);
  }

  componentWillReceiveProps(nextProps) {
    const {
      condition
    } = nextProps;

    this._setState(condition);
  }

  focus() {
    // Explicitly focus the 'clear all' button using the raw DOM API
    this._clearAllButton.focus();
  }

  render() {
    const {
      onClose
    } = this.props;
    const {
      firstPredicate,
      secondPredicate,
      logicalOperation,
      disableDoneButton
    } = this.state;
    const closeString = nls_StringResource.get('close');
    const addConditionString = nls_StringResource.get('addCondition');
    const clearConditionsString = nls_StringResource.get('clearConditions');
    const applyString = nls_StringResource.get('apply');
    const setFilterCondition = nls_StringResource.get('setFilterCondition');
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
      role: "application",
      gutter: [0, 1.25, 0, 1.25],
      minWidth: "400px"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      direction: "column",
      className: "bi-filter-setFilterCondition"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Dialog"].Header, null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
      value: setFilterCondition
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      hasIconOnly: true,
      kind: "ghost",
      size: "small",
      renderIcon: props => /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], PredicateSelector_extends({
        icon: close_16_js_default.a
      }, props)),
      iconDescription: closeString,
      "data-tid": "closeConditionClickable",
      onClick: onClose
    })))), /*#__PURE__*/external_react_default.a.createElement(ConditionSelector_ConditionSelector, {
      "data-tid": "firstConditionSection",
      position: 0,
      type: firstPredicate && firstPredicate.conditionType,
      invert: firstPredicate && firstPredicate.invert,
      value: firstPredicate ? firstPredicate.value : '',
      onChange: this._onConditionChange
    }), !secondPredicate ? /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [3, 0, 0, 0],
      maxWidth: "224px"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      onClick: this._onAddCondition,
      disabled: !firstPredicate || firstPredicate.value.length === 0,
      kind: "ghost",
      renderIcon: props => /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], PredicateSelector_extends({
        icon: add_32_js_default.a
      }, props)),
      "data-tid": "addConditionClickable",
      style: {
        paddingLeft: '0px',
        paddingRight: '0px'
      } // until UX carbonizes dialog

    }, addConditionString)) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [2, 0, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(OperatorSelector_OperatorSelector, {
      onChange: this._onOperatorChange,
      operator: logicalOperation
    }), /*#__PURE__*/external_react_default.a.createElement(ConditionSelector_ConditionSelector, {
      "data-tid": "secondConditionSection",
      position: 1,
      type: secondPredicate && secondPredicate.conditionType,
      invert: secondPredicate && secondPredicate.invert,
      value: secondPredicate && secondPredicate.value,
      onChange: this._onConditionChange
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [3, 0, 0, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      textAlign: "left"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      ref: btn => {
        this._clearAllButton = btn;
      },
      "data-tid": "clearConditionsClickable",
      kind: "ghost",
      style: {
        paddingLeft: '0px',
        paddingRight: '0px'
      } // until UX carbonizes dialog
      ,
      onClick: this._onClear,
      disabled: !firstPredicate || firstPredicate.value.length === 0 && !secondPredicate
    }, clearConditionsString)), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      textAlign: "right"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
      "data-tid": "applyClickable",
      onClick: this._onDone,
      disabled: disableDoneButton
    }, applyString))))));
  }

}

PredicateSelector_defineProperty(PredicateSelector_PredicateSelector, "propTypes", {
  onConditionChange: external_prop_types_default.a.func.isRequired,
  condition: external_prop_types_default.a.object,
  onClose: external_prop_types_default.a.func.isRequired
});
// CONCATENATED MODULE: ./src/filters/SummaryHelper.ts
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


class SummaryHelper_SummaryHelper {
  static getSummary(condition, inverted) {
    let summary = '';
    const invertPrefix = inverted ? 'NOT( ' : '';
    const invertSuffix = inverted ? ' )' : '';
    const options = new ConditionTypeOptions_ConditionTypeOptions();
    condition.predicates.forEach((predicate, index) => {
      // When condition.logicalOperation exists...
      //   - there are two and only two predicates
      //   - the conditionType strings in each predicate will be empty strings
      // This function is unsafe/overloaded - it should be rewritten.
      if (index === 1) {
        summary = `${summary} ${nls_StringResource.get(condition.logicalOperation).toLowerCase()} `;
      }

      summary = `${summary}${options.label(predicate)} '${predicate.value}'`;
    }); // Capitalize the first letter and lower-case the rest

    return `${invertPrefix}${summary[0].toUpperCase()}${summary.slice(1).toLowerCase()}${invertSuffix}`;
  }

}
// EXTERNAL MODULE: ./src/filters/FilterSummary.scss
var filters_FilterSummary = __webpack_require__(83);

// CONCATENATED MODULE: ./src/filters/FilterSummary.tsx
function FilterSummary_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








class FilterSummary_FilterSummary extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    FilterSummary_defineProperty(this, "_conditionSummaryId1", void 0);

    FilterSummary_defineProperty(this, "_conditionSummaryId2", void 0);

    FilterSummary_defineProperty(this, "_filterHeader", void 0);

    FilterSummary_defineProperty(this, "_onMenu", () => {
      this.props.onMenu();
    });
  }

  componentWillMount() {
    this._conditionSummaryId1 = Object(external_lodash_["uniqueId"])('conditionSummary-');
    this._conditionSummaryId2 = Object(external_lodash_["uniqueId"])('conditionSummary-');
  }

  focus() {
    this._filterHeader.focus();
  }

  render() {
    const {
      title,
      showMenu,
      condition,
      inverted,
      readOnly,
      hasManualSelections,
      menuButtonPressed,
      isMenuEditButton
    } = this.props;
    const showSearch = false;
    const showClose = false;
    const showMatch = true;
    const ids = hasManualSelections ? `${this._conditionSummaryId1} ${this._conditionSummaryId2}` : this._conditionSummaryId1;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      className: "bi-filter-summary",
      direction: "column"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [1, 1, 0.5, 0]
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      ref: header => {
        this._filterHeader = header;
      },
      title: title,
      onMenu: this._onMenu,
      showMenu: showMenu,
      menuTitle: nls_StringResource.get('editCondition'),
      menuButtonPressed: menuButtonPressed,
      showSearch: showSearch,
      showClose: showClose,
      readOnly: readOnly,
      showMatchCondition: showMatch,
      menuButtonDescribedby: ids,
      isMenuEditButton: isMenuEditButton
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [0, 2, 2, 2],
      id: this._conditionSummaryId1,
      className: "bi-filter-summary-desc",
      "data-tid": "filterSummarySection"
    }, SummaryHelper_SummaryHelper.getSummary(condition, inverted)), hasManualSelections && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [0, 2, 2, 2],
      id: this._conditionSummaryId2
    }, nls_StringResource.get('containsExcludedIncludedItems')));
  }

}

FilterSummary_defineProperty(FilterSummary_FilterSummary, "propTypes", {
  showMenu: external_prop_types_default.a.bool,
  title: external_prop_types_default.a.string.isRequired,
  condition: external_prop_types_default.a.object.isRequired,
  inverted: external_prop_types_default.a.bool.isRequired,
  onMenu: external_prop_types_default.a.func,
  readOnly: external_prop_types_default.a.bool,
  hasManualSelections: external_prop_types_default.a.bool,
  menuButtonPressed: external_prop_types_default.a.bool,
  isMenuEditButton: external_prop_types_default.a.bool
});

FilterSummary_defineProperty(FilterSummary_FilterSummary, "defaultProps", {
  showMenu: true,
  readOnly: false,
  isMenuEditButton: true,
  hasManualSelections: false,
  menuButtonPressed: false
});
// EXTERNAL MODULE: ./src/filters/ConditionBuilder.scss
var filters_ConditionBuilder = __webpack_require__(85);

// CONCATENATED MODULE: ./src/filters/ConditionBuilder.tsx
function ConditionBuilder_extends() { ConditionBuilder_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ConditionBuilder_extends.apply(this, arguments); }

function ConditionBuilder_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








class ConditionBuilder_ConditionBuilder extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    ConditionBuilder_defineProperty(this, "_filterSummary", void 0);

    ConditionBuilder_defineProperty(this, "_addConditionButton", void 0);

    ConditionBuilder_defineProperty(this, "_setFocus", (showToggleButton, condition) => {
      if (showToggleButton) {
        if (condition) {
          if (this._filterSummary) this._filterSummary.focus();
        } else if (this._addConditionButton) this._addConditionButton.focus();
      }
    });

    ConditionBuilder_defineProperty(this, "_onToggle", () => {
      const {
        open,
        condition,
        toggleSlideout,
        showToggleButton,
        readOnly
      } = this.props;

      if (readOnly) {
        return;
      }

      toggleSlideout(!open); // We are closing the menu so focus the 'Add condition' button

      open && this._setFocus(showToggleButton, condition);
    });

    ConditionBuilder_defineProperty(this, "_onConditionValueChanged", result => {
      this.props.onChange(result);
    });

    ConditionBuilder_defineProperty(this, "_renderCondition", () => {
      const {
        open,
        condition,
        showToggleButton,
        readOnly,
        inverted,
        hasManualSelections
      } = this.props;
      return /*#__PURE__*/external_react_default.a.createElement("div", null, condition === null ? showToggleButton && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Button"], {
        ref: btn => {
          this._addConditionButton = btn;
        },
        "data-tid": "addFilterClickable",
        onClick: this._onToggle,
        kind: "ghost",
        size: "small",
        renderIcon: props => /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["SVGIcon"], ConditionBuilder_extends({
          icon: add_32_js_default.a
        }, props)),
        disabled: readOnly,
        "aria-pressed": open,
        style: {
          paddingLeft: '0px',
          paddingRight: '0px'
        } // until UX carbonizes dialog

      }, nls_StringResource.get('addFilterCondition')) : /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true
      }, /*#__PURE__*/external_react_default.a.createElement(FilterSummary_FilterSummary, {
        ref: summary => {
          this._filterSummary = summary;
        },
        title: nls_StringResource.get('filterCondition'),
        condition: condition,
        onMenu: this._onToggle,
        menuButtonPressed: open,
        inverted: inverted,
        readOnly: readOnly,
        hasManualSelections: hasManualSelections
      }))));
    });
  }

  render() {
    const {
      open,
      condition
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      grow: true,
      direction: "row"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: !condition ? [0, 0, 2, 0] : [0, 0, 3, 0]
    }, this._renderCondition(), open && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Flyout"], {
      placement: "right",
      theme: "dark"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Container"], {
      gutter: 1
    }, /*#__PURE__*/external_react_default.a.createElement(PredicateSelector_PredicateSelector, {
      condition: condition,
      onConditionChange: this._onConditionValueChanged,
      onClose: this._onToggle
    })))));
  }

}

ConditionBuilder_defineProperty(ConditionBuilder_ConditionBuilder, "propTypes", {
  onChange: external_prop_types_default.a.func.isRequired,
  toggleSlideout: external_prop_types_default.a.func.isRequired,
  open: external_prop_types_default.a.bool.isRequired,
  showToggleButton: external_prop_types_default.a.bool,
  condition: external_prop_types_default.a.object,
  inverted: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  hasManualSelections: external_prop_types_default.a.bool
});

ConditionBuilder_defineProperty(ConditionBuilder_ConditionBuilder, "defaultProps", {
  toggleSlideout: null,
  open: false,
  showToggleButton: true,
  readOnly: false,
  inverted: false,
  hasManualSelections: false
});
// EXTERNAL MODULE: ./src/filters/CompactNonNumericFilter.scss
var filters_CompactNonNumericFilter = __webpack_require__(87);

// CONCATENATED MODULE: ./src/filters/CompactNonNumericFilter.tsx
function CompactNonNumericFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */










class CompactNonNumericFilter_CompactNonNumericFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    CompactNonNumericFilter_defineProperty(this, "state", {
      isOpen: false,
      showSearch: this.props.allowSearch,
      // this hides/shows the search input
      isDirty: false,
      // these states are used to determine dirty
      // these values are set in _resetDirty()
      selectedValuesCount: undefined,
      inverted: undefined
    });

    CompactNonNumericFilter_defineProperty(this, "getConditionFlyoutContentContainerId", () => {
      const id = this.props.conditionFlyoutContentContainerId;

      if (typeof id === 'undefined' || id === null || id === '') {
        return this._conditionFlyoutContentContainerId;
      }

      return id;
    });

    CompactNonNumericFilter_defineProperty(this, "_conditionFlyoutContentContainerId", void 0);

    CompactNonNumericFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false,
        selectedValuesCount: this.props.selectedValuesCount,
        inverted: this.props.inverted
      });
    });

    CompactNonNumericFilter_defineProperty(this, "_onSearchClick", () => {
      this.setState(prevState => ({
        showSearch: !prevState.showSearch
      }));
    });

    CompactNonNumericFilter_defineProperty(this, "_onEditFilter", () => {
      this.setState({
        isOpen: true
      });
    });

    CompactNonNumericFilter_defineProperty(this, "_onInvert", () => {
      const {
        onChange
      } = this.props;
      onChange && onChange({
        inverted: !this.props.inverted
      });
    });

    CompactNonNumericFilter_defineProperty(this, "_onClearAll", () => {
      const {
        onClear
      } = this.props;
      onClear && onClear();
    });

    CompactNonNumericFilter_defineProperty(this, "_onOpenCondition", () => {
      this.setState({
        isOpen: true
      });
    });

    CompactNonNumericFilter_defineProperty(this, "_onCloseCondition", () => {
      this.setState({
        isOpen: false
      });
    });

    CompactNonNumericFilter_defineProperty(this, "_shouldShowCondition", () => {
      const {
        showCondition,
        allowCondition
      } = this.props;

      if (showCondition !== undefined && showCondition !== null) {
        return showCondition; // legacy, takes precedence
      }

      return allowCondition;
    });

    CompactNonNumericFilter_defineProperty(this, "_getContextMenu", () => {
      const menu = [];
      menu.push({
        label: nls_StringResource.get('invert'),
        fn: this._onInvert
      });
      menu.push({
        label: nls_StringResource.get('clearAll'),
        fn: this._onClearAll
      });

      if (this.state.isOpen !== true && this._shouldShowCondition()) {
        const {
          condition
        } = this.props;
        const label = condition && condition.predicates ? nls_StringResource.get('editCondition') : nls_StringResource.get('newCondition');
        menu.push({
          label,
          fn: this._onOpenCondition
        });
      }

      return menu;
    });

    CompactNonNumericFilter_defineProperty(this, "_onApply", () => {
      const {
        onApply
      } = this.props;
      onApply && onApply();

      this._resetDirty();
    });
  }

  componentWillMount() {
    this._conditionFlyoutContentContainerId = Object(external_lodash_["uniqueId"])('filter-condition-');

    this._resetDirty();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isDirty: this.state.selectedValuesCount !== nextProps.selectedValuesCount || this.state.inverted !== nextProps.inverted
    });
  }

  _renderCondition() {
    const {
      isOpen
    } = this.state;
    const {
      condition,
      onChange,
      readOnly
    } = this.props;

    if (isOpen) {
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        padding: [0, 0, 0, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(ConditionBuilder_ConditionBuilder, {
        condition: condition,
        onChange: onChange,
        open: isOpen,
        toggleSlideout: this._onCloseCondition,
        showToggleButton: false,
        height: 0,
        readOnly: readOnly,
        conditionFlyoutContentContainerId: this.getConditionFlyoutContentContainerId()
      }));
    }

    return null;
  }

  render() {
    const {
      showSearch
    } = this.state; // TODO add onInvert and onClear

    const {
      condition,
      showHeader,
      title,
      menuTitle,
      loading,
      selectedValuesCount,
      totalValues,
      onSearch,
      onChange,
      onClick,
      getValue,
      contentRenderer,
      readOnly,
      allowSearch,
      hasMoreData,
      isSearching,
      showToggle
    } = this.props;
    const borderStyle = {
      'border-color': '#F2F2F2',
      'border-width': '1px',
      'border-style': 'solid'
    };
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      className: "bi-filter-select-value",
      direction: "column"
    }, showHeader === true && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [2, 2, 0, 2],
      className: "bi-filter-compact-filter-title"
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      menuTitle: menuTitle,
      onSearch: this._onSearchClick,
      menu: this._getContextMenu(),
      loading: loading,
      height: 40,
      readOnly: readOnly,
      showSearch: allowSearch
    })), showToggle && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [3, 3, 0, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ToggleSwitchSection"], {
      label: nls_StringResource.get('allMembers'),
      checked: this.props.isToggled,
      onChange: this.props.onToggleChange
    })), this._shouldShowCondition() && !loading && this._renderCondition(), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: [1, 2, 2, 2],
      style: borderStyle
    }, /*#__PURE__*/external_react_default.a.createElement(SelectValueFilterPane_SelectValueFilterPane, {
      condition: condition,
      totalValues: totalValues,
      selectedValuesCount: selectedValuesCount,
      loading: loading,
      allowSearch: allowSearch && showSearch,
      onClick: onClick,
      onChange: onChange,
      onSearch: onSearch,
      isSearching: isSearching,
      getValue: getValue,
      contentRenderer: contentRenderer,
      showFilterPreferences: false,
      readOnly: readOnly,
      hasMoreData: hasMoreData
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      textAlign: "center"
    }, /*#__PURE__*/external_react_default.a.createElement(ApplyButton_ApplyButton, {
      dirty: this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty,
      onApply: this._onApply,
      loading: loading,
      readOnly: readOnly
    })));
  }

}

CompactNonNumericFilter_defineProperty(CompactNonNumericFilter_CompactNonNumericFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  menuTitle: external_prop_types_default.a.string,
  totalValues: external_prop_types_default.a.number.isRequired,
  selectedValuesCount: external_prop_types_default.a.number,
  loading: external_prop_types_default.a.bool,
  onClick: external_prop_types_default.a.func.isRequired,
  onChange: external_prop_types_default.a.func.isRequired,
  // onInvert: PropTypes.func.isRequired,
  // onClear: PropTypes.func.isRequired,
  onSearch: external_prop_types_default.a.func,
  onApply: external_prop_types_default.a.func.isRequired,
  contentRenderer: external_prop_types_default.a.func,
  getValue: external_prop_types_default.a.func.isRequired,
  condition: external_prop_types_default.a.object,
  allowSearch: external_prop_types_default.a.bool,
  showCondition: external_prop_types_default.a.bool,
  allowCondition: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  onClear: external_prop_types_default.a.func,
  isDirty: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool,
  showToggle: external_prop_types_default.a.bool,
  onToggleChange: external_prop_types_default.a.func,
  isToggled: external_prop_types_default.a.bool,
  // Non-API props
  showHeader: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  conditionFlyoutContentContainerId: external_prop_types_default.a.string,
  hasMoreData: external_prop_types_default.a.bool
});

CompactNonNumericFilter_defineProperty(CompactNonNumericFilter_CompactNonNumericFilter, "defaultProps", {
  title: '',
  selectedValuesCount: 0,
  loading: false,
  showHeader: true,
  inverted: false,
  showCondition: undefined,
  readOnly: false,
  allowCondition: true,
  allowSearch: true,
  hasMoreData: false,
  showToggle: false,
  isToggled: false
});
// CONCATENATED MODULE: ./src/filters/NonNumericFilterPane.tsx
function NonNumericFilterPane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */







/*
This is a common filter component that allows a filter to be applied using a
slider control. There are also options to enter to/from filter values directly
via text boxes, invert the current selection and specify whether to include
blank values. The filter type can be to switched to a 'list' filter which allows the user
to select/deselectSVGIcon from a list of values.
*/

class NonNumericFilterPane_NonNumericFilterPane extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    NonNumericFilterPane_defineProperty(this, "state", {
      isOpen: false
    });

    NonNumericFilterPane_defineProperty(this, "_onChange", result => {
      this.props.onChange(result);
    });

    NonNumericFilterPane_defineProperty(this, "_buildResult", () => {
      const result = {
        inverted: this.props.inverted
      };
      return result;
    });

    NonNumericFilterPane_defineProperty(this, "_onPreferencesChanged", preferences => {
      const result = { ...this._buildResult(),
        ...preferences,
        condition: this.props.condition
      };
      this.props.onChange(result);
    });

    NonNumericFilterPane_defineProperty(this, "_toggleSlideout", open => {
      this.setState({
        isOpen: open
      });
    });

    NonNumericFilterPane_defineProperty(this, "_onConditionChange", v => {
      const result = { ...this._buildResult(),
        condition: v
      };
      this.props.onChange(result);
    });

    NonNumericFilterPane_defineProperty(this, "_shouldShowCondition", () => {
      const {
        showCondition,
        allowCondition
      } = this.props;

      if (showCondition !== undefined && showCondition !== null) {
        return showCondition; // legacy, takes precedence
      }

      return allowCondition;
    });

    NonNumericFilterPane_defineProperty(this, "_renderNonNumericFilterPane", () => {
      const {
        inverted,
        selectedValuesCount,
        totalValues,
        loading,
        onClick,
        onSearch,
        getValue,
        contentRenderer,
        allowSearch,
        showSearchInput,
        readOnly,
        hasMoreData,
        invertDisabled,
        isSearching,
        autoFocus
      } = this.props;
      const borderStyle = {
        borderColor: '#F2F2F2',
        borderWidth: '1px',
        borderStyle: 'solid'
      };
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        justifyContent: "space-between",
        fullHeight: true,
        direction: "column",
        "data-tid": "nonNumericFilterPane"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, this._shouldShowCondition() && this._renderCondition()), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: 1,
        style: borderStyle
      }, /*#__PURE__*/external_react_default.a.createElement(SelectValueFilterPane_SelectValueFilterPane, {
        totalValues: totalValues,
        selectedValuesCount: selectedValuesCount,
        loading: loading,
        allowSearch: allowSearch,
        showSearchInput: showSearchInput,
        onClick: onClick,
        onChange: this._onChange,
        onSearch: onSearch,
        isSearching: isSearching,
        getValue: getValue,
        contentRenderer: contentRenderer,
        border: "1px",
        "border-color": "gray",
        readOnly: readOnly,
        hasMoreData: hasMoreData,
        autoFocus: autoFocus
      })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: [2, 0, 0, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(FilterPreferences_FilterPreferences, {
        inverted: inverted,
        includeNulls: false,
        onChange: this._onPreferencesChanged,
        onClear: this.props.onClear,
        showIncludeNull: false,
        selectedValuesCount: selectedValuesCount,
        returnToTree: () => {},
        readOnly: readOnly || this.props.readOnlyPrefs,
        invertDisabled: invertDisabled
      })));
    });
  }

  _renderCondition() {
    const {
      isOpen
    } = this.state;
    const {
      condition,
      inverted,
      readOnly,
      conditionFlyoutContentContainerId,
      hasManualSelections
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: 0
    }, /*#__PURE__*/external_react_default.a.createElement(ConditionBuilder_ConditionBuilder, {
      condition: condition,
      onChange: this._onConditionChange,
      open: isOpen,
      inverted: inverted,
      toggleSlideout: this._toggleSlideout,
      readOnly: readOnly,
      conditionFlyoutContentContainerId: conditionFlyoutContentContainerId,
      hasManualSelections: hasManualSelections
    }));
  }

  render() {
    const {
      loading
    } = this.props;

    if (loading) {
      return /*#__PURE__*/external_react_default.a.createElement(FilterLoadingSpinner_FilterLoadingSpinner, null);
    }

    return this._renderNonNumericFilterPane();
  }

}

NonNumericFilterPane_defineProperty(NonNumericFilterPane_NonNumericFilterPane, "propTypes", {
  inverted: external_prop_types_default.a.bool,
  onChange: external_prop_types_default.a.func.isRequired,
  totalValues: external_prop_types_default.a.number.isRequired,
  selectedValuesCount: external_prop_types_default.a.number,
  loading: external_prop_types_default.a.bool,
  onClick: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func,
  onSearch: external_prop_types_default.a.func.isRequired,
  allowSearch: external_prop_types_default.a.bool,
  contentRenderer: external_prop_types_default.a.func,
  getValue: external_prop_types_default.a.func,
  showCondition: external_prop_types_default.a.bool,
  allowCondition: external_prop_types_default.a.bool,
  condition: external_prop_types_default.a.object,
  readOnly: external_prop_types_default.a.bool,
  showSearchInput: external_prop_types_default.a.bool,
  conditionFlyoutContentContainerId: external_prop_types_default.a.string,
  hasManualSelections: external_prop_types_default.a.bool,
  hasMoreData: external_prop_types_default.a.bool,
  readOnlyPrefs: external_prop_types_default.a.bool,
  invertDisabled: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool,
  autoFocus: external_prop_types_default.a.bool
});

NonNumericFilterPane_defineProperty(NonNumericFilterPane_NonNumericFilterPane, "defaultProps", {
  inverted: false,
  decimalPlaces: 5,
  selectedValuesCount: 0,
  loading: false,
  allowSearch: true,
  showSearchInput: true,
  showCondition: undefined,
  allowCondition: true,
  condition: null,
  readOnly: false,
  hasManualSelections: false,
  hasMoreData: false,
  invertDisabled: false
});
// EXTERNAL MODULE: ./src/filters/NonNumericFilter.scss
var filters_NonNumericFilter = __webpack_require__(89);

// CONCATENATED MODULE: ./src/filters/NonNumericFilter.tsx
function NonNumericFilter_extends() { NonNumericFilter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return NonNumericFilter_extends.apply(this, arguments); }

function NonNumericFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */









/*
This is a common filter component that allows a filter to be applied using a
slider control. There are also options to enter to/from filter values directly
via text boxes, invert the current selection and specify whether to include
blank values. The filter type can be to switched to a 'list' filter which allows the user
to select/deselectSVGIcon from a list of values.
*/

class NonNumericFilter_NonNumericFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    NonNumericFilter_defineProperty(this, "state", {
      isDirty: false,
      // these states are used to determine dirty
      // these values are set in _resetDirty()
      selectedValuesCount: undefined,
      inverted: undefined
    });

    NonNumericFilter_defineProperty(this, "getConditionFlyoutContentContainerId", () => {
      const id = this.props.conditionFlyoutContentContainerId;

      if (typeof id === 'undefined' || id === null || id === '') {
        return this._conditionFlyoutContentContainerId;
      }

      return id;
    });

    NonNumericFilter_defineProperty(this, "_conditionFlyoutContentContainerId", void 0);

    NonNumericFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false,
        selectedValuesCount: this.props.selectedValuesCount,
        inverted: this.props.inverted
      });
    });

    NonNumericFilter_defineProperty(this, "_onChange", result => {
      this.props.onChange(result);
    });

    NonNumericFilter_defineProperty(this, "_onApply", () => {
      this.props.onApply();

      this._resetDirty();
    });

    NonNumericFilter_defineProperty(this, "_onClear", () => {
      this.props.onClear();
    });

    NonNumericFilter_defineProperty(this, "_onClose", () => {
      this.props.onClose();
    });

    NonNumericFilter_defineProperty(this, "_onOk", () => {
      this._onApply();

      this.props.onDone();
    });

    NonNumericFilter_defineProperty(this, "_onCancel", () => {
      this.props.onClose();
    });
  }

  componentWillMount() {
    this._conditionFlyoutContentContainerId = Object(external_lodash_["uniqueId"])('filter-condition-');

    this._resetDirty();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isDirty: this.state.selectedValuesCount !== nextProps.selectedValuesCount || this.state.inverted !== nextProps.inverted
    });
  }

  render() {
    const {
      title,
      actionTitle,
      showCondition,
      loading,
      readOnly,
      allowSearch,
      allowCondition,
      hasMoreData,
      showToggle,
      showHeader,
      showCancel
    } = this.props;
    const showClose = true;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column",
      "data-tid": "nonNumericFilter",
      className: "bi-common-NonNumericFilter"
    }, showHeader && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [3, 3, 0, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      actionTitle: actionTitle,
      showSearch: false // always false, controls the icon
      ,
      showMenu: false,
      showClose: showClose,
      onClose: this._onClose,
      height: 16,
      readOnly: readOnly
    })), showToggle && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [3, 3, 0, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["ToggleSwitchSection"], {
      label: nls_StringResource.get('allMembers'),
      checked: this.props.isToggled,
      onChange: this.props.onToggleChange
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: 3
    }, /*#__PURE__*/external_react_default.a.createElement(NonNumericFilterPane_NonNumericFilterPane, NonNumericFilter_extends({}, this.props, {
      onChange: this._onChange,
      allowSearch: allowSearch,
      showCondition: showCondition,
      allowCondition: allowCondition,
      readOnly: readOnly,
      conditionFlyoutContentContainerId: this.getConditionFlyoutContentContainerId(),
      hasMoreData: hasMoreData,
      readOnlyPrefs: this.props.isToggled
    }))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(FilterFooter_FilterFooter, {
      loading: loading,
      readOnly: readOnly,
      onClear: this._onClear,
      onApply: this._onApply,
      onOk: this._onOk,
      onCancel: this._onCancel,
      showCancel: showCancel,
      dirty: (this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty) || this.props.isToggled
    }), ' '));
  }

}

NonNumericFilter_defineProperty(NonNumericFilter_NonNumericFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  actionTitle: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  onClose: external_prop_types_default.a.func.isRequired,
  onDone: external_prop_types_default.a.func.isRequired,
  showCondition: external_prop_types_default.a.bool,
  allowCondition: external_prop_types_default.a.bool,
  inverted: external_prop_types_default.a.bool,
  selectedValuesCount: external_prop_types_default.a.number,
  loading: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  conditionFlyoutContentContainerId: external_prop_types_default.a.string,
  hasMoreData: external_prop_types_default.a.bool,
  showToggle: external_prop_types_default.a.bool,
  onToggleChange: external_prop_types_default.a.func,
  isToggled: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  showHeader: external_prop_types_default.a.bool,
  showCancel: external_prop_types_default.a.bool,
  autoFocus: external_prop_types_default.a.bool
});

NonNumericFilter_defineProperty(NonNumericFilter_NonNumericFilter, "defaultProps", {
  filterSelectionType: nls_StringResource.get('range'),
  minimumValue: 0,
  maximumValue: 100,
  fromValue: 0,
  toValue: 0,
  includeNulls: false,
  inverted: false,
  decimalPlaces: 5,
  selectedValuesCount: 0,
  loading: false,
  showLabels: true,
  showCondition: undefined,
  readOnly: false,
  allowCondition: true,
  allowSearch: true,
  hasMoreData: false,
  showToggle: false,
  showHeader: true,
  showCancel: true
});
// CONCATENATED MODULE: ./src/filters/SelectHierarchyFilter.tsx
function SelectHierarchyFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-unused-state */

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */





const {
  expandEventTypes
} = ba_ui_carbon_toolkit_["listEventTypes"];

class SparseTreeItem {
  constructor(id, getNumberOfChildren, hasGetMoreLimit, getLimitChildren) {
    SelectHierarchyFilter_defineProperty(this, "_id", void 0);

    SelectHierarchyFilter_defineProperty(this, "_getNumberOfChildren", void 0);

    SelectHierarchyFilter_defineProperty(this, "_getLimitChildren", void 0);

    SelectHierarchyFilter_defineProperty(this, "_numberOfChildren", 0);

    SelectHierarchyFilter_defineProperty(this, "_hasGetMoreLimit", void 0);

    SelectHierarchyFilter_defineProperty(this, "_expanded", false);

    SelectHierarchyFilter_defineProperty(this, "_position", null);

    SelectHierarchyFilter_defineProperty(this, "parent", null);

    SelectHierarchyFilter_defineProperty(this, "children", []);

    this._id = id;
    this._getNumberOfChildren = getNumberOfChildren;
    this._getLimitChildren = getLimitChildren;
    this._numberOfChildren = 0;
    this._hasGetMoreLimit = hasGetMoreLimit;
    this._expanded = false;
    this._position = null;
    this.parent = null;
    this.children = [];
  }

  get id() {
    return this._id;
  }

  set numberOfChildren(numberOfChildren) {
    this._numberOfChildren = numberOfChildren;
  }

  get numberOfChildren() {
    const numberOfChildren = this._getNumberOfChildren(this._id);

    if (numberOfChildren > this._numberOfChildren) {
      this._numberOfChildren = numberOfChildren;
    }

    if (this._hasGetMoreLimit) {
      return Math.min(this._getLimitChildren(this._id) + 1, this._numberOfChildren);
    }

    return this._numberOfChildren;
  }

  get level() {
    return this.parent ? this.parent.level + 1 : 0;
  }

  set expanded(expanded) {
    this._expanded = expanded;
  }

  get expanded() {
    return this._expanded;
  }

  get position() {
    return this._position;
  }

  set position(pos) {
    this._position = pos;
  } // Check if the child @position should be "Load More";


  isGetMoreChildrenItem(position) {
    const limitChildren = this._getLimitChildren(this._id);

    if (limitChildren > 0 && this.numberOfChildren === limitChildren + 1) {
      return position === limitChildren;
    }

    return false;
  }

  get length() {
    let len = 1;

    if (this.expanded) {
      len += this.numberOfChildren;
      this.children.forEach(child => {
        len += child.length - 1;
      });
    }

    return len;
  }

  getDistanceToRoot() {
    if (this.parent === null) {
      return -1;
    }

    let distance = this._position + this.parent.getDistanceToRoot() + 1;

    for (let idx = this.parent.children.length - 1; idx >= 0; --idx) {
      const sibling = this.parent.children[idx]; // skip collapsed child.

      if (sibling.position < this._position && sibling.expanded !== false) {
        distance += sibling.length - 1;
      }
    }

    return distance;
  }

  getChild(position) {
    return this.children.find(ele => ele.position === position);
  }

  isChildExpanded(position) {
    const child = this.getChild(position);
    return child ? child.expanded : false;
  } // only expandable child would be added.


  addChild(position, id, hasChildren) {
    let child = null;

    if (hasChildren) {
      child = new SparseTreeItem(id, this._getNumberOfChildren, this._hasGetMoreLimit, this._getLimitChildren);
      child.parent = this;
      child.position = position;
      this.children = [...this.children, child].sort((a, b) => a.position - b.position).slice();
    }

    return child;
  } // only expandable child would be added.


  purgeChild(position) {
    const index = this.children.findIndex(x => x.position === position);

    if (index >= 0) {
      this.children.splice(index, 1);
    }
  }

  walking(distance) {
    // walking itself.
    let remainDistance = distance - 1;

    if (remainDistance === 0 || this.expanded === false) {
      return {
        remainDistance,
        item: this.parent,
        position: this._position
      };
    } // walking inside.


    let walkingStop = 0;
    let position = 0;

    for (let idx = 0; idx < this.children.length; ++idx) {
      const child = this.children[idx]; // skip collapsed child.

      if (child.expanded !== false) {
        // walking before child, not include child.
        if (remainDistance <= child.position - walkingStop) {
          position = walkingStop + remainDistance;
          position -= 1;
          return {
            remainDistance: 0,
            item: this,
            position
          };
        }

        remainDistance -= child.position - walkingStop;
        walkingStop = child.position; // walking child.

        const walked = child.walking(remainDistance);
        remainDistance = walked.remainDistance;

        if (remainDistance === 0) {
          return walked;
        }

        walkingStop = child.position + 1;
      }
    }

    position = Math.min(walkingStop + remainDistance, this.numberOfChildren) - 1;
    remainDistance -= position - walkingStop;
    remainDistance -= 1;
    return {
      remainDistance,
      item: this,
      position
    };
  }

}

class SparseTree {
  constructor(rootId, getNumberOfChildren, limitChildrenCnt, getLimitChildren) {
    SelectHierarchyFilter_defineProperty(this, "_limitChildrenCnt", void 0);

    SelectHierarchyFilter_defineProperty(this, "_root", void 0);

    if (getNumberOfChildren) {
      this._limitChildrenCnt = Math.max(limitChildrenCnt, 0);
      this._root = new SparseTreeItem(rootId, getNumberOfChildren, this._limitChildrenCnt > 0, getLimitChildren);
      this._root.expanded = true;
    } else {
      this._root = null;
    }
  }

  get length() {
    return this._root ? this._root.length - 1 : 0;
  }

  get limitChildrenCnt() {
    return this._limitChildrenCnt;
  }

  locate(index) {
    if (!this._root) {
      throw new Error('Internal error in SparseTree.locate(), no root.');
    }

    const location = this._root.walking(index + 2);

    if (location.remainDistance > 0) {
      throw new Error(`Internal error in SparseTree.locate(${index}`);
    }

    return location;
  }

  expandCollapse(index, type, id, hasChildren, onExpandCollapse) {
    const location = this.locate(index);
    let child = location.item.getChild(location.position);

    if (child) {
      if (child.id !== id) {
        throw new Error('Sparsetree data wrong.');
      }
    } else {
      child = location.item.addChild(location.position, id, hasChildren);
    } // ignore if it's not expandable


    if (!child) {
      return -1;
    }

    if (type === expandEventTypes.TOGGLE) {
      child.expanded = !child.expanded;
    } else if (type === expandEventTypes.EXPAND) {
      child.expanded = true;
    } else if (type === expandEventTypes.COLLAPSE) {
      child.expanded = false;
    }

    onExpandCollapse && onExpandCollapse(child.id, child.expanded);
    return this.length;
  }

}

class SelectHierarchyFilter_SelectHierarchyFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    SelectHierarchyFilter_defineProperty(this, "state", {
      length: 0
    });

    SelectHierarchyFilter_defineProperty(this, "getFromMap", index => this._itemMap.get(index));

    SelectHierarchyFilter_defineProperty(this, "_sparseTree", null);

    SelectHierarchyFilter_defineProperty(this, "_list", void 0);

    SelectHierarchyFilter_defineProperty(this, "_itemMap", new Map());

    SelectHierarchyFilter_defineProperty(this, "_refList", list => {
      this._list = list;
    });

    SelectHierarchyFilter_defineProperty(this, "_contentRenderer", value => {
      const {
        contentRenderer,
        readOnly
      } = this.props;

      if (contentRenderer) {
        return contentRenderer(value);
      }

      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        direction: "row"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], null, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: [0, 1, 0, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Checkbox"], {
        checked: value.selected,
        indeterminate: !value.selected && value.descendantsSelected,
        readOnly: readOnly,
        visual: true
      })))), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true,
        alignSelf: "center"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["TruncatedText"], {
        value: value.caption ? value.caption : value.id
      })));
    });

    SelectHierarchyFilter_defineProperty(this, "_getMoreRenderer", () => /*#__PURE__*/external_react_default.a.createElement("span", null, nls_StringResource.get('loadMore')));

    SelectHierarchyFilter_defineProperty(this, "_isExpanded", index => {
      const location = this._sparseTree.locate(index);

      return location.item.isChildExpanded(location.position);
    });

    SelectHierarchyFilter_defineProperty(this, "_itemRenderer", (index, props) => {
      const location = this._sparseTree.locate(index);

      const {
        getTreeItemProps,
        getValue,
        TreeItemToUse
      } = this.props;
      const parentId = location.item.id;
      const {
        position
      } = location;
      const isGetMoreChildrenItem = location.item.isGetMoreChildrenItem(location.position);
      const value = isGetMoreChildrenItem ? {
        parentId,
        position,
        isGetMoreChildrenItem
      } : getValue(parentId, position);
      const depth = location.item.level;
      const {
        hasChildren
      } = value;
      const pathToRoot = '';
      const ariaSelected = value && value.selected;

      this._itemMap.set(index, { ...value,
        depth
      }); // in some case, parent control( i.e. mosejs ) do not know if node has children, always set hasChildren as true at beginning,
      // once user expand the node, eventually getNumberOfChildren() will be called, a node might be confirmed as leaf node,
      // if a node hasChildren changed to false, need to remove it from sparse tree.


      if (!hasChildren) {
        location.item.purgeChild(location.position);
      }

      const treeProps = getTreeItemProps({ ...props,
        depth,
        hasChildren,
        pathToRoot,
        index,
        ariaSelected
      });
      let children;

      if (isGetMoreChildrenItem === true) {
        children = this._getMoreRenderer();
      } else {
        children = this._contentRenderer(this._itemMap.get(index));
      }

      let element;

      if (Array.isArray(children)) {
        // supress react's key warning: https://github.com/facebook/react/issues/
        element = external_react_default.a.createElement(TreeItemToUse, treeProps, ...children);
      } else {
        element = external_react_default.a.createElement(TreeItemToUse, treeProps, children);
      }

      return element;
    });

    SelectHierarchyFilter_defineProperty(this, "_onExpandCollapse", event => {
      const {
        index,
        type
      } = event;

      if (index >= 0) {
        const {
          id,
          hasChildren
        } = this._itemMap.get(index);

        const length = this._sparseTree.expandCollapse(index, type, id, hasChildren, this.props.onExpandCollapse);

        length && this.setState({
          length
        });
      }
    });

    SelectHierarchyFilter_defineProperty(this, "_onClick", event => {
      const {
        index
      } = event;
      const {
        onClick,
        readOnly,
        onLoadMore
      } = this.props;

      if (readOnly) {
        return;
      }

      const location = this._sparseTree.locate(index);

      if (location.item.isGetMoreChildrenItem(location.position)) {
        const loadMoreItem = this._itemMap.get(index);

        loadMoreItem && onLoadMore && onLoadMore(loadMoreItem.parentId, loadMoreItem.position);
      } else if (this._itemMap.has(index)) {
        onClick && onClick(Object(external_lodash_["omit"])(this._itemMap.get(index), ['depth', 'hasChildren']));
      } else {
        throw new Error('onClick data is missing...');
      }
    });

    SelectHierarchyFilter_defineProperty(this, "_getParentIndex", index => {
      const location = this._sparseTree.locate(index);

      if (location) {
        return location.item.getDistanceToRoot();
      }

      return -1;
    });
  }

  componentDidMount() {
    this.initSpareTree();
  }

  componentWillUpdate() {
    // always re-fetch data value from parent control.
    this._itemMap = new Map();
  } // utility function used for dragDrop


  initSpareTree() {
    const {
      limitChildrenCnt,
      getValue,
      getNumberOfChildren,
      getLimitChildren
    } = this.props;

    if (getValue) {
      const root = getValue(null);

      if (root.hasChildren) {
        this._sparseTree = new SparseTree(root.id, getNumberOfChildren, limitChildrenCnt, getLimitChildren);
        const {
          length
        } = this._sparseTree;
        this.setState({
          length
        });
      }
    }
  }

  render() {
    const {
      virtualized,
      ariaMultiselectable
    } = this.props;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["List"], {
      ref: this._refList,
      length: this._sparseTree ? this._sparseTree.length : 0,
      virtualized: virtualized,
      fullHeight: true,
      itemRenderer: this._itemRenderer,
      getParentIndex: this._getParentIndex,
      selectionMode: this.props.selectionMode,
      listType: "uniform",
      onExpand: this._onExpandCollapse,
      role: "tree",
      isExpanded: this._isExpanded,
      onSelectionChange: this._onClick,
      getKey: v => v,
      hierarchical: true,
      ariaMultiselectable: !!ariaMultiselectable
    });
  }

}

SelectHierarchyFilter_defineProperty(SelectHierarchyFilter_SelectHierarchyFilter, "propTypes", {
  getValue: external_prop_types_default.a.func.isRequired,
  getNumberOfChildren: external_prop_types_default.a.func.isRequired,
  getLimitChildren: external_prop_types_default.a.func,
  onExpandCollapse: external_prop_types_default.a.func,
  onClick: external_prop_types_default.a.func.isRequired,
  onLoadMore: external_prop_types_default.a.func,
  contentRenderer: external_prop_types_default.a.func,
  limitChildrenCnt: external_prop_types_default.a.number,
  TreeItemToUse: external_prop_types_default.a.func,
  getTreeItemProps: external_prop_types_default.a.func,
  selectionMode: external_prop_types_default.a.oneOf(['none', 'single']).isRequired,
  readOnly: external_prop_types_default.a.bool,
  ariaMultiselectable: external_prop_types_default.a.bool,
  virtualized: external_prop_types_default.a.bool
});

SelectHierarchyFilter_defineProperty(SelectHierarchyFilter_SelectHierarchyFilter, "defaultProps", {
  TreeItemToUse: ba_ui_carbon_toolkit_["TreeItem"],
  getTreeItemProps: x => x,
  virtualized: true
});
// CONCATENATED MODULE: ./src/filters/HierarchyFilterPane.tsx
function HierarchyFilterPane_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */









/*
This is a common filter component that show hierarchy filter either in tree shape or flat list.
*/

class HierarchyFilterPane_HierarchyFilterPane extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    HierarchyFilterPane_defineProperty(this, "state", {
      searchText: '',
      limitChildren: this.props.limitChildren,
      showTree: true,
      inverted: false,
      listInverted: false
    });

    HierarchyFilterPane_defineProperty(this, "_tree", void 0);

    HierarchyFilterPane_defineProperty(this, "_onSearchTextChange", result => {
      const searchText = result;
      const {
        onSearch
      } = this.props;

      if (searchText !== this.state.searchText) {
        onSearch && onSearch(searchText);
        let {
          showTree
        } = this.state;

        if (this.state.showTree && searchText !== '') {
          showTree = false;
        }

        this.setState({
          searchText,
          showTree
        });
      }
    });

    HierarchyFilterPane_defineProperty(this, "_onPreferencesChanged", preferences => {
      const {
        onInvert,
        listOnInvert
      } = this.props;
      const inverted = !!preferences.inverted;

      if (this.state.showTree && inverted !== this.state.inverted) {
        this.setState({
          inverted
        });
        onInvert && onInvert();
      }

      const listInverted = !!preferences.inverted;

      if (!this.state.showTree && listInverted !== this.state.listInverted) {
        this.setState({
          listInverted
        });

        if (listOnInvert) {
          listOnInvert();
        } else if (onInvert) {
          onInvert();
        }
      }
    });

    HierarchyFilterPane_defineProperty(this, "_refTree", tree => {
      this._tree = tree;
    });

    HierarchyFilterPane_defineProperty(this, "_resetTree", () => {
      this._tree && this._tree.initSpareTree();
    });

    HierarchyFilterPane_defineProperty(this, "returnToTree", () => {
      const {
        onDoneSearch
      } = this.props;
      const searchText = '';
      const showTree = true;
      this.setState({
        searchText,
        showTree
      });

      if (this.props.onDoneSearch) {
        onDoneSearch();
      }
    });

    HierarchyFilterPane_defineProperty(this, "_renderHierarchy", () => {
      const {
        showSearch,
        allowSearch,
        getValue,
        getNumberOfChildren,
        getLimitChildren,
        onExpandCollapse,
        onClick,
        onLoadMore,
        limitChildren,
        contentRenderer,
        readOnly,
        listOnClick,
        listGetValue,
        listGetNumberOfChildren,
        listContentRenderer,
        isSearching
      } = this.props;

      if (limitChildren !== this.state.limitChildren) {
        this.setState({
          limitChildren
        }, this._resetTree);
      }

      const listGetNumberOfChildrenFn = listGetNumberOfChildren || getNumberOfChildren;
      const totalValues = this.state.showTree ? 0 : listGetNumberOfChildrenFn();
      const borderStyle = {
        'border-color': '#F2F2F2',
        'border-width': '1px',
        'border-style': 'solid'
      };
      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        justifyContent: "space-between",
        fullHeight: true,
        direction: "column",
        style: borderStyle
      }, allowSearch === true && showSearch === true && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: 0
      }, /*#__PURE__*/external_react_default.a.createElement(FilterSearchInput_FilterSearchInput, {
        fullWidth: true,
        placeholder: nls_StringResource.get('search'),
        value: this.state.searchText,
        onChange: this._onSearchTextChange,
        readOnly: readOnly
      })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true
      }, this.state.showTree ? /*#__PURE__*/external_react_default.a.createElement(SelectHierarchyFilter_SelectHierarchyFilter, {
        getValue: getValue,
        getNumberOfChildren: getNumberOfChildren,
        getLimitChildren: getLimitChildren,
        onExpandCollapse: onExpandCollapse,
        onClick: onClick,
        onLoadMore: onLoadMore,
        ref: this._refTree,
        limitChildrenCnt: limitChildren,
        contentRenderer: contentRenderer,
        selectionMode: "single",
        readOnly: readOnly,
        ariaMultiselectable: true
      }) : /*#__PURE__*/external_react_default.a.createElement(FilterList_FilterList, {
        totalValues: totalValues,
        onClick: listOnClick || onClick,
        getValue: listGetValue || getValue,
        listGetNumberOfChildren: listGetNumberOfChildren || getNumberOfChildren,
        contentRenderer: listContentRenderer || contentRenderer,
        showPath: this.props.showSubcaption,
        readOnly: readOnly,
        isSearching: isSearching
      })));
    });

    HierarchyFilterPane_defineProperty(this, "_renderHierarchyFilterPane", () => {
      const {
        showFilterPreferences,
        limitChildren,
        selectedValuesCount,
        readOnly
      } = this.props;

      if (limitChildren !== this.state.limitChildren) {
        this.setState({
          limitChildren
        }, this._resetTree);
      }

      return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
        justifyContent: "space-between",
        fullHeight: true,
        direction: "column"
      }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        grow: true
      }, this._renderHierarchy()), showFilterPreferences && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
        gutter: [2, 0, 0, 0]
      }, /*#__PURE__*/external_react_default.a.createElement(FilterPreferences_FilterPreferences, {
        showInvertSelected: false,
        inverted: this.state.showTree ? this.state.inverted : this.state.listInverted,
        includeNulls: false,
        onChange: this._onPreferencesChanged,
        onClear: this.props.onClear,
        showIncludeNull: false,
        selectedValuesCount: selectedValuesCount,
        showReturnToTree: !this.state.showTree,
        returnToTree: this.returnToTree,
        readOnly: readOnly,
        invertDisabled: this.props.invertDisabled
      })));
    });
  }

  render() {
    const {
      loading
    } = this.props;

    if (loading) {
      return /*#__PURE__*/external_react_default.a.createElement(FilterLoadingSpinner_FilterLoadingSpinner, null);
    }

    return this._renderHierarchyFilterPane();
  }

}

HierarchyFilterPane_defineProperty(HierarchyFilterPane_HierarchyFilterPane, "propTypes", {
  onDoneSearch: external_prop_types_default.a.func,
  loading: external_prop_types_default.a.bool,
  // searchBox.HierarchyFilter
  showSearch: external_prop_types_default.a.bool.isRequired,
  allowSearch: external_prop_types_default.a.bool,
  onSearch: external_prop_types_default.a.func.isRequired,
  showFilterPreferences: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool,
  // Tree props.
  getValue: external_prop_types_default.a.func.isRequired,
  getNumberOfChildren: external_prop_types_default.a.func.isRequired,
  getLimitChildren: external_prop_types_default.a.func,
  onExpandCollapse: external_prop_types_default.a.func.isRequired,
  onClick: external_prop_types_default.a.func.isRequired,
  onLoadMore: external_prop_types_default.a.func,
  onClear: external_prop_types_default.a.func,
  contentRenderer: external_prop_types_default.a.func,
  limitChildren: external_prop_types_default.a.number,
  onInvert: external_prop_types_default.a.func.isRequired,
  selectedValuesCount: external_prop_types_default.a.number,
  // List props.
  listOnClick: external_prop_types_default.a.func,
  listGetValue: external_prop_types_default.a.func,
  listGetNumberOfChildren: external_prop_types_default.a.func,
  listContentRenderer: external_prop_types_default.a.func,
  listOnInvert: external_prop_types_default.a.func,
  showSubcaption: external_prop_types_default.a.bool,
  readOnly: external_prop_types_default.a.bool,
  invertDisabled: external_prop_types_default.a.bool
});

HierarchyFilterPane_defineProperty(HierarchyFilterPane_HierarchyFilterPane, "defaultProps", {
  showFilterPreferences: true,
  limitChildren: 0,
  selectedValuesCount: 0,
  showSubcaption: true,
  loading: false,
  readOnly: false,
  allowSearch: true,
  invertDisabled: false,
  isSearching: false
});
// CONCATENATED MODULE: ./src/filters/CompactHierarchyFilter.tsx
function CompactHierarchyFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








class CompactHierarchyFilter_CompactHierarchyFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    CompactHierarchyFilter_defineProperty(this, "state", {
      showSearch: false,
      showTree: true,
      isDirty: false // these states are used to determine dirty
      // these values are set in _resetDirty()

    });

    CompactHierarchyFilter_defineProperty(this, "_pane", void 0);

    CompactHierarchyFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false
      });
    });

    CompactHierarchyFilter_defineProperty(this, "_toggleSearch", () => {
      this.setState(prevState => ({
        showSearch: !prevState.showSearch
      }));
    });

    CompactHierarchyFilter_defineProperty(this, "_onSearch", searchText => {
      const {
        onSearch
      } = this.props;
      let {
        showTree
      } = this.state;

      if (this.state.showTree && searchText !== '') {
        showTree = false;
      }

      this.setState({
        showTree
      });
      onSearch && onSearch(searchText);
    });

    CompactHierarchyFilter_defineProperty(this, "_onDoneSearch", () => {
      const {
        onDoneSearch
      } = this.props;
      this.setState({
        showTree: true
      });
      onDoneSearch && onDoneSearch();
    });

    CompactHierarchyFilter_defineProperty(this, "_onReturnToTree", () => {
      this._pane && this._pane.returnToTree();
    });

    CompactHierarchyFilter_defineProperty(this, "_onInvert", () => {
      const {
        onInvert,
        listOnInvert
      } = this.props;

      if (!this.state.showTree && listOnInvert) {
        listOnInvert();
      } else {
        onInvert && onInvert();
      }

      this.forceUpdate();
    });

    CompactHierarchyFilter_defineProperty(this, "_onClear", () => {
      const {
        onClear
      } = this.props;

      if (onClear) {
        onClear();
        this.forceUpdate();
      }
    });

    CompactHierarchyFilter_defineProperty(this, "_getContextMenu", () => {
      const menu = []; // rtc 190502, hide invert for now.
      // menu.push({ label: stringResource.get('invert'), fn: this._onInvert });

      menu.push({
        label: nls_StringResource.get('clearAll'),
        fn: this._onClear
      });

      if (!this.state.showTree) {
        menu.push({
          label: nls_StringResource.get('returnToTree'),
          fn: this._onReturnToTree
        });
      }

      return menu;
    });

    CompactHierarchyFilter_defineProperty(this, "_onApply", () => {
      const {
        onApply
      } = this.props;
      onApply && onApply();

      this._resetDirty();
    });
  }

  componentWillMount() {
    this._resetDirty();
  }

  componentWillReceiveProps() {
    // We have received some props so mark the isDirty flag to true, note this is
    // not called during the initial render
    if (!this.state.isDirty) {
      this.setState({
        isDirty: true
      });
    }
  }

  render() {
    const {
      title,
      menuTitle,
      onMenu,
      getValue,
      getNumberOfChildren,
      getLimitChildren,
      onExpandCollapse,
      onClick,
      onLoadMore,
      limitChildren,
      contentRenderer,
      onInvert,
      selectedValuesCount,
      listOnClick,
      listGetValue,
      listGetNumberOfChildren,
      listContentRenderer,
      listOnInvert,
      showSubcaption,
      loading,
      readOnly,
      allowSearch
    } = this.props;
    const borderStyle = {
      'border-color': '#F2F2F2',
      'border-width': '1px',
      'border-style': 'solid'
    };
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column"
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: [2, 2, 0, 2],
      className: "bi-filter-compact-filter-title"
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      menuTitle: menuTitle,
      onSearch: this._toggleSearch,
      showSearch: allowSearch,
      onMenu: onMenu,
      menu: this._getContextMenu(),
      loading: loading,
      height: 40,
      readOnly: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: [1, 2, 2, 2],
      style: borderStyle
    }, /*#__PURE__*/external_react_default.a.createElement(HierarchyFilterPane_HierarchyFilterPane, {
      ref: pane => {
        this._pane = pane;
      },
      showSearch: this.state.showSearch,
      allowSearch: allowSearch,
      onSearch: this._onSearch,
      onDoneSearch: this._onDoneSearch,
      showFilterPreferences: false // tree
      ,
      getValue: getValue,
      getNumberOfChildren: getNumberOfChildren,
      getLimitChildren: getLimitChildren,
      onExpandCollapse: onExpandCollapse,
      onClick: onClick,
      onLoadMore: onLoadMore,
      contentRenderer: contentRenderer,
      limitChildren: limitChildren,
      onInvert: onInvert,
      selectedValuesCount: selectedValuesCount // list
      ,
      listOnClick: listOnClick,
      listGetValue: listGetValue,
      listGetNumberOfChildren: listGetNumberOfChildren,
      listOnInvert: listOnInvert,
      listContentRenderer: listContentRenderer,
      showSubcaption: showSubcaption,
      loading: loading,
      readOnly: readOnly
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      textAlign: "center"
    }, /*#__PURE__*/external_react_default.a.createElement(ApplyButton_ApplyButton, {
      dirty: this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty,
      onApply: this._onApply,
      loading: loading,
      readOnly: readOnly
    })));
  }

}

CompactHierarchyFilter_defineProperty(CompactHierarchyFilter_CompactHierarchyFilter, "propTypes", {
  title: external_prop_types_default.a.string.isRequired,
  menuTitle: external_prop_types_default.a.string,
  onMenu: external_prop_types_default.a.func,
  onSearch: external_prop_types_default.a.func.isRequired,
  onDoneSearch: external_prop_types_default.a.func,
  onApply: external_prop_types_default.a.func.isRequired,
  onClear: external_prop_types_default.a.func,
  loading: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  ...COMMON_FILTER_PROPS
});

CompactHierarchyFilter_defineProperty(CompactHierarchyFilter_CompactHierarchyFilter, "defaultProps", {
  allowSearch: true
});
// CONCATENATED MODULE: ./src/filters/HierarchyFilter.tsx
function HierarchyFilter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */








class HierarchyFilter_HierarchyFilter extends external_react_["Component"] {
  constructor(...args) {
    super(...args);

    HierarchyFilter_defineProperty(this, "state", {
      showSearchInput: true,
      isDirty: false // these states are used to determine dirty
      // these values are set in _resetDirty()

    });

    HierarchyFilter_defineProperty(this, "_resetDirty", () => {
      this.setState({
        isDirty: false
      });
    });

    HierarchyFilter_defineProperty(this, "_onSearchClick", () => {
      this.setState(prevState => ({
        showSearchInput: !prevState.showSearchInput
      }));
    });

    HierarchyFilter_defineProperty(this, "_onApply", () => {
      this.props.onApply();

      this._resetDirty();
    });

    HierarchyFilter_defineProperty(this, "_onClear", () => {
      this.props.onClear();
    });

    HierarchyFilter_defineProperty(this, "_onOk", () => {
      this._onApply();

      this.props.onDone();
    });

    HierarchyFilter_defineProperty(this, "_onCancel", () => {
      this.props.onClose();
    });
  }

  componentWillMount() {
    this._resetDirty();
  }

  componentWillReceiveProps() {
    // We have received some props so mark the dirty flag to true, note this is
    // not called during the initial render
    if (!this.state.isDirty) {
      this.setState({
        isDirty: true
      });
    }
  }

  render() {
    const {
      title,
      actionTitle,
      subTitle,
      onClose,
      onSearch,
      onDoneSearch,
      getValue,
      getNumberOfChildren,
      getLimitChildren,
      onExpandCollapse,
      onClick,
      onLoadMore,
      limitChildren,
      contentRenderer,
      onInvert,
      selectedValuesCount,
      listOnClick,
      listGetValue,
      listGetNumberOfChildren,
      listContentRenderer,
      listOnInvert,
      showSubcaption,
      loading,
      readOnly,
      allowSearch,
      isSearching,
      showHeader,
      showCancel
    } = this.props;
    const {
      showSearchInput
    } = this.state;
    return /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexLayout"], {
      fullHeight: true,
      direction: "column",
      "data-tid": "hierarchyFilter"
    }, showHeader && /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      gutter: 3
    }, /*#__PURE__*/external_react_default.a.createElement(FilterHeader_FilterHeader, {
      title: title,
      actionTitle: actionTitle,
      showSearch: false // always false, this controls the icon
      ,
      onSearch: this._onSearchClick,
      showMenu: false,
      showClose: true,
      onClose: onClose,
      loading: loading,
      height: 16
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      margin: [1, 3, 0, 3]
    }, /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["Label"], {
      label: subTitle
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], {
      grow: true,
      margin: 3
    }, /*#__PURE__*/external_react_default.a.createElement(HierarchyFilterPane_HierarchyFilterPane, {
      showSearch: showSearchInput,
      allowSearch: allowSearch,
      onSearch: onSearch,
      onDoneSearch: onDoneSearch,
      loading: loading,
      isSearching: isSearching // tree
      ,
      getValue: getValue,
      getNumberOfChildren: getNumberOfChildren,
      getLimitChildren: getLimitChildren,
      onExpandCollapse: onExpandCollapse,
      onClick: onClick,
      onLoadMore: onLoadMore,
      contentRenderer: contentRenderer,
      limitChildren: limitChildren,
      onInvert: onInvert,
      selectedValuesCount: selectedValuesCount // list
      ,
      listOnClick: listOnClick,
      listGetValue: listGetValue,
      listGetNumberOfChildren: listGetNumberOfChildren,
      listOnInvert: listOnInvert,
      listContentRenderer: listContentRenderer,
      showSubcaption: showSubcaption,
      readOnly: readOnly,
      onClear: this._onClear
    })), /*#__PURE__*/external_react_default.a.createElement(ba_ui_carbon_toolkit_["FlexItem"], null, /*#__PURE__*/external_react_default.a.createElement(FilterFooter_FilterFooter, {
      loading: loading,
      readOnly: readOnly,
      onClear: this._onClear,
      onApply: this._onApply,
      onOk: this._onOk,
      onCancel: this._onCancel,
      showCancel: showCancel,
      dirty: this.props.isDirty === true || this.props.isDirty === false ? this.props.isDirty : this.state.isDirty
    })));
  }

}

HierarchyFilter_defineProperty(HierarchyFilter_HierarchyFilter, "propTypes", {
  title: external_prop_types_default.a.string,
  actionTitle: external_prop_types_default.a.string,
  subTitle: external_prop_types_default.a.string,
  onClose: external_prop_types_default.a.func.isRequired,
  onSearch: external_prop_types_default.a.func.isRequired,
  onDoneSearch: external_prop_types_default.a.func,
  onClear: external_prop_types_default.a.func.isRequired,
  onApply: external_prop_types_default.a.func.isRequired,
  onDone: external_prop_types_default.a.func.isRequired,
  loading: external_prop_types_default.a.bool,
  allowSearch: external_prop_types_default.a.bool,
  isDirty: external_prop_types_default.a.bool,
  isSearching: external_prop_types_default.a.bool,
  showHeader: external_prop_types_default.a.bool,
  showCancel: external_prop_types_default.a.bool,
  ...COMMON_FILTER_PROPS
});

HierarchyFilter_defineProperty(HierarchyFilter_HierarchyFilter, "defaultProps", {
  title: '',
  subTitle: nls_StringResource.get('useCheckboxes'),
  loading: false,
  readOnly: false,
  isSearching: false,
  showHeader: true,
  showCancel: true
});
// CONCATENATED MODULE: ./src/filters/SelectHierarchyFilterDnD.tsx
function SelectHierarchyFilterDnD_extends() { SelectHierarchyFilterDnD_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SelectHierarchyFilterDnD_extends.apply(this, arguments); }

function SelectHierarchyFilterDnD_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */




/* harmony default export */ var filters_SelectHierarchyFilterDnD = (function (SelectHierarchyFilterType, itemType = 'ITEM_TYPE', TreeDragLayer = ba_ui_carbon_toolkit_["DragLayer"]) {
  var _class, _temp;

  const TreeItemDnD = Object(ba_ui_carbon_toolkit_["itemDnD"])(ba_ui_carbon_toolkit_["TreeItem"], {
    dragItemType: itemType
  });
  return _temp = _class = class SelectHierarchyFilterDnD extends external_react_["Component"] {
    constructor(...args) {
      super(...args);

      SelectHierarchyFilterDnD_defineProperty(this, "tree", void 0);

      SelectHierarchyFilterDnD_defineProperty(this, "_dragLayerRenderer", ({
        itemProps,
        currentOffset,
        droppable
      }) => {
        const dragLayerRenderFn = this.props.dragLayerRenderer;
        return /*#__PURE__*/external_react_default.a.createElement(TreeDragLayer, {
          currentOffset: currentOffset,
          droppable: droppable
        }, dragLayerRenderFn(itemProps));
      });

      SelectHierarchyFilterDnD_defineProperty(this, "_getTreeItemProps", treeProps => ( //		const { canDrop, onDrop } = this.props;
      //		const { draggingNodes } = this.state;
      //		const itemDragging = draggingNodes.indexOf(node) >= 0;
      { //			...getTreeItemProps(treeProps, node),
        //			dragging: itemDragging,
        // canDrop,
        // onDrop,
        ...treeProps,
        canDragNode: this._canDragNode,
        onBeginDrag: this._onBeginDrag,
        onEndDrag: this._onEndDrag
      }));

      SelectHierarchyFilterDnD_defineProperty(this, "_canDragNode", itemProps => {
        const {
          index
        } = itemProps;
        const {
          canDragNode
        } = this.props; // get the payload from the tree

        const value = this.tree.getFromMap(index); // override default canDrag processing

        if (canDragNode) {
          return canDragNode(value);
        } // default canDrag processing just looks for isGetModeChildren property


        if (Object.prototype.hasOwnProperty.call(value, 'isGetMoreChildrenItem')) {
          return !value.isGetMoreChildrenItem;
        }

        return true;
      });

      SelectHierarchyFilterDnD_defineProperty(this, "_onBeginDrag", itemProps => {
        const {
          index
        } = itemProps; // get the payload from the tree

        const value = this.tree.getFromMap(index);
        const payload = {
          value,
          dragLayerRenderer: this._dragLayerRenderer
        };
        let newPayload;

        if (this.props.onBeginDrag) {
          newPayload = this.props.onBeginDrag(payload);
        } // this.setState({ draggingNodes: selected });


        return newPayload == null ? payload : newPayload;
      });

      SelectHierarchyFilterDnD_defineProperty(this, "_onEndDrag", () => {
        setTimeout(() => {
          // 	this.setState({ draggingNodes: [] });
          this.props.onEndDrag && this.props.onEndDrag();
        }, 0);
      });

      SelectHierarchyFilterDnD_defineProperty(this, "_connectToDnD", ref => {
        this.tree = ref;
      });

      SelectHierarchyFilterDnD_defineProperty(this, "initSpareTree", () => {
        this.tree.initSpareTree();
      });
    }

    render() {
      const passThroughProps = Object(external_lodash_["omit"])(this.props, 'dragLayerRenderer', 'onBeginDrag', 'canDragNode', 'onEndDrag');
      return /*#__PURE__*/external_react_default.a.createElement(SelectHierarchyFilterType, SelectHierarchyFilterDnD_extends({
        TreeItemToUse: TreeItemDnD
      }, passThroughProps, {
        getTreeItemProps: this._getTreeItemProps,
        ref: this._connectToDnD
      }));
    }

  }, SelectHierarchyFilterDnD_defineProperty(_class, "propTypes", {
    dragLayerRenderer: external_prop_types_default.a.func,
    //			isActive: PropTypes.bool,
    onEndDrag: external_prop_types_default.a.func,
    onBeginDrag: external_prop_types_default.a.func,
    canDragNode: external_prop_types_default.a.func
  }), _temp;
});
// CONCATENATED MODULE: ./src/filters/index.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initGlassContext", function() { return initGlassContext; });
/* concated harmony reexport CompactDateTimeFilter */__webpack_require__.d(__webpack_exports__, "CompactDateTimeFilter", function() { return CompactDateTimeFilter_CompactDateTimeFilter; });
/* concated harmony reexport FullDateTimeFilter */__webpack_require__.d(__webpack_exports__, "FullDateTimeFilter", function() { return FullDateTimeFilter_FullDateTimeFilter; });
/* concated harmony reexport DateTimeFilterPane */__webpack_require__.d(__webpack_exports__, "DateTimeFilterPane", function() { return DateTimeFilterPane_DateTimeFilterPane; });
/* concated harmony reexport CompactNumericFilter */__webpack_require__.d(__webpack_exports__, "CompactNumericFilter", function() { return CompactNumericFilter_CompactNumericFilter; });
/* concated harmony reexport NumericFilter */__webpack_require__.d(__webpack_exports__, "NumericFilter", function() { return NumericFilter_NumericFilter; });
/* concated harmony reexport NumericFilterPane */__webpack_require__.d(__webpack_exports__, "NumericFilterPane", function() { return NumericFilterPane_NumericFilterPane; });
/* concated harmony reexport CompactNonNumericFilter */__webpack_require__.d(__webpack_exports__, "CompactNonNumericFilter", function() { return CompactNonNumericFilter_CompactNonNumericFilter; });
/* concated harmony reexport NonNumericFilter */__webpack_require__.d(__webpack_exports__, "NonNumericFilter", function() { return NonNumericFilter_NonNumericFilter; });
/* concated harmony reexport NonNumericFilterPane */__webpack_require__.d(__webpack_exports__, "NonNumericFilterPane", function() { return NonNumericFilterPane_NonNumericFilterPane; });
/* concated harmony reexport CompactHierarchyFilter */__webpack_require__.d(__webpack_exports__, "CompactHierarchyFilter", function() { return CompactHierarchyFilter_CompactHierarchyFilter; });
/* concated harmony reexport HierarchyFilter */__webpack_require__.d(__webpack_exports__, "HierarchyFilter", function() { return HierarchyFilter_HierarchyFilter; });
/* concated harmony reexport HierarchyFilterPane */__webpack_require__.d(__webpack_exports__, "HierarchyFilterPane", function() { return HierarchyFilterPane_HierarchyFilterPane; });
/* concated harmony reexport SelectHierarchyFilter */__webpack_require__.d(__webpack_exports__, "SelectHierarchyFilter", function() { return SelectHierarchyFilter_SelectHierarchyFilter; });
/* concated harmony reexport selectHierarchyFilterDnD */__webpack_require__.d(__webpack_exports__, "selectHierarchyFilterDnD", function() { return filters_SelectHierarchyFilterDnD; });
/* concated harmony reexport FilterList */__webpack_require__.d(__webpack_exports__, "FilterList", function() { return FilterList_FilterList; });
/* concated harmony reexport FilterListItem */__webpack_require__.d(__webpack_exports__, "FilterListItem", function() { return FilterListItem_FilterListItem; });
/* concated harmony reexport glassContext */__webpack_require__.d(__webpack_exports__, "glassContext", function() { return external_context_; });
/* concated harmony reexport filterProps */__webpack_require__.d(__webpack_exports__, "filterProps", function() { return filterProps_namespaceObject; });
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


















const {
  initGlassContext
} = external_context_;


/***/ })
/******/ ]);
});